function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n12 = 0, F = function F() {}; return { s: F, n: function n() { return _n12 >= r.length ? { done: !0 } : { done: !1, value: r[_n12++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (_n, T) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == "object" && typeof module != "undefined" ? module.exports = T() : typeof define == "function" && define.amd ? define(T) : (_n = typeof globalThis != "undefined" ? globalThis : _n || self, _n.app = T());
})(this, function () {
  "use strict";

  var _n = window.customElements.define.bind(window.customElements);
  window.customElements.define = function (n) {
    for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      e[_key - 1] = arguments[_key];
    }
    if (!customElements.get(n)) return _n.apply(void 0, [n].concat(e));
  };
  function T() {}
  function ue(n, e) {
    for (var t in e) n[t] = e[t];
    return n;
  }
  function Ka(n) {
    return n && _typeof(n) == "object" && typeof n.then == "function";
  }
  function ni(n) {
    return n();
  }
  function Ti() {
    return Object.create(null);
  }
  function ot(n) {
    n.forEach(ni);
  }
  function ii(n) {
    return typeof n == "function";
  }
  function Ye(n, e) {
    return n != n ? e == e : n !== e || n && _typeof(n) == "object" || typeof n == "function";
  }
  var In;
  function Ai(n, e) {
    return In || (In = document.createElement("a")), In.href = e, n === In.href;
  }
  function Qa(n, e) {
    return n != n ? e == e : n !== e;
  }
  function Oi(n) {
    return Object.keys(n).length === 0;
  }
  function Si(n) {
    if (n == null) return T;
    for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      e[_key2 - 1] = arguments[_key2];
    }
    var t = n.subscribe.apply(n, e);
    return t.unsubscribe ? function () {
      return t.unsubscribe();
    } : t;
  }
  function hn(n, e, t) {
    n.$$.on_destroy.push(Si(e, t));
  }
  function Se(n) {
    var e = {};
    for (var t in n) t[0] !== "$" && (e[t] = n[t]);
    return e;
  }
  var jn = !1;
  function $a() {
    jn = !0;
  }
  function qa() {
    jn = !1;
  }
  function el(n, e, t, i) {
    for (; n < e;) {
      var r = n + (e - n >> 1);
      t(r) <= i ? n = r + 1 : e = r;
    }
    return n;
  }
  function tl(n) {
    if (n.hydrate_init) return;
    n.hydrate_init = !0;
    var e = n.childNodes;
    if (n.nodeName === "HEAD") {
      var o = [];
      for (var c = 0; c < e.length; c++) {
        var f = e[c];
        f.claim_order !== void 0 && o.push(f);
      }
      e = o;
    }
    var t = new Int32Array(e.length + 1),
      i = new Int32Array(e.length);
    t[0] = -1;
    var r = 0;
    for (var _o2 = 0; _o2 < e.length; _o2++) {
      var _c2 = e[_o2].claim_order,
        _f = (r > 0 && e[t[r]].claim_order <= _c2 ? r + 1 : el(1, r, function (y) {
          return e[t[y]].claim_order;
        }, _c2)) - 1;
      i[_o2] = t[_f] + 1;
      var g = _f + 1;
      t[g] = _o2, r = Math.max(g, r);
    }
    var l = [],
      a = [];
    var s = e.length - 1;
    for (var _o3 = t[r] + 1; _o3 != 0; _o3 = i[_o3 - 1]) {
      for (l.push(e[_o3 - 1]); s >= _o3; s--) a.push(e[s]);
      s--;
    }
    for (; s >= 0; s--) a.push(e[s]);
    l.reverse(), a.sort(function (o, c) {
      return o.claim_order - c.claim_order;
    });
    for (var _o4 = 0, _c3 = 0; _o4 < a.length; _o4++) {
      for (; _c3 < l.length && a[_o4].claim_order >= l[_c3].claim_order;) _c3++;
      var _f2 = _c3 < l.length ? l[_c3] : null;
      n.insertBefore(a[_o4], _f2);
    }
  }
  function w(n, e) {
    n.appendChild(e);
  }
  function ve(n, e) {
    if (jn) {
      for (tl(n), (n.actual_end_child === void 0 || n.actual_end_child !== null && n.actual_end_child.parentElement !== n) && (n.actual_end_child = n.firstChild); n.actual_end_child !== null && n.actual_end_child.claim_order === void 0;) n.actual_end_child = n.actual_end_child.nextSibling;
      e !== n.actual_end_child ? (e.claim_order !== void 0 || e.parentNode !== n) && n.insertBefore(e, n.actual_end_child) : n.actual_end_child = e.nextSibling;
    } else (e.parentNode !== n || e.nextSibling !== null) && n.appendChild(e);
  }
  function p(n, e, t) {
    n.insertBefore(e, t || null);
  }
  function ut(n, e, t) {
    jn && !t ? ve(n, e) : (e.parentNode !== n || e.nextSibling != t) && n.insertBefore(e, t || null);
  }
  function m(n) {
    n.parentNode.removeChild(n);
  }
  function kt(n, e) {
    for (var t = 0; t < n.length; t += 1) n[t] && n[t].d(e);
  }
  function b(n) {
    return document.createElement(n);
  }
  function te(n) {
    return document.createElementNS("http://www.w3.org/2000/svg", n);
  }
  function x(n) {
    return document.createTextNode(n);
  }
  function G() {
    return x(" ");
  }
  function Le() {
    return x("");
  }
  function ge(n, e, t, i) {
    return n.addEventListener(e, t, i), function () {
      return n.removeEventListener(e, t, i);
    };
  }
  function nl(n) {
    return function (e) {
      return e.preventDefault(), n.call(this, e);
    };
  }
  function Xe(n) {
    return function (e) {
      return e.stopPropagation(), n.call(this, e);
    };
  }
  function d(n, e, t) {
    t == null ? n.removeAttribute(e) : n.getAttribute(e) !== t && n.setAttribute(e, t);
  }
  function Me(n, e) {
    for (var t in e) d(n, t, e[t]);
  }
  function U(n, e, t) {
    e in n ? n[e] = typeof n[e] == "boolean" && t === "" ? !0 : t : d(n, e, t);
  }
  function ne(n) {
    return Array.from(n.childNodes);
  }
  function il(n) {
    n.claim_info === void 0 && (n.claim_info = {
      last_index: 0,
      total_claimed: 0
    });
  }
  function rl(n, e, t, i) {
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
    il(n);
    var l = function () {
      for (var a = n.claim_info.last_index; a < n.length; a++) {
        var s = n[a];
        if (e(s)) {
          var o = t(s);
          return o === void 0 ? n.splice(a, 1) : n[a] = o, r || (n.claim_info.last_index = a), s;
        }
      }
      for (var _a2 = n.claim_info.last_index - 1; _a2 >= 0; _a2--) {
        var _s2 = n[_a2];
        if (e(_s2)) {
          var _o5 = t(_s2);
          return _o5 === void 0 ? n.splice(_a2, 1) : n[_a2] = _o5, r ? _o5 === void 0 && n.claim_info.last_index-- : n.claim_info.last_index = _a2, _s2;
        }
      }
      return i();
    }();
    return l.claim_order = n.claim_info.total_claimed, n.claim_info.total_claimed += 1, l;
  }
  function al(n, e, t, i) {
    return rl(n, function (r) {
      return r.nodeName === e;
    }, function (r) {
      var l = [];
      for (var a = 0; a < r.attributes.length; a++) {
        var s = r.attributes[a];
        t[s.name] || l.push(s.name);
      }
      l.forEach(function (a) {
        return r.removeAttribute(a);
      });
    }, function () {
      return i(e);
    });
  }
  function ie(n, e, t) {
    return al(n, e, t, te);
  }
  function me(n, e) {
    e = "" + e, n.wholeText !== e && (n.data = e);
  }
  function en(n, e, t, i) {
    t === null ? n.style.removeProperty(e) : n.style.setProperty(e, t, i ? "important" : "");
  }
  function Ae(n, e, t) {
    n.classList[t ? "add" : "remove"](e);
  }
  var pn = /*#__PURE__*/function () {
    function pn() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      _classCallCheck(this, pn);
      pn.prototype.__init.call(this), this.is_svg = e, this.e = this.n = null;
    }
    return _createClass(pn, [{
      key: "__init",
      value: function __init() {
        this.is_svg = !1;
      }
    }, {
      key: "c",
      value: function c(e) {
        this.h(e);
      }
    }, {
      key: "m",
      value: function m(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        this.e || (this.is_svg ? this.e = te(t.nodeName) : this.e = b(t.nodeName), this.t = t, this.c(e)), this.i(i);
      }
    }, {
      key: "h",
      value: function h(e) {
        this.e.innerHTML = e, this.n = Array.from(this.e.childNodes);
      }
    }, {
      key: "i",
      value: function i(e) {
        for (var t = 0; t < this.n.length; t += 1) p(this.t, this.n[t], e);
      }
    }, {
      key: "p",
      value: function p(e) {
        this.d(), this.h(e), this.i(this.a);
      }
    }, {
      key: "d",
      value: function d() {
        this.n.forEach(m);
      }
    }]);
  }();
  function gn(n) {
    var e = {};
    var _iterator = _createForOfIteratorHelper(n),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        e[t.name] = t.value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return e;
  }
  var vn;
  function St(n) {
    vn = n;
  }
  function tn() {
    if (!vn) throw new Error("Function called outside component initialization");
    return vn;
  }
  function ll(n) {
    tn().$$.before_update.push(n);
  }
  function Ci(n) {
    tn().$$.on_mount.push(n);
  }
  var bn = [],
    wn = [],
    Fn = [],
    Ni = [],
    Li = Promise.resolve();
  var ri = !1;
  function Mi() {
    ri || (ri = !0, Li.then(fe));
  }
  function ol() {
    return Mi(), Li;
  }
  function ai(n) {
    Fn.push(n);
  }
  var li = new Set();
  var Un = 0,
    Di = !1;
  function fe() {
    if (Di) return;
    var n = vn;
    do {
      for (; Un < bn.length;) {
        var e = bn[Un];
        Un++, St(e), sl(e.$$);
      }
      for (St(null), bn.length = 0, Un = 0; wn.length;) wn.pop()();
      for (var _e2 = 0; _e2 < Fn.length; _e2 += 1) {
        var t = Fn[_e2];
        li.has(t) || (li.add(t), t());
      }
      Fn.length = 0;
    } while (bn.length);
    for (; Ni.length;) Ni.pop()();
    Di = !1, ri = !1, li.clear(), St(n);
  }
  function sl(n) {
    if (n.fragment !== null) {
      n.update(), ot(n.before_update);
      var e = n.dirty;
      n.dirty = [-1], n.fragment && n.fragment.p(n.ctx, e), n.after_update.forEach(ai);
    }
  }
  var Hn = new Set();
  var Jt;
  function Ee() {
    Jt = {
      r: 0,
      c: [],
      p: Jt
    };
  }
  function Te() {
    Jt.r || ot(Jt.c), Jt = Jt.p;
  }
  function C(n, e) {
    n && n.i && (Hn.delete(n), n.i(e));
  }
  function F(n, e, t, i) {
    if (n && n.o) {
      if (Hn.has(n)) return;
      Hn.add(n), Jt.c.push(function () {
        Hn.delete(n), i && (t && n.d(1), i());
      }), n.o(e);
    } else i && i();
  }
  function mt(n, e) {
    var t = e.token = {};
    function i(r, l, a, s) {
      if (e.token !== t) return;
      e.resolved = s;
      var o = e.ctx;
      a !== void 0 && (o = o.slice(), o[a] = s);
      var c = r && (e.current = r)(o);
      var f = !1;
      e.block && (e.blocks ? e.blocks.forEach(function (g, y) {
        y !== l && g && (Ee(), F(g, 1, 1, function () {
          e.blocks[y] === g && (e.blocks[y] = null);
        }), Te());
      }) : e.block.d(1), c.c(), C(c, 1), c.m(e.mount(), e.anchor), f = !0), e.block = c, e.blocks && (e.blocks[l] = c), f && fe();
    }
    if (Ka(n)) {
      var r = tn();
      if (n.then(function (l) {
        St(r), i(e.then, 1, e.value, l), St(null);
      }, function (l) {
        if (St(r), i(e.catch, 2, e.error, l), St(null), !e.hasCatch) throw l;
      }), e.current !== e.pending) return i(e.pending, 0), !0;
    } else {
      if (e.current !== e.then) return i(e.then, 1, e.value, n), !0;
      e.resolved = n;
    }
  }
  function nn(n, e, t) {
    var i = e.slice(),
      r = n.resolved;
    n.current === n.then && (i[n.value] = r), n.current === n.catch && (i[n.error] = r), n.block.p(i, t);
  }
  function _t(n, e) {
    var t = {},
      i = {},
      r = {
        $$scope: 1
      };
    var l = n.length;
    for (; l--;) {
      var a = n[l],
        s = e[l];
      if (s) {
        for (var o in a) o in s || (i[o] = 1);
        for (var _o6 in s) r[_o6] || (t[_o6] = s[_o6], r[_o6] = 1);
        n[l] = s;
      } else for (var _o7 in a) r[_o7] = 1;
    }
    for (var _a3 in i) _a3 in t || (t[_a3] = void 0);
    return t;
  }
  function He(n) {
    n && n.c();
  }
  function Fe(n, e, t, i) {
    var _n$$$ = n.$$,
      r = _n$$$.fragment,
      l = _n$$$.on_mount,
      a = _n$$$.on_destroy,
      s = _n$$$.after_update;
    r && r.m(e, t), i || ai(function () {
      var o = l.map(ni).filter(ii);
      a ? a.push.apply(a, _toConsumableArray(o)) : ot(o), n.$$.on_mount = [];
    }), s.forEach(ai);
  }
  function Re(n, e) {
    var t = n.$$;
    t.fragment !== null && (ot(t.on_destroy), t.fragment && t.fragment.d(e), t.on_destroy = t.fragment = null, t.ctx = []);
  }
  function cl(n, e) {
    n.$$.dirty[0] === -1 && (bn.push(n), Mi(), n.$$.dirty.fill(0)), n.$$.dirty[e / 31 | 0] |= 1 << e % 31;
  }
  function Ke(n, e, t, i, r, l, a) {
    var s = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [-1];
    var o = vn;
    St(n);
    var c = n.$$ = {
      fragment: null,
      ctx: null,
      props: l,
      update: T,
      not_equal: r,
      bound: Ti(),
      on_mount: [],
      on_destroy: [],
      on_disconnect: [],
      before_update: [],
      after_update: [],
      context: new Map(e.context || (o ? o.$$.context : [])),
      callbacks: Ti(),
      dirty: s,
      skip_bound: !1,
      root: e.target || o.$$.root
    };
    a && a(c.root);
    var f = !1;
    if (c.ctx = t ? t(n, e.props || {}, function (g, y) {
      var k = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : y;
      return c.ctx && r(c.ctx[g], c.ctx[g] = k) && (!c.skip_bound && c.bound[g] && c.bound[g](k), f && cl(n, g)), y;
    }) : [], c.update(), f = !0, ot(c.before_update), c.fragment = i ? i(c.ctx) : !1, e.target) {
      if (e.hydrate) {
        $a();
        var g = ne(e.target);
        c.fragment && c.fragment.l(g), g.forEach(m);
      } else c.fragment && c.fragment.c();
      e.intro && C(n.$$.fragment), Fe(n, e.target, e.anchor, e.customElement), qa(), fe();
    }
    St(o);
  }
  var rn;
  typeof HTMLElement == "function" && (rn = /*#__PURE__*/function (_HTMLElement) {
    function rn() {
      var _this;
      _classCallCheck(this, rn);
      _this = _callSuper(this, rn);
      _this.attachShadow({
        mode: "open"
      });
      return _this;
    }
    _inherits(rn, _HTMLElement);
    return _createClass(rn, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var n = this.$$.on_mount;
        this.$$.on_disconnect = n.map(ni).filter(ii);
        for (var e in this.$$.slotted) this.appendChild(this.$$.slotted[e]);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(n, e, t) {
        this[n] = t;
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        ot(this.$$.on_disconnect);
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        Re(this, 1), this.$destroy = T;
      }
    }, {
      key: "$on",
      value: function $on(n, e) {
        var t = this.$$.callbacks[n] || (this.$$.callbacks[n] = []);
        return t.push(e), function () {
          var i = t.indexOf(e);
          i !== -1 && t.splice(i, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(n) {
        this.$$set && !Oi(n) && (this.$$.skip_bound = !0, this.$$set(n), this.$$.skip_bound = !1);
      }
    }]);
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
  var ht = /*#__PURE__*/function () {
    function ht() {
      _classCallCheck(this, ht);
    }
    return _createClass(ht, [{
      key: "$destroy",
      value: function $destroy() {
        Re(this, 1), this.$destroy = T;
      }
    }, {
      key: "$on",
      value: function $on(e, t) {
        var i = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
        return i.push(t), function () {
          var r = i.indexOf(t);
          r !== -1 && i.splice(r, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(e) {
        this.$$set && !Oi(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
      }
    }]);
  }();
  var an = [];
  function fl(n, e) {
    return {
      subscribe: bt(n, e).subscribe
    };
  }
  function bt(n) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : T;
    var t;
    var i = new Set();
    function r(s) {
      if (Ye(n, s) && (n = s, t)) {
        var o = !an.length;
        var _iterator2 = _createForOfIteratorHelper(i),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _c4 = _step2.value;
            _c4[1](), an.push(_c4, n);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (o) {
          for (var c = 0; c < an.length; c += 2) an[c][0](an[c + 1]);
          an.length = 0;
        }
      }
    }
    function l(s) {
      r(s(n));
    }
    function a(s) {
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : T;
      var c = [s, o];
      return i.add(c), i.size === 1 && (t = e(r) || T), s(n), function () {
        i.delete(c), i.size === 0 && (t(), t = null);
      };
    }
    return {
      set: r,
      update: l,
      subscribe: a
    };
  }
  function dl(n, e, t) {
    var i = !Array.isArray(n),
      r = i ? [n] : n,
      l = e.length < 2;
    return fl(t, function (a) {
      var s = !1;
      var o = [];
      var c = 0,
        f = T;
      var g = function g() {
          if (c) return;
          f();
          var S = e(i ? o[0] : o, a);
          l ? a(S) : f = ii(S) ? S : T;
        },
        y = r.map(function (S, k) {
          return Si(S, function (L) {
            o[k] = L, c &= ~(1 << k), s && g();
          }, function () {
            c |= 1 << k;
          });
        });
      return s = !0, g(), function () {
        ot(y), f();
      };
    });
  }
  function ul() {
    return bt({});
  }
  var oi = ul();
  var ml = Object.defineProperty,
    _l = Object.defineProperties,
    hl = Object.getOwnPropertyDescriptors,
    Pi = Object.getOwnPropertySymbols,
    pl = Object.prototype.hasOwnProperty,
    gl = Object.prototype.propertyIsEnumerable,
    Ri = function Ri(n, e, t) {
      return e in n ? ml(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    vl = function vl(n, e) {
      for (var t in e || (e = {})) pl.call(e, t) && Ri(n, t, e[t]);
      if (Pi) {
        var _iterator3 = _createForOfIteratorHelper(Pi(e)),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var t = _step3.value;
            gl.call(e, t) && Ri(n, t, e[t]);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      return n;
    },
    bl = function bl(n, e) {
      return _l(n, hl(e));
    };
  function Be(_x) {
    return _Be.apply(this, arguments);
  }
  function _Be() {
    _Be = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(n) {
      var e, t, i, r;
      return _regeneratorRuntime().wrap(function _callee51$(_context51) {
        while (1) switch (_context51.prev = _context51.next) {
          case 0:
            if (n.ok) {
              _context51.next = 7;
              break;
            }
            _context51.next = 3;
            return n.json().then(function (l) {
              return l;
            });
          case 3:
            t = _context51.sent;
            i = ((e = t == null ? void 0 : t.response) == null ? void 0 : e.error) || (t == null ? void 0 : t.message);
            r = new Error(i);
            return _context51.abrupt("return", (r.name = t.name, Promise.reject({
              message: r,
              statusCode: n.status
            })));
          case 7:
            return _context51.abrupt("return", n.json());
          case 8:
          case "end":
            return _context51.stop();
        }
      }, _callee51);
    }));
    return _Be.apply(this, arguments);
  }
  function Ge() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      component_id: ""
    };
    return {
      method: n.method || "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Component-Id": n.component_id || "",
        "X-Access-Token": n.access_token || ""
      },
      body: n.body ? JSON.stringify(n.body) : void 0
    };
  }
  function We(n, e) {
    throw console.error(e), oi.update(function (t) {
      return bl(vl({}, t), _defineProperty({}, n, e));
    }), e;
  }
  var Ii = {
    "001": "",
    "002": "ireland-",
    "003": "canada-"
  };
  function Ve(n) {
    var e = "";
    if (n.substring(3, 4) === "-") {
      var i = n.substring(0, 3);
      typeof Ii[i] != "undefined" && (e = Ii[i]);
    }
    return "https://".concat(e, "web-components.nylas.com/middleware");
  }
  function It(n) {}
  function wl(n) {
    return Object.keys(n).reduce(function (e, t) {
      return n[t] !== void 0 && e.append(t, n[t]), e;
    }, new URLSearchParams()).toString();
  }
  var yl = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(n, e) {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              t = "".concat(Ve(n.component_id), "/contact-list/contacts?").concat(wl(e));
              _context.next = 3;
              return fetch(t, Ge({
                component_id: n.component_id,
                access_token: n.access_token
              })).then(function (r) {
                return Be(r);
              }).then(function (r) {
                return r.response;
              }).catch(function (r) {
                return We(n.component_id, r);
              });
            case 3:
              i = _context.sent;
              return _context.abrupt("return", i != null ? i : []);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function yl(_x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }(),
    kl = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(n) {
        var e;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch("".concat(Ve(n.component_id), "/contacts").concat(n.query), Ge({
                component_id: n.component_id,
                access_token: n.access_token
              })).then(function (t) {
                return Be(t);
              }).then(function (t) {
                return t.response;
              }).catch(function (t) {
                return We(n.component_id, t);
              });
            case 2:
              e = _context2.sent;
              return _context2.abrupt("return", e != null ? e : []);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function kl(_x4) {
        return _ref2.apply(this, arguments);
      };
    }(),
    El = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(n, e) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetch("".concat(Ve(n.component_id), "/contacts/").concat(e, "/picture"), Ge({
                component_id: n.component_id,
                access_token: n.access_token
              })).then(function (t) {
                return Be(t);
              }).then(function (t) {
                return t.response;
              }).catch(function (t) {
                return We(n.component_id, t);
              });
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function El(_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();
  var Tl = Object.defineProperty,
    Al = Object.defineProperties,
    Ol = Object.getOwnPropertyDescriptors,
    ji = Object.getOwnPropertySymbols,
    Sl = Object.prototype.hasOwnProperty,
    Cl = Object.prototype.propertyIsEnumerable,
    Fi = function Fi(n, e, t) {
      return e in n ? Tl(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    Nl = function Nl(n, e) {
      for (var t in e || (e = {})) Sl.call(e, t) && Fi(n, t, e[t]);
      if (ji) {
        var _iterator4 = _createForOfIteratorHelper(ji(e)),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var t = _step4.value;
            Cl.call(e, t) && Fi(n, t, e[t]);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      return n;
    },
    Ll = function Ll(n, e) {
      return Al(n, Ol(e));
    };
  var Ui = function Ui(n, e, t) {
    var i = "".concat(Ve(n.component_id), "/threads?view=expanded&not_in=trash&limit=").concat(e, "&offset=").concat(t);
    return n.query && Object.entries(n.query).forEach(function (r) {
      return i = i.concat("&".concat(r[0], "=").concat(r[1]));
    }), fetch(i, Ge(n)).then(function (r) {
      return Be(r);
    }).then(function (r) {
      return r.response;
    }).then(function (r) {
      return r.map(function (l) {
        return Ll(Nl({}, l), {
          messages: l.messages.filter(function (a) {
            return a.from.length !== 0 || a.to.length !== 0;
          })
        });
      });
    }).catch(function (r) {
      return We(n.component_id, r);
    });
  };
  function Hi(n) {
    var e = "".concat(Ve(n.component_id), "/threads?view=expanded&not_in=trash&view=count");
    return n.query && Object.entries(n.query).forEach(function (t) {
      return e = e.concat("&".concat(t[0], "=").concat(t[1]));
    }), n.keywordToSearch && (e += "&q=".concat(n.keywordToSearch)), fetch(e, Ge(n)).then(function (t) {
      return Be(t);
    }).then(function (t) {
      return t.response.count;
    });
  }
  var Ml = function Ml(n) {
      var e = "".concat(Ve(n.component_id), "/threads/search?q=").concat(n.keywordToSearch, "&view=expanded&limit=").concat(n.query.limit, "&offset=").concat(n.query.offset);
      return fetch(e, Ge(n)).then( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(t) {
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", Be(t));
              case 1:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x7) {
          return _ref4.apply(this, arguments);
        };
      }()).then(function (t) {
        return t.response;
      }).catch(function (t) {
        return We(n.component_id, t);
      });
    },
    Dl = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(n) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return fetch("".concat(Ve(n.component_id), "/threads/").concat(n.thread_id, "?view=expanded"), Ge({
                component_id: n.component_id,
                access_token: n.access_token
              })).then(function (t) {
                return Be(t);
              }).then(function (t) {
                return t.response;
              }).catch(function (t) {
                return We(n.component_id, t);
              });
            case 2:
              return _context5.abrupt("return", _context5.sent);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function Dl(_x8) {
        return _ref5.apply(this, arguments);
      };
    }(),
    zi = function zi(n, e) {
      return fetch("".concat(Ve(n.component_id), "/threads/").concat(e.id), Ge({
        method: "PUT",
        component_id: n.component_id,
        access_token: n.access_token,
        body: {
          unread: e.unread,
          starred: e.starred,
          folder_id: e.folder_id,
          label_ids: e.label_ids
        }
      })).then(function (t) {
        return Be(t);
      }).then(function (t) {
        return t.response;
      }).catch(function (t) {
        return We(n.component_id, t);
      });
    },
    Pl = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(n, e) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return fetch("".concat(Ve(n), "/manifest"), Ge({
                access_token: e,
                component_id: n
              })).then(Be).then(function (t) {
                return t.component.theming;
              }).catch(function (t) {
                return We(n, t);
              });
            case 2:
              return _context6.abrupt("return", _context6.sent);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function Pl(_x9, _x10) {
        return _ref6.apply(this, arguments);
      };
    }();
  function Rl(_x11, _x12, _x13) {
    return _Rl.apply(this, arguments);
  }
  function _Rl() {
    _Rl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52(n, e, t) {
      var i, r;
      return _regeneratorRuntime().wrap(function _callee52$(_context52) {
        while (1) switch (_context52.prev = _context52.next) {
          case 0:
            i = "".concat(Ve(n), "/messages/").concat(e.id), r = Ge({
              method: "PUT",
              component_id: n,
              access_token: t,
              body: {
                folder_id: e.folder_id,
                label_ids: e.label_ids
              }
            });
            _context52.next = 3;
            return fetch(i, r).then(function (l) {
              return Be(l);
            }).then(function (l) {
              return l.response;
            }).catch(function (l) {
              return We(n, l);
            });
          case 3:
            return _context52.abrupt("return", _context52.sent);
          case 4:
          case "end":
            return _context52.stop();
        }
      }, _callee52);
    }));
    return _Rl.apply(this, arguments);
  }
  var Il = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(n, e) {
        var t;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              t = "".concat(Ve(n.component_id), "/messages/").concat(e);
              _context7.next = 3;
              return fetch(t, Ge(n)).then(function (i) {
                return Be(i);
              }).then(function (i) {
                return i.response;
              }).catch(function (i) {
                return We(n.component_id, i);
              });
            case 3:
              return _context7.abrupt("return", _context7.sent);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function Il(_x14, _x15) {
        return _ref7.apply(this, arguments);
      };
    }(),
    jl = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(n) {
        var e;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              e = "".concat(Ve(n.component_id), "/messages/").concat(n.message_id);
              _context8.next = 3;
              return fetch(e, Ge(n)).then(function (t) {
                return Be(t);
              }).then(function (t) {
                return t.response;
              }).catch(function (t) {
                return We(n.component_id, t);
              });
            case 3:
              return _context8.abrupt("return", _context8.sent);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function jl(_x16) {
        return _ref8.apply(this, arguments);
      };
    }(),
    Fl = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(n) {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return fetch("".concat(Ve(n.component_id), "/account"), Ge(n)).then(function (t) {
                return Be(t);
              }).then(function (t) {
                return t.response;
              }).catch(function (t) {
                return We(n.component_id, t);
              });
            case 2:
              return _context9.abrupt("return", _context9.sent);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return function Fl(_x17) {
        return _ref9.apply(this, arguments);
      };
    }(),
    Bi = function Bi(n) {
      return fetch("".concat(Ve(n.component_id), "/neural/conversation"), Ge({
        method: "PUT",
        access_token: n.access_token,
        component_id: n.component_id,
        body: {
          message_id: n.message_id
        }
      })).then( /*#__PURE__*/function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return Be(e);
              case 2:
                return _context10.abrupt("return", _context10.sent.response);
              case 3:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        return function (_x18) {
          return _ref10.apply(this, arguments);
        };
      }()).catch(function (e) {
        return We(n.component_id, e);
      });
    };
  var Ul = Object.defineProperty,
    Gi = Object.getOwnPropertySymbols,
    Hl = Object.prototype.hasOwnProperty,
    zl = Object.prototype.propertyIsEnumerable,
    Vi = function Vi(n, e, t) {
      return e in n ? Ul(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    Wi = function Wi(n, e) {
      for (var t in e || (e = {})) Hl.call(e, t) && Vi(n, t, e[t]);
      if (Gi) {
        var _iterator5 = _createForOfIteratorHelper(Gi(e)),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var t = _step5.value;
            zl.call(e, t) && Vi(n, t, e[t]);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
      return n;
    };
  var Bl = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(n) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", fetch("".concat(Ve(n.component_id), "/calendars/availability"), Ge({
                method: "POST",
                component_id: n.component_id,
                access_token: n.access_token,
                body: n.body
              })).then( /*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(e) {
                  var t;
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return Be(e);
                      case 2:
                        t = _context11.sent;
                        return _context11.abrupt("return", (t.response.time_slots = t.response.time_slots.map(function (i) {
                          return i.start_time = i.start || 0, i.end_time = i.end || 0, delete i.start, delete i.end, i;
                        }), t.response));
                      case 4:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x20) {
                  return _ref12.apply(this, arguments);
                };
              }()).catch(function (e) {
                return We(n.component_id, e);
              }));
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return function Bl(_x19) {
        return _ref11.apply(this, arguments);
      };
    }(),
    Gl = /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(n) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", fetch("".concat(Ve(n.component_id), "/calendars/availability/consecutive"), Ge({
                method: "POST",
                component_id: n.component_id,
                access_token: n.access_token,
                body: n.body
              })).then( /*#__PURE__*/function () {
                var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(e) {
                  var t, r, l;
                  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        _context13.next = 2;
                        return Be(e);
                      case 2:
                        _context13.t1 = t = _context13.sent.response;
                        if (!(_context13.t1 == null)) {
                          _context13.next = 7;
                          break;
                        }
                        _context13.t2 = void 0;
                        _context13.next = 8;
                        break;
                      case 7:
                        _context13.t2 = t.map(function (s) {
                          return s = s.map(function (o) {
                            return o.start_time = new Date(o.start_time * 1e3), o.end_time = new Date(o.end_time * 1e3), o;
                          }), s;
                        });
                      case 8:
                        _context13.t0 = _context13.t2;
                        if (_context13.t0) {
                          _context13.next = 11;
                          break;
                        }
                        _context13.t0 = [];
                      case 11:
                        r = _context13.t0;
                        l = Vl(r, n.body.events);
                        return _context13.abrupt("return", Wl(l));
                      case 14:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee13);
                }));
                return function (_x22) {
                  return _ref14.apply(this, arguments);
                };
              }()).catch(function (e) {
                return We(n.component_id, e);
              }));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return function Gl(_x21) {
        return _ref13.apply(this, arguments);
      };
    }();
  function Vl(n, e) {
    return n.map(function (t) {
      return t.map(function (i) {
        return Wi(Wi({}, i), e.find(function (r) {
          return r.participantEmails.length === i.emails.length && r.participantEmails.every(function (l) {
            return i.emails.includes(l);
          });
        }));
      });
    });
  }
  function Wl(n) {
    var e = new Set();
    return n.filter(function (t) {
      var i = "".concat(t[0].start_time, "_").concat(t[t.length - 1].end_time);
      return e.has(i) ? !1 : (e.add(i), !0);
    });
  }
  var Jl = Object.defineProperty,
    Ji = Object.getOwnPropertySymbols,
    xl = Object.prototype.hasOwnProperty,
    Zl = Object.prototype.propertyIsEnumerable,
    xi = function xi(n, e, t) {
      return e in n ? Jl(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    Yl = function Yl(n, e) {
      for (var t in e || (e = {})) xl.call(e, t) && xi(n, t, e[t]);
      if (Ji) {
        var _iterator6 = _createForOfIteratorHelper(Ji(e)),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var t = _step6.value;
            Zl.call(e, t) && xi(n, t, e[t]);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
      return n;
    };
  function Xl() {
    var n = function n(t, i) {
        var r, l;
        var a = JSON.parse(i),
          s = Yl({}, a);
        if (delete s.forceReload, i = JSON.stringify(s), !(!a.component_id || !((r = a == null ? void 0 : a.body) == null ? void 0 : r.start_time) || !((l = a == null ? void 0 : a.body) == null ? void 0 : l.end_time))) {
          if (!t[i] || a.forceReload) {
            var o = Bl(a);
            e.update(function (c) {
              return c[i] = o, c;
            }), t[i] = o;
          }
          return t[i];
        }
      },
      e = bt(new Proxy({}, {
        get: n
      }));
    return e;
  }
  Xl();
  function Kl() {
    var n = function n(t, i) {
        var r, l;
        var a = JSON.parse(i);
        if (!(!a.component_id || !((r = a == null ? void 0 : a.body) == null ? void 0 : r.start_time) || !((l = a == null ? void 0 : a.body) == null ? void 0 : l.end_time))) {
          if (!t[i]) {
            var s = Gl(a);
            e.update(function (o) {
              return o[i] = s, o;
            }), t[i] = s;
          }
          return t[i];
        }
      },
      e = bt(new Proxy({}, {
        get: n
      }));
    return e;
  }
  Kl();
  var Ql = Object.defineProperty,
    Zi = Object.getOwnPropertySymbols,
    $l = Object.prototype.hasOwnProperty,
    ql = Object.prototype.propertyIsEnumerable,
    Yi = function Yi(n, e, t) {
      return e in n ? Ql(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    Xi = function Xi(n, e) {
      for (var t in e || (e = {})) $l.call(e, t) && Yi(n, t, e[t]);
      if (Zi) {
        var _iterator7 = _createForOfIteratorHelper(Zi(e)),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var t = _step7.value;
            ql.call(e, t) && Yi(n, t, e[t]);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
      return n;
    };
  var st = {};
  function Ki(n) {
    return n.filter(function (e) {
      return !!e.given_name || !!e.surname || Array.isArray(e.emails) && e.emails.length > 0;
    }).map(function (e) {
      return (!Array.isArray(e.emails) || e.emails.length === 0) && (e.emails = [{
        email: ""
      }]), e;
    });
  }
  function eo() {
    var _bt = bt({}),
      n = _bt.subscribe,
      e = _bt.set,
      t = _bt.update;
    return {
      subscribe: n,
      addContacts: function () {
        var _addContacts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(i, r) {
          var l, a, s;
          return _regeneratorRuntime().wrap(function _callee15$(_context15) {
            while (1) switch (_context15.prev = _context15.next) {
              case 0:
                a = JSON.stringify(i);
                if (!(!st[a] && (i.component_id || i.access_token))) {
                  _context15.next = 13;
                  break;
                }
                r.offset === 0 && si.reset();
                _context15.next = 5;
                return yl(i, r).then(function (o) {
                  return Ki(o);
                }).catch(function () {
                  return [];
                });
              case 5:
                _context15.t0 = l = _context15.sent;
                if (!(_context15.t0 != null)) {
                  _context15.next = 10;
                  break;
                }
                _context15.t1 = l;
                _context15.next = 11;
                break;
              case 10:
                _context15.t1 = [];
              case 11:
                s = _context15.t1;
                return _context15.abrupt("return", (st[a] = st[a] ? [].concat(_toConsumableArray(st[a]), _toConsumableArray(s)) : s, t(function (o) {
                  return o[a] = st[a], Xi({}, o);
                }), st[a]));
              case 13:
              case "end":
                return _context15.stop();
            }
          }, _callee15);
        }));
        function addContacts(_x23, _x24) {
          return _addContacts.apply(this, arguments);
        }
        return addContacts;
      }(),
      addContact: function () {
        var _addContact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(i) {
          var r, l, a;
          return _regeneratorRuntime().wrap(function _callee16$(_context16) {
            while (1) switch (_context16.prev = _context16.next) {
              case 0:
                l = JSON.stringify(i);
                if (!(!st[l] && (i.component_id || i.access_token))) {
                  _context16.next = 12;
                  break;
                }
                _context16.next = 4;
                return kl(i).then(function (s) {
                  return Ki(s);
                }).catch(function () {
                  return [];
                });
              case 4:
                _context16.t0 = r = _context16.sent;
                if (!(_context16.t0 != null)) {
                  _context16.next = 9;
                  break;
                }
                _context16.t1 = r;
                _context16.next = 10;
                break;
              case 9:
                _context16.t1 = [];
              case 10:
                a = _context16.t1;
                st[l] = st[l] ? [].concat(_toConsumableArray(st[l]), _toConsumableArray(a)) : a, t(function (s) {
                  return s[l] = st[l], Xi({}, s);
                });
              case 12:
                return _context16.abrupt("return", st[l]);
              case 13:
              case "end":
                return _context16.stop();
            }
          }, _callee16);
        }));
        function addContact(_x25) {
          return _addContact.apply(this, arguments);
        }
        return addContact;
      }(),
      reset: function reset() {
        st = {}, e({});
      }
    };
  }
  var si = eo(),
    ci = {};
  function to() {
    var _bt2 = bt({}),
      n = _bt2.subscribe,
      e = _bt2.set;
    return {
      subscribe: n,
      getContactAvatar: function () {
        var _getContactAvatar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(t, i) {
          var r,
            l,
            _args17 = arguments;
          return _regeneratorRuntime().wrap(function _callee17$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                r = _args17.length > 2 && _args17[2] !== undefined ? _args17[2] : !1;
                if (!(!ci[i] || r)) {
                  _context17.next = 6;
                  break;
                }
                _context17.next = 4;
                return El(t, i).then(function (a) {
                  return a;
                }).catch(function () {
                  return "";
                });
              case 4:
                l = _context17.sent;
                l && (ci[i] = l);
              case 6:
                return _context17.abrupt("return", ci[i]);
              case 7:
              case "end":
                return _context17.stop();
            }
          }, _callee17);
        }));
        function getContactAvatar(_x26, _x27) {
          return _getContactAvatar.apply(this, arguments);
        }
        return getContactAvatar;
      }(),
      reset: function reset() {
        return e({});
      }
    };
  }
  var no = to();
  var io = Object.defineProperty,
    Qi = Object.getOwnPropertySymbols,
    ro = Object.prototype.hasOwnProperty,
    ao = Object.prototype.propertyIsEnumerable,
    $i = function $i(n, e, t) {
      return e in n ? io(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    xt = function xt(n, e) {
      for (var t in e || (e = {})) ro.call(e, t) && $i(n, t, e[t]);
      if (Qi) {
        var _iterator8 = _createForOfIteratorHelper(Qi(e)),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var t = _step8.value;
            ao.call(e, t) && $i(n, t, e[t]);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
      return n;
    };
  function qi(_x28) {
    return _qi.apply(this, arguments);
  }
  function _qi() {
    _qi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53(n) {
      var e, t;
      return _regeneratorRuntime().wrap(function _callee53$(_context53) {
        while (1) switch (_context53.prev = _context53.next) {
          case 0:
            e = [];
            for (t = 0; t < n; t++) e.push({
              isLoaded: !1,
              threads: []
            });
            return _context53.abrupt("return", e);
          case 3:
          case "end":
            return _context53.stop();
        }
      }, _callee53);
    }));
    return _qi.apply(this, arguments);
  }
  function lo() {
    var _bt3 = bt({}),
      n = _bt3.subscribe,
      e = _bt3.set,
      t = _bt3.update;
    var i = {},
      r;
    return {
      subscribe: n,
      set: e,
      getThreads: function () {
        var _getThreads = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(l, a, s) {
          var o,
            c,
            f,
            _f3,
            _f4,
            _args18 = arguments;
          return _regeneratorRuntime().wrap(function _callee18$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                o = _args18.length > 3 && _args18[3] !== undefined ? _args18[3] : !1;
                c = JSON.stringify(l);
                if (!(!l.component_id && !l.access_token)) {
                  _context18.next = 4;
                  break;
                }
                return _context18.abrupt("return", []);
              case 4:
                if (!(r === void 0 || o)) {
                  _context18.next = 9;
                  break;
                }
                _context18.next = 7;
                return Hi(l).catch(It);
              case 7:
                f = _context18.sent;
                f && (r = f);
              case 9:
                if (!(!Array.isArray(i[c]) || o)) {
                  _context18.next = 14;
                  break;
                }
                _f3 = Math.ceil(r / s);
                _context18.next = 13;
                return qi(_f3);
              case 13:
                i[c] = _context18.sent;
              case 14:
                if (!(typeof i[c][a] == "undefined")) {
                  _context18.next = 16;
                  break;
                }
                return _context18.abrupt("return", []);
              case 16:
                if (i[c][a].isLoaded) {
                  _context18.next = 21;
                  break;
                }
                _context18.next = 19;
                return Ui(l, s, a * s).catch(It);
              case 19:
                _f4 = _context18.sent;
                _f4 && (i[c][a].threads = _f4, i[c][a].isLoaded = !0);
              case 21:
                return _context18.abrupt("return", (t(function (f) {
                  return f[c] = i[c], xt({}, f);
                }), i[c][a].threads));
              case 22:
              case "end":
                return _context18.stop();
            }
          }, _callee18);
        }));
        function getThreads(_x29, _x30, _x31) {
          return _getThreads.apply(this, arguments);
        }
        return getThreads;
      }(),
      getNumberOfItems: function () {
        var _getNumberOfItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(l) {
          var a;
          return _regeneratorRuntime().wrap(function _callee19$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                if (!(!l.component_id && !l.access_token)) {
                  _context19.next = 2;
                  break;
                }
                return _context19.abrupt("return", 0);
              case 2:
                if (!(typeof r == "undefined")) {
                  _context19.next = 7;
                  break;
                }
                _context19.next = 5;
                return Hi(l).catch(It);
              case 5:
                a = _context19.sent;
                a && (r = a);
              case 7:
                return _context19.abrupt("return", r);
              case 8:
              case "end":
                return _context19.stop();
            }
          }, _callee19);
        }));
        function getNumberOfItems(_x32) {
          return _getNumberOfItems.apply(this, arguments);
        }
        return getNumberOfItems;
      }(),
      getThreadsWithSearchKeyword: function () {
        var _getThreadsWithSearchKeyword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(l) {
          var a,
            s,
            o,
            _args20 = arguments;
          return _regeneratorRuntime().wrap(function _callee20$(_context20) {
            while (1) switch (_context20.prev = _context20.next) {
              case 0:
                a = _args20.length > 1 && _args20[1] !== undefined ? _args20[1] : !1;
                if (!(!l.component_id && !l.access_token)) {
                  _context20.next = 3;
                  break;
                }
                return _context20.abrupt("return", []);
              case 3:
                s = JSON.stringify(l);
                _context20.t0 = !Array.isArray(i[s]) || a;
                if (!_context20.t0) {
                  _context20.next = 9;
                  break;
                }
                _context20.next = 8;
                return qi(1);
              case 8:
                i[s] = _context20.sent;
              case 9:
                if (!(!i[s][0].isLoaded || a)) {
                  _context20.next = 14;
                  break;
                }
                _context20.next = 12;
                return Ml(l).catch(It);
              case 12:
                o = _context20.sent;
                o && (i[s][0].threads = o, i[s][0].isLoaded = !0);
              case 14:
                return _context20.abrupt("return", (t(function (o) {
                  return o[s] = i[s], xt({}, o);
                }), i[s][0].threads));
              case 15:
              case "end":
                return _context20.stop();
            }
          }, _callee20);
        }));
        function getThreadsWithSearchKeyword(_x33) {
          return _getThreadsWithSearchKeyword.apply(this, arguments);
        }
        return getThreadsWithSearchKeyword;
      }(),
      updateThread: function () {
        var _updateThread = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(l, a, s, o, c) {
          var f, g;
          return _regeneratorRuntime().wrap(function _callee21$(_context21) {
            while (1) switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return zi(l, s).catch(It);
              case 2:
                f = _context21.sent;
                if (i[a][o].isLoaded) {
                  _context21.next = 8;
                  break;
                }
                _context21.next = 6;
                return Ui(JSON.parse(a), c, o * c).catch(It);
              case 6:
                g = _context21.sent;
                g && (i[a][o].threads = g, i[a][o].isLoaded = !0);
              case 8:
                return _context21.abrupt("return", (i[a][o].threads = i[a][o].threads.map(function (g) {
                  return f && g.id === f.id && (g = Object.assign(g, f)), g;
                }), t(function (g) {
                  return g[a] = i[a], xt({}, g);
                }), i[a][o].threads));
              case 9:
              case "end":
                return _context21.stop();
            }
          }, _callee21);
        }));
        function updateThread(_x34, _x35, _x36, _x37, _x38) {
          return _updateThread.apply(this, arguments);
        }
        return updateThread;
      }(),
      updateThreadSelection: function updateThreadSelection(l, a, s) {
        var o = i[l][a].threads;
        if (s) {
          var c = o.find(function (f) {
            return f.id === s;
          });
          c && (c.selected = !c.selected);
        } else {
          var _c5 = o.some(function (f) {
            return f.selected;
          });
          var _iterator9 = _createForOfIteratorHelper(o),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var f = _step9.value;
              f.selected = !_c5;
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        }
        return t(function (c) {
          return c[l] = i[l], xt({}, c);
        }), i[l][a].threads;
      },
      reset: function reset() {
        i = {}, e({});
      },
      hydrateMessageInThread: function hydrateMessageInThread(l, a, s) {
        var o, c, f;
        var g = JSON.stringify(a),
          y = (c = (o = i[g][s]) == null ? void 0 : o.threads) == null ? void 0 : c.find(function (S) {
            return S.id === l.thread_id;
          });
        if (y) {
          var S = (f = y.messages) == null ? void 0 : f.find(function (k) {
            return k.id === l.id;
          });
          S ? (S.body = l.body, t(function (k) {
            if (l.thread_id) {
              var L = k[g][s].threads.find(function (j) {
                return j.id === y.id;
              });
              L && (L = JSON.parse(JSON.stringify(y)));
            }
            return xt({}, k);
          })) : t(function (k) {
            if (l.thread_id) {
              var L = k[g][s].threads.find(function (j) {
                return j.id === y.id;
              });
              if (L) {
                var j = y.messages;
                j.push(l), y.messages = j, y.snippet = l.snippet, y.drafts = y.drafts.filter(function (E) {
                  return E.id !== l.id;
                }), L = JSON.parse(JSON.stringify(y));
              }
            }
            return xt({}, k);
          });
        }
        return i[g][s].threads;
      },
      hydrateDraftInThread: function hydrateDraftInThread(l, a, s) {
        var o, c, f;
        var g = JSON.stringify(a),
          y = (c = (o = i[g][s]) == null ? void 0 : o.threads) == null ? void 0 : c.find(function (S) {
            return S.id === l.thread_id;
          });
        if (y) {
          var S = (f = y.drafts) == null ? void 0 : f.find(function (k) {
            return k.id === l.id;
          });
          if (l.thread_id) {
            if (S) Object.assign(S, l);else {
              var k = y.drafts;
              k.push(l), y.drafts = k;
            }
            t(function (k) {
              var L = k[g][s].threads.find(function (j) {
                return j.id === y.id;
              });
              return L && (L = JSON.parse(JSON.stringify(y))), xt({}, k);
            });
          }
        }
        return i[g][s].threads;
      }
    };
  }
  var oo = lo(),
    so = dl(oo, function (n) {
      var e = {};
      return Object.entries(n).forEach(function (_ref15) {
        var _ref16 = _slicedToArray(_ref15, 2),
          t = _ref16[0],
          i = _ref16[1];
        return e[t] = i.map(function (r) {
          return r.threads;
        }).flat();
      }), e;
    });
  function co() {
    var n = function n(t, i) {
        var r = JSON.parse(i);
        if (!!r.component_id) {
          if (!t[i]) {
            var l = Pl(r.component_id, r.access_token);
            e.update(function (a) {
              return a[i] = l, a;
            }), t[i] = l;
          }
          return t[i];
        }
      },
      e = bt(new Proxy({}, {
        get: n
      }));
    return e;
  }
  var fo = co(),
    er = /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(n) {
        var e;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              e = "".concat(Ve(n.component_id), "/files/").concat(n.file_id, "/download");
              _context22.next = 3;
              return fetch(e, Ge(n)).then(function (t) {
                return Be(t);
              }).then(function (t) {
                return t.response;
              }).catch(function (t) {
                return We(n.component_id, t);
              });
            case 3:
              return _context22.abrupt("return", _context22.sent);
            case 4:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
      return function er(_x39) {
        return _ref17.apply(this, arguments);
      };
    }(),
    uo = ["message/delivery-status", "message/rfc822"],
    tr = ["image/png", "image/apng", "image/avif", "image/gif", "image/jpeg", "image/svg+xml"];
  var mo = Object.defineProperty,
    nr = Object.getOwnPropertySymbols,
    _o = Object.prototype.hasOwnProperty,
    ho = Object.prototype.propertyIsEnumerable,
    ir = function ir(n, e, t) {
      return e in n ? mo(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    po = function po(n, e) {
      for (var t in e || (e = {})) _o.call(e, t) && ir(n, t, e[t]);
      if (nr) {
        var _iterator10 = _createForOfIteratorHelper(nr(e)),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var t = _step10.value;
            ho.call(e, t) && ir(n, t, e[t]);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
      return n;
    };
  function go() {
    var _bt4 = bt({}),
      n = _bt4.subscribe,
      e = _bt4.set,
      t = _bt4.update,
      i = {};
    return {
      subscribe: n,
      getFilesForMessage: function () {
        var _getFilesForMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(r, l) {
          var a, _iterator11, _step11, s;
          return _regeneratorRuntime().wrap(function _callee23$(_context23) {
            while (1) switch (_context23.prev = _context23.next) {
              case 0:
                if (i[r.id]) {
                  _context23.next = 24;
                  break;
                }
                a = {};
                _iterator11 = _createForOfIteratorHelper(r.files.values());
                _context23.prev = 3;
                _iterator11.s();
              case 5:
                if ((_step11 = _iterator11.n()).done) {
                  _context23.next = 15;
                  break;
                }
                s = _step11.value;
                _context23.t0 = (s.content_disposition === "inline" || s.content_id && tr.includes(s.content_type)) && !a[s.id];
                if (!_context23.t0) {
                  _context23.next = 13;
                  break;
                }
                a[s.id] = s;
                _context23.next = 12;
                return er({
                  file_id: s.id,
                  component_id: l.component_id,
                  access_token: l.access_token
                });
              case 12:
                a[s.id].data = _context23.sent;
              case 13:
                _context23.next = 5;
                break;
              case 15:
                _context23.next = 20;
                break;
              case 17:
                _context23.prev = 17;
                _context23.t1 = _context23["catch"](3);
                _iterator11.e(_context23.t1);
              case 20:
                _context23.prev = 20;
                _iterator11.f();
                return _context23.finish(20);
              case 23:
                i[r.id] = a, t(function (s) {
                  return s[r.id] = a, po({}, s);
                });
              case 24:
                return _context23.abrupt("return", i[r.id]);
              case 25:
              case "end":
                return _context23.stop();
            }
          }, _callee23, null, [[3, 17, 20, 23]]);
        }));
        function getFilesForMessage(_x40, _x41) {
          return _getFilesForMessage.apply(this, arguments);
        }
        return getFilesForMessage;
      }(),
      hasInlineFiles: function hasInlineFiles(r) {
        var l;
        return (l = r == null ? void 0 : r.files) == null ? void 0 : l.some(function (a) {
          return a.content_disposition === "inline" || a.content_id && tr.includes(a.content_type);
        });
      },
      reset: function reset() {
        return e({});
      }
    };
  }
  var fi = go();
  function di(n) {
    return function (e, t) {
      n.dispatchEvent && n.dispatchEvent(new CustomEvent(e, {
        detail: t,
        composed: !0
      }));
    };
  }
  function ui(n, e, t) {
    return new Proxy(n, {
      get: function get(i, r) {
        return r === "toString" || r === "toJSON" ? function () {
          return JSON.stringify(i);
        } : Reflect.get(i, r) !== void 0 ? rr(Reflect.get(i, r), t[r]) : e && r in e ? rr(e[r], t[r]) : t[r];
      },
      ownKeys: function ownKeys(i) {
        var r = new Set([].concat(_toConsumableArray(Reflect.ownKeys(i)), _toConsumableArray(Object.keys(e)), _toConsumableArray(Object.keys(t))));
        return Array.from(r);
      },
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(i, r) {
        var l, a;
        var s = Reflect.getOwnPropertyDescriptor(i, r);
        return s || (s = (a = (l = e && Object.getOwnPropertyDescriptor(e, r)) != null ? l : t && Object.getOwnPropertyDescriptor(t, r)) != null ? a : {
          configurable: !0,
          enumerable: !0,
          writable: !0
        }, Reflect.defineProperty(i, r, s)), s;
      }
    });
  }
  function rr(n, e) {
    if (n) {
      if (typeof e == "boolean") return vo(n);
      if (typeof e == "number") return Number(n);
      if (e instanceof Date) return new Date(n);
    }
    return n === void 0 ? e != null ? e : null : n;
  }
  function vo(n) {
    return [!0, "true", "1"].includes(n);
  }
  function bo(n, e) {
    var t;
    var i = Uint8Array.from(atob(n), function (s) {
        return s.charCodeAt(0);
      }),
      r = new Blob([i], {
        type: e.content_type
      }),
      l = window.URL.createObjectURL(r),
      a = document.createElement("a");
    a.href = l, a.download = (t = e.filename) != null ? t : e.id, a.target = "_blank", a.click(), a.remove();
  }
  function ar(n) {
    var e, t, i, r, l, a;
    function s(f, g) {
      if (f[2] === "HostDomainNotAllowedError") return yo;
      if (f[2] === "IncompatibleProperties") return wo;
    }
    var o = s(n),
      _c6 = o && o(n);
    return {
      c: function c() {
        var f, g;
        e = b("div"), _c6 && _c6.c(), t = G(), i = b("span"), i.textContent = "Debug info:", r = G(), l = b("textarea"), d(i, "class", "details"), d(l, "class", "details"), l.readOnly = !0, l.value = a = "      " + n[2] + ": " + n[0] + "\n      " + ((g = (f = n[1].message) == null ? void 0 : f.message) != null ? g : "") + "\n    ", d(e, "class", "message-container");
      },
      m: function m(f, g) {
        p(f, e, g), _c6 && _c6.m(e, null), w(e, t), w(e, i), w(e, r), w(e, l);
      },
      p: function p(f, g) {
        var y, S;
        o === (o = s(f)) && _c6 ? _c6.p(f, g) : (_c6 && _c6.d(1), _c6 = o && o(f), _c6 && (_c6.c(), _c6.m(e, t))), g & 7 && a !== (a = "      " + f[2] + ": " + f[0] + "\n      " + ((S = (y = f[1].message) == null ? void 0 : y.message) != null ? S : "") + "\n    ") && (l.value = a);
      },
      d: function d(f) {
        f && m(e), _c6 && _c6.d();
      }
    };
  }
  function wo(n) {
    var e;
    return {
      c: function c() {
        e = b("h3"), e.textContent = "Your component properties do not work with each other.";
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function yo(n) {
    var e, t, i, r, l, a;
    return {
      c: function c() {
        e = b("h3"), t = x("You are trying to access this component from\xA0\n        "), i = b("code"), i.textContent = "".concat(window.location.hostname), r = x(". The component's settings do not\n        allow access from this domain."), l = G(), a = b("h4"), a.innerHTML = "The list of allowed domains can be modified in your\xA0\n        <a href=\"https://dashboard.nylas.com\">Dashboard</a>.";
      },
      m: function m(s, o) {
        p(s, e, o), w(e, t), w(e, i), w(e, r), p(s, l, o), p(s, a, o);
      },
      p: T,
      d: function d(s) {
        s && m(e), s && m(l), s && m(a);
      }
    };
  }
  function ko(n) {
    var e,
      t = n[2] && n[3] && ar(n);
    return {
      c: function c() {
        t && t.c(), e = Le(), this.c = T;
      },
      m: function m(i, r) {
        t && t.m(i, r), p(i, e, r);
      },
      p: function p(i, _ref18) {
        var _ref19 = _slicedToArray(_ref18, 1),
          r = _ref19[0];
        i[2] && i[3] ? t ? t.p(i, r) : (t = ar(i), t.c(), t.m(e.parentNode, e)) : t && (t.d(1), t = null);
      },
      i: T,
      o: T,
      d: function d(i) {
        t && t.d(i), i && m(e);
      }
    };
  }
  function Eo(n, e, t) {
    var i;
    hn(n, oi, function (y) {
      return t(8, i = y);
    });
    var r, l, a, s;
    var o = e.id,
      c,
      f;
    var g = window.location.href.includes("localhost") || window.location.href.includes("127.0.0.1");
    return n.$$set = function (y) {
      "id" in y && t(0, o = y.id);
    }, n.$$.update = function () {
      n.$$.dirty & 499 && (t(1, c = t(4, r = i[o]) !== null && r !== void 0 ? r : {
        name: ""
      }), t(2, f = t(7, s = t(5, l = c.name) !== null && l !== void 0 ? l : t(6, a = c.message) === null || a === void 0 ? void 0 : a.name) !== null && s !== void 0 ? s : ""));
    }, [o, c, f, g, r, l, a, s, i];
  }
  var To = /*#__PURE__*/function (_rn) {
    function To(e) {
      var _this2;
      _classCallCheck(this, To);
      _this2 = _callSuper(this, To);
      _this2.shadowRoot.innerHTML = "<style>.message-container{background:#fff6f6;border-radius:5px;box-shadow:0 0 0 1px #aa92a0 inset, 0 0 0 0 transparent;color:#9f3a38;font-size:1.25rem;padding:10px;margin:0 auto;transition:opacity 500ms ease, color 500ms ease,\n      background-color 500ms ease, box-shadow 500ms ease,\n      -webkit-box-shadow 500ms ease}.message-container *:focus{outline:5px auto Highlight;outline:5px auto -webkit-focus-ring-color}.details{color:#494949;font-size:0.75rem;width:100%}</style>", Ke(_this2, {
        target: _this2.shadowRoot,
        props: gn(_this2.attributes),
        customElement: !0
      }, Eo, ko, Qa, {
        id: 0
      }, null), e && (e.target && p(e.target, _this2, e.anchor), e.props && (_this2.$set(e.props), fe()));
      return _this2;
    }
    _inherits(To, _rn);
    return _createClass(To, [{
      key: "id",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(e) {
        this.$$set({
          id: e
        }), fe();
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["id"];
      }
    }]);
  }(rn);
  customElements.define("nylas-error", To);
  function lr(n, e, t) {
    return n ? e[t].some(function (i) {
      return i.email.toLowerCase() === n.toLowerCase();
    }) : !1;
  }
  function Ao(n, e) {
    return [].concat(_toConsumableArray(e.from), _toConsumableArray(e.to), _toConsumableArray(e.cc), _toConsumableArray(e.bcc)).filter(function (i) {
      return !n.includes(i.email);
    });
  }
  function Oo(_ref20) {
    var n = _ref20.myEmail,
      e = _ref20.message,
      t = _ref20.type;
    var i;
    var r = [],
      l = [];
    if (r = e.reply_to.filter(function (a) {
      return a.email !== n;
    }), r.length || (lr(n, e, "from") ? r = e.to : r = e.from), t === "reply_all") {
      var a = (i = e.from) == null ? void 0 : i.map(function (s) {
        return s.email;
      });
      l = _toConsumableArray(Ao([].concat(_toConsumableArray(a), [n]), e));
    }
    return {
      to: r,
      cc: l
    };
  }
  var So = Object.defineProperty,
    or = Object.getOwnPropertySymbols,
    Co = Object.prototype.hasOwnProperty,
    No = Object.prototype.propertyIsEnumerable,
    sr = function sr(n, e, t) {
      return e in n ? So(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    cr = function cr(n, e) {
      for (var t in e || (e = {})) Co.call(e, t) && sr(n, t, e[t]);
      if (or) {
        var _iterator12 = _createForOfIteratorHelper(or(e)),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var t = _step12.value;
            No.call(e, t) && sr(n, t, e[t]);
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }
      return n;
    };
  function mi(n, e) {
    return n.map(function (t) {
      return cr(cr({}, t), e);
    });
  }
  function Lo(n) {
    var e,
      t,
      i = [{
        width: "17"
      }, {
        height: "16"
      }, {
        viewBox: "0 0 17 16"
      }, {
        fill: "none"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      r = {};
    for (var l = 0; l < i.length; l += 1) r = ue(r, i[l]);
    return {
      c: function c() {
        e = te("svg"), t = te("path"), this.h();
      },
      l: function l(_l2) {
        e = ie(_l2, "svg", {
          width: !0,
          height: !0,
          viewBox: !0,
          fill: !0,
          xmlns: !0
        });
        var a = ne(e);
        t = ie(a, "path", {
          d: !0,
          stroke: !0,
          "stroke-miterlimit": !0
        }), ne(t).forEach(m), a.forEach(m), this.h();
      },
      h: function h() {
        d(t, "d", "M11.1666 6.66666L8.50094 9.48258L5.83331 6.66666"), d(t, "stroke", "#8d94a5"), d(t, "stroke-miterlimit", "10"), Me(e, r);
      },
      m: function m(l, a) {
        ut(l, e, a), ve(e, t);
      },
      p: function p(l, _ref21) {
        var _ref22 = _slicedToArray(_ref21, 1),
          a = _ref22[0];
        Me(e, r = _t(i, [{
          width: "17"
        }, {
          height: "16"
        }, {
          viewBox: "0 0 17 16"
        }, {
          fill: "none"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, a & 1 && l[0]]));
      },
      i: T,
      o: T,
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function Mo(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var ln = /*#__PURE__*/function (_ht) {
    function ln(e) {
      var _this3;
      _classCallCheck(this, ln);
      _this3 = _callSuper(this, ln);
      Ke(_this3, e, Mo, Lo, Ye, {});
      return _this3;
    }
    _inherits(ln, _ht);
    return _createClass(ln);
  }(ht);
  function Do(n) {
    var e,
      t,
      i = [{
        width: "11"
      }, {
        height: "13"
      }, {
        viewBox: "0 0 11 13"
      }, {
        fill: "none"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      r = {};
    for (var l = 0; l < i.length; l += 1) r = ue(r, i[l]);
    return {
      c: function c() {
        e = te("svg"), t = te("path"), this.h();
      },
      l: function l(_l3) {
        e = ie(_l3, "svg", {
          width: !0,
          height: !0,
          viewBox: !0,
          fill: !0,
          xmlns: !0
        });
        var a = ne(e);
        t = ie(a, "path", {
          d: !0,
          fill: !0
        }), ne(t).forEach(m), a.forEach(m), this.h();
      },
      h: function h() {
        d(t, "d", "M0.75 11.375C0.75 12.0078 1.24219 12.5 1.875 12.5H8.625C9.23438 12.5 9.75 12.0078 9.75 11.375V3.5H0.75V11.375ZM7.125 5.375C7.125 5.1875 7.28906 5 7.5 5C7.6875 5 7.875 5.1875 7.875 5.375V10.625C7.875 10.8359 7.6875 11 7.5 11C7.28906 11 7.125 10.8359 7.125 10.625V5.375ZM4.875 5.375C4.875 5.1875 5.03906 5 5.25 5C5.4375 5 5.625 5.1875 5.625 5.375V10.625C5.625 10.8359 5.4375 11 5.25 11C5.03906 11 4.875 10.8359 4.875 10.625V5.375ZM2.625 5.375C2.625 5.1875 2.78906 5 3 5C3.1875 5 3.375 5.1875 3.375 5.375V10.625C3.375 10.8359 3.1875 11 3 11C2.78906 11 2.625 10.8359 2.625 10.625V5.375ZM10.125 1.25H7.3125L7.07812 0.828125C6.98438 0.640625 6.79688 0.5 6.58594 0.5H3.89062C3.67969 0.5 3.49219 0.640625 3.39844 0.828125L3.1875 1.25H0.375C0.164062 1.25 0 1.4375 0 1.625V2.375C0 2.58594 0.164062 2.75 0.375 2.75H10.125C10.3125 2.75 10.5 2.58594 10.5 2.375V1.625C10.5 1.4375 10.3125 1.25 10.125 1.25Z"), d(t, "fill", "#6A7285"), Me(e, r);
      },
      m: function m(l, a) {
        ut(l, e, a), ve(e, t);
      },
      p: function p(l, _ref23) {
        var _ref24 = _slicedToArray(_ref23, 1),
          a = _ref24[0];
        Me(e, r = _t(i, [{
          width: "11"
        }, {
          height: "13"
        }, {
          viewBox: "0 0 11 13"
        }, {
          fill: "none"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, a & 1 && l[0]]));
      },
      i: T,
      o: T,
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function Po(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var fr = /*#__PURE__*/function (_ht2) {
    function fr(e) {
      var _this4;
      _classCallCheck(this, fr);
      _this4 = _callSuper(this, fr);
      Ke(_this4, e, Po, Do, Ye, {});
      return _this4;
    }
    _inherits(fr, _ht2);
    return _createClass(fr);
  }(ht);
  function Ro(n) {
    var e,
      t,
      i = [{
        width: "12"
      }, {
        height: "13"
      }, {
        viewBox: "0 0 12 13"
      }, {
        fill: "none"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      r = {};
    for (var l = 0; l < i.length; l += 1) r = ue(r, i[l]);
    return {
      c: function c() {
        e = te("svg"), t = te("path"), this.h();
      },
      l: function l(_l4) {
        e = ie(_l4, "svg", {
          width: !0,
          height: !0,
          viewBox: !0,
          fill: !0,
          xmlns: !0
        });
        var a = ne(e);
        t = ie(a, "path", {
          d: !0,
          fill: !0
        }), ne(t).forEach(m), a.forEach(m), this.h();
      },
      h: function h() {
        d(t, "d", "M4.125 5.5625H7.875C8.0625 5.5625 8.25 5.39844 8.25 5.1875V4.8125C8.25 4.625 8.0625 4.4375 7.875 4.4375H4.125C3.91406 4.4375 3.75 4.625 3.75 4.8125V5.1875C3.75 5.39844 3.91406 5.5625 4.125 5.5625ZM3.75 7.4375C3.75 7.64844 3.91406 7.8125 4.125 7.8125H7.875C8.0625 7.8125 8.25 7.64844 8.25 7.4375V7.0625C8.25 6.875 8.0625 6.6875 7.875 6.6875H4.125C3.91406 6.6875 3.75 6.875 3.75 7.0625V7.4375ZM6 10.2969C5.60156 10.2969 5.22656 10.1797 4.89844 9.92188L0 6.38281V11.375C0 12.0078 0.492188 12.5 1.125 12.5H10.875C11.4844 12.5 12 12.0078 12 11.375V6.38281L7.07812 9.92188C6.75 10.1797 6.375 10.2969 6 10.2969ZM11.5547 4.32031C11.3438 4.17969 11.1562 4.01562 10.875 3.80469V2.75C10.875 2.14062 10.3594 1.625 9.75 1.625H7.92188C7.85156 1.57812 7.78125 1.53125 7.71094 1.48438C7.3125 1.20312 6.53906 0.5 6 0.5C5.4375 0.5 4.66406 1.20312 4.26562 1.48438C4.19531 1.53125 4.125 1.57812 4.05469 1.625H2.25C1.61719 1.625 1.125 2.14062 1.125 2.75V3.80469C0.820312 4.01562 0.632812 4.17969 0.421875 4.32031C0.164062 4.53125 0 4.85938 0 5.21094V5.46875L2.25 7.08594V2.75H9.75V7.08594L12 5.46875V5.21094C12 4.85938 11.8359 4.55469 11.5547 4.32031Z"), d(t, "fill", "#6A7285"), Me(e, r);
      },
      m: function m(l, a) {
        ut(l, e, a), ve(e, t);
      },
      p: function p(l, _ref25) {
        var _ref26 = _slicedToArray(_ref25, 1),
          a = _ref26[0];
        Me(e, r = _t(i, [{
          width: "12"
        }, {
          height: "13"
        }, {
          viewBox: "0 0 12 13"
        }, {
          fill: "none"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, a & 1 && l[0]]));
      },
      i: T,
      o: T,
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function Io(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var dr = /*#__PURE__*/function (_ht3) {
    function dr(e) {
      var _this5;
      _classCallCheck(this, dr);
      _this5 = _callSuper(this, dr);
      Ke(_this5, e, Io, Ro, Ye, {});
      return _this5;
    }
    _inherits(dr, _ht3);
    return _createClass(dr);
  }(ht);
  function jo(n) {
    var e,
      t,
      i = [{
        width: "12"
      }, {
        height: "9"
      }, {
        viewBox: "0 0 12 9"
      }, {
        fill: "none"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      r = {};
    for (var l = 0; l < i.length; l += 1) r = ue(r, i[l]);
    return {
      c: function c() {
        e = te("svg"), t = te("path"), this.h();
      },
      l: function l(_l5) {
        e = ie(_l5, "svg", {
          width: !0,
          height: !0,
          viewBox: !0,
          fill: !0,
          xmlns: !0
        });
        var a = ne(e);
        t = ie(a, "path", {
          d: !0,
          fill: !0
        }), ne(t).forEach(m), a.forEach(m), this.h();
      },
      h: function h() {
        d(t, "d", "M11.7656 2.97656C11.2266 3.39844 10.5469 3.91406 8.15625 5.64844C7.6875 6 6.82031 6.77344 6 6.77344C5.15625 6.77344 4.3125 6 3.82031 5.64844C1.42969 3.91406 0.75 3.39844 0.210938 2.97656C0.117188 2.90625 0 2.97656 0 3.09375V7.875C0 8.50781 0.492188 9 1.125 9H10.875C11.4844 9 12 8.50781 12 7.875V3.09375C12 2.97656 11.8594 2.90625 11.7656 2.97656ZM6 6C6.53906 6.02344 7.3125 5.32031 7.71094 5.03906C10.8281 2.78906 11.0625 2.57812 11.7656 2.01562C11.9062 1.92188 12 1.75781 12 1.57031V1.125C12 0.515625 11.4844 0 10.875 0H1.125C0.492188 0 0 0.515625 0 1.125V1.57031C0 1.75781 0.0703125 1.92188 0.210938 2.01562C0.914062 2.57812 1.14844 2.78906 4.26562 5.03906C4.66406 5.32031 5.4375 6.02344 6 6Z"), d(t, "fill", "#6A7285"), Me(e, r);
      },
      m: function m(l, a) {
        ut(l, e, a), ve(e, t);
      },
      p: function p(l, _ref27) {
        var _ref28 = _slicedToArray(_ref27, 1),
          a = _ref28[0];
        Me(e, r = _t(i, [{
          width: "12"
        }, {
          height: "9"
        }, {
          viewBox: "0 0 12 9"
        }, {
          fill: "none"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, a & 1 && l[0]]));
      },
      i: T,
      o: T,
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function Fo(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var ur = /*#__PURE__*/function (_ht4) {
    function ur(e) {
      var _this6;
      _classCallCheck(this, ur);
      _this6 = _callSuper(this, ur);
      Ke(_this6, e, Fo, jo, Ye, {});
      return _this6;
    }
    _inherits(ur, _ht4);
    return _createClass(ur);
  }(ht);
  function Uo(n) {
    var e,
      t,
      i,
      r,
      l = [{
        width: "17"
      }, {
        height: "16"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, {
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, {
        x: "0px"
      }, {
        y: "0px"
      }, {
        viewBox: "0 0 511.36 511.36"
      }, {
        style: "enable-background:new 0 0 511.36 511.36;"
      }, {
        "xml:space": "preserve"
      }, n[0]],
      a = {};
    for (var s = 0; s < l.length; s += 1) a = ue(a, l[s]);
    return {
      c: function c() {
        e = te("svg"), t = te("g"), i = te("g"), r = te("path"), this.h();
      },
      l: function l(s) {
        e = ie(s, "svg", {
          width: !0,
          height: !0,
          xmlns: !0,
          "xmlns:xlink": !0,
          x: !0,
          y: !0,
          viewBox: !0,
          style: !0,
          "xml:space": !0
        });
        var o = ne(e);
        t = ie(o, "g", {});
        var c = ne(t);
        i = ie(c, "g", {});
        var f = ne(i);
        r = ie(f, "path", {
          d: !0
        }), ne(r).forEach(m), f.forEach(m), c.forEach(m), o.forEach(m), this.h();
      },
      h: function h() {
        d(r, "d", "M454.827,35.2c-46.933-46.933-122.027-46.933-168.96,0L63.147,258.773c-3.413,3.413-3.413,8.533,0,11.947\r\n\t\t\ts8.533,3.413,11.947,0l222.72-223.573c40.107-40.107,104.96-40.107,145.067,0c40.107,40.107,40.107,104.96,0,145.067\r\n\t\t\tL162.133,472.96c-28.16,28.16-74.24,28.16-102.4,0c-28.16-28.16-28.16-74.24,0-102.4l226.133-226.987\r\n\t\t\tc17.067-16.213,43.52-17.067,60.587,0c16.213,17.067,16.213,44.373,0,60.587l-168.96,169.813c-3.413,3.413-3.413,8.533,0,11.947\r\n\t\t\tc3.413,3.413,8.533,3.413,11.947,0L358.4,216.96c23.04-23.04,23.04-61.44,0-84.48c-23.04-23.04-61.44-23.04-84.48,0\r\n\t\t\tL47.787,358.613c-34.987,34.133-34.987,91.307,0,126.293c17.067,17.92,40.107,26.453,63.147,26.453\r\n\t\t\tc23.04,0,46.08-8.533,63.147-26.453L454.827,204.16c22.187-22.187,34.987-52.907,34.987-84.48\r\n\t\t\tC489.813,88.107,477.013,57.387,454.827,35.2z"), Me(e, a);
      },
      m: function m(s, o) {
        ut(s, e, o), ve(e, t), ve(t, i), ve(i, r);
      },
      p: function p(s, _ref29) {
        var _ref30 = _slicedToArray(_ref29, 1),
          o = _ref30[0];
        Me(e, a = _t(l, [{
          width: "17"
        }, {
          height: "16"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, {
          "xmlns:xlink": "http://www.w3.org/1999/xlink"
        }, {
          x: "0px"
        }, {
          y: "0px"
        }, {
          viewBox: "0 0 511.36 511.36"
        }, {
          style: "enable-background:new 0 0 511.36 511.36;"
        }, {
          "xml:space": "preserve"
        }, o & 1 && s[0]]));
      },
      i: T,
      o: T,
      d: function d(s) {
        s && m(e);
      }
    };
  }
  function Ho(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var zo = /*#__PURE__*/function (_ht5) {
    function zo(e) {
      var _this7;
      _classCallCheck(this, zo);
      _this7 = _callSuper(this, zo);
      Ke(_this7, e, Ho, Uo, Ye, {});
      return _this7;
    }
    _inherits(zo, _ht5);
    return _createClass(zo);
  }(ht);
  function Bo(n) {
    var e,
      t,
      i,
      r = [{
        width: "24"
      }, {
        height: "24"
      }, {
        viewBox: "0 0 24 24"
      }, {
        fill: "none"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      l = {};
    for (var a = 0; a < r.length; a += 1) l = ue(l, r[a]);
    return {
      c: function c() {
        e = te("svg"), t = te("path"), i = te("path"), this.h();
      },
      l: function l(a) {
        e = ie(a, "svg", {
          width: !0,
          height: !0,
          viewBox: !0,
          fill: !0,
          xmlns: !0
        });
        var s = ne(e);
        t = ie(s, "path", {
          d: !0,
          stroke: !0,
          "stroke-width": !0,
          "stroke-miterlimit": !0
        }), ne(t).forEach(m), i = ie(s, "path", {
          d: !0,
          stroke: !0,
          "stroke-width": !0,
          "stroke-miterlimit": !0
        }), ne(i).forEach(m), s.forEach(m), this.h();
      },
      h: function h() {
        d(t, "d", "M11.7605 17.3029L6.32422 12.1494L11.7605 6.99968"), d(t, "stroke", "#161717"), d(t, "stroke-width", "1.5"), d(t, "stroke-miterlimit", "10"), d(i, "d", "M6.42791 12.1494L18 12.1494"), d(i, "stroke", "#161717"), d(i, "stroke-width", "1.5"), d(i, "stroke-miterlimit", "10"), Me(e, l);
      },
      m: function m(a, s) {
        ut(a, e, s), ve(e, t), ve(e, i);
      },
      p: function p(a, _ref31) {
        var _ref32 = _slicedToArray(_ref31, 1),
          s = _ref32[0];
        Me(e, l = _t(r, [{
          width: "24"
        }, {
          height: "24"
        }, {
          viewBox: "0 0 24 24"
        }, {
          fill: "none"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, s & 1 && a[0]]));
      },
      i: T,
      o: T,
      d: function d(a) {
        a && m(e);
      }
    };
  }
  function Go(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var Vo = /*#__PURE__*/function (_ht6) {
    function Vo(e) {
      var _this8;
      _classCallCheck(this, Vo);
      _this8 = _callSuper(this, Vo);
      Ke(_this8, e, Go, Bo, Ye, {});
      return _this8;
    }
    _inherits(Vo, _ht6);
    return _createClass(Vo);
  }(ht);
  function Wo(n) {
    var e,
      t,
      i = [{
        width: "30"
      }, {
        height: "28"
      }, {
        style: "margin-top:2px"
      }, {
        viewBox: "0 0 20 20"
      }, {
        fill: "none"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      r = {};
    for (var l = 0; l < i.length; l += 1) r = ue(r, i[l]);
    return {
      c: function c() {
        e = te("svg"), t = te("path"), this.h();
      },
      l: function l(_l6) {
        e = ie(_l6, "svg", {
          width: !0,
          height: !0,
          style: !0,
          viewBox: !0,
          fill: !0,
          xmlns: !0
        });
        var a = ne(e);
        t = ie(a, "path", {
          d: !0,
          fill: !0
        }), ne(t).forEach(m), a.forEach(m), this.h();
      },
      h: function h() {
        d(t, "d", "M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3ZM10 12.5C10.4142 12.5 10.75 12.8358 10.75 13.25C10.75 13.6642 10.4142 14 10 14C9.58579 14 9.25 13.6642 9.25 13.25C9.25 12.8358 9.58579 12.5 10 12.5ZM10 6C10.2455 6 10.4496 6.17688 10.4919 6.41012L10.5 6.5V11C10.5 11.2761 10.2761 11.5 10 11.5C9.75454 11.5 9.55039 11.3231 9.50806 11.0899L9.5 11V6.5C9.5 6.22386 9.72386 6 10 6Z"), d(t, "fill", "white"), Me(e, r);
      },
      m: function m(l, a) {
        ut(l, e, a), ve(e, t);
      },
      p: function p(l, _ref33) {
        var _ref34 = _slicedToArray(_ref33, 1),
          a = _ref34[0];
        Me(e, r = _t(i, [{
          width: "30"
        }, {
          height: "28"
        }, {
          style: "margin-top:2px"
        }, {
          viewBox: "0 0 20 20"
        }, {
          fill: "none"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, a & 1 && l[0]]));
      },
      i: T,
      o: T,
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function Jo(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var xo = /*#__PURE__*/function (_ht7) {
    function xo(e) {
      var _this9;
      _classCallCheck(this, xo);
      _this9 = _callSuper(this, xo);
      Ke(_this9, e, Jo, Wo, Ye, {});
      return _this9;
    }
    _inherits(xo, _ht7);
    return _createClass(xo);
  }(ht);
  function Zo(n) {
    var e,
      t,
      i = [{
        width: "16"
      }, {
        height: "16"
      }, {
        viewBox: "0 0 16 16"
      }, {
        fill: "none"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      r = {};
    for (var l = 0; l < i.length; l += 1) r = ue(r, i[l]);
    return {
      c: function c() {
        e = te("svg"), t = te("path"), this.h();
      },
      l: function l(_l7) {
        e = ie(_l7, "svg", {
          width: !0,
          height: !0,
          viewBox: !0,
          fill: !0,
          xmlns: !0
        });
        var a = ne(e);
        t = ie(a, "path", {
          d: !0,
          fill: !0
        }), ne(t).forEach(m), a.forEach(m), this.h();
      },
      h: function h() {
        d(t, "d", "M11.2452 0.817058C12.332 -0.269749 14.0941 -0.269749 15.1809 0.817058C16.2224 1.85858 16.2658 3.52026 15.3111 4.61346L15.1809 4.75273L5.57506 14.3586C5.36997 14.5636 5.12323 14.7212 4.85236 14.821L4.68708 14.8739L0.632111 15.9798C0.285522 16.0743 -0.0345414 15.7857 0.00300655 15.4452L0.0181704 15.3658L1.12407 11.3109C1.20039 11.031 1.33646 10.7718 1.52212 10.5508L1.63939 10.4229L11.2452 0.817058ZM10.385 3.09195L2.34649 11.13C2.2542 11.2223 2.18117 11.3314 2.13111 11.4511L2.08884 11.574L1.2122 14.7847L4.42397 13.9091C4.50791 13.8862 4.58815 13.8526 4.66278 13.8093L4.77028 13.7372L4.86796 13.6515L12.906 5.61295L10.385 3.09195ZM14.4738 1.52417C13.8162 0.866565 12.7727 0.830031 12.0722 1.41457L11.9523 1.52417L11.092 2.38495L13.613 4.90595L14.4738 4.04563C15.1314 3.38803 15.1679 2.34455 14.5834 1.64407L14.4738 1.52417Z"), d(t, "fill", "#ffffff"), Me(e, r);
      },
      m: function m(l, a) {
        ut(l, e, a), ve(e, t);
      },
      p: function p(l, _ref35) {
        var _ref36 = _slicedToArray(_ref35, 1),
          a = _ref36[0];
        Me(e, r = _t(i, [{
          width: "16"
        }, {
          height: "16"
        }, {
          viewBox: "0 0 16 16"
        }, {
          fill: "none"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, a & 1 && l[0]]));
      },
      i: T,
      o: T,
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function Yo(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var mr = /*#__PURE__*/function (_ht8) {
    function mr(e) {
      var _this10;
      _classCallCheck(this, mr);
      _this10 = _callSuper(this, mr);
      Ke(_this10, e, Yo, Zo, Ye, {});
      return _this10;
    }
    _inherits(mr, _ht8);
    return _createClass(mr);
  }(ht);
  function Xo(n) {
    var e,
      t = (n[0].given_name && n[0].surname ? n[0].given_name.charAt(0) + n[0].surname.charAt(0) : n[0].name ? n[0].name.charAt(0) : n[0].email ? n[0].email.charAt(0) : "?") + "",
      i;
    return {
      c: function c() {
        e = b("p"), i = x(t), en(e, "margin", "0");
      },
      m: function m(r, l) {
        p(r, e, l), w(e, i);
      },
      p: function p(r, l) {
        l & 1 && t !== (t = (r[0].given_name && r[0].surname ? r[0].given_name.charAt(0) + r[0].surname.charAt(0) : r[0].name ? r[0].name.charAt(0) : r[0].email ? r[0].email.charAt(0) : "?") + "") && me(i, t);
      },
      d: function d(r) {
        r && m(e);
      }
    };
  }
  function Ko(n) {
    var e, t;
    return {
      c: function c() {
        e = b("img"), d(e, "alt", ""), en(e, "height", n[1]), en(e, "width", n[2]), en(e, "border-radius", "50%"), Ai(e.src, t = "data:image/jpg;base64," + n[3]) || d(e, "src", t);
      },
      m: function m(i, r) {
        p(i, e, r);
      },
      p: function p(i, r) {
        r & 2 && en(e, "height", i[1]), r & 4 && en(e, "width", i[2]), r & 8 && !Ai(e.src, t = "data:image/jpg;base64," + i[3]) && d(e, "src", t);
      },
      d: function d(i) {
        i && m(e);
      }
    };
  }
  function Qo(n) {
    var e;
    function t(l, a) {
      if (l[3]) return Ko;
      if (l[0]) return Xo;
    }
    var i = t(n),
      r = i && i(n);
    return {
      c: function c() {
        r && r.c(), e = Le(), this.c = T;
      },
      m: function m(l, a) {
        r && r.m(l, a), p(l, e, a);
      },
      p: function p(l, _ref37) {
        var _ref38 = _slicedToArray(_ref37, 1),
          a = _ref38[0];
        i === (i = t(l)) && r ? r.p(l, a) : (r && r.d(1), r = i && i(l), r && (r.c(), r.m(e.parentNode, e)));
      },
      i: T,
      o: T,
      d: function d(l) {
        r && r.d(l), l && m(e);
      }
    };
  }
  function $o(n, e, t) {
    var i,
      r = e.contact,
      l = e.contact_query,
      _e$height = e.height,
      a = _e$height === void 0 ? "32px" : _e$height,
      _e$width = e.width,
      s = _e$width === void 0 ? "32px" : _e$width;
    return ll( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
      return _regeneratorRuntime().wrap(function _callee24$(_context24) {
        while (1) switch (_context24.prev = _context24.next) {
          case 0:
            if (!(r && r.picture_url)) {
              _context24.next = 8;
              break;
            }
            _context24.t0 = t;
            _context24.next = 4;
            return no.getContactAvatar(l, r.id);
          case 4:
            _context24.t1 = i = _context24.sent;
            (0, _context24.t0)(3, _context24.t1);
            _context24.next = 9;
            break;
          case 8:
            t(3, i = null);
          case 9:
          case "end":
            return _context24.stop();
        }
      }, _callee24);
    }))), n.$$set = function (o) {
      "contact" in o && t(0, r = o.contact), "contact_query" in o && t(4, l = o.contact_query), "height" in o && t(1, a = o.height), "width" in o && t(2, s = o.width);
    }, t(3, i = null), [r, a, s, i, l];
  }
  var qo = /*#__PURE__*/function (_rn2) {
    function qo(e) {
      var _this11;
      _classCallCheck(this, qo);
      _this11 = _callSuper(this, qo);
      Ke(_this11, {
        target: _this11.shadowRoot,
        props: gn(_this11.attributes),
        customElement: !0
      }, $o, Qo, Ye, {
        contact: 0,
        contact_query: 4,
        height: 1,
        width: 2
      }, null), e && (e.target && p(e.target, _this11, e.anchor), e.props && (_this11.$set(e.props), fe()));
      return _this11;
    }
    _inherits(qo, _rn2);
    return _createClass(qo, [{
      key: "contact",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(e) {
        this.$$set({
          contact: e
        }), fe();
      }
    }, {
      key: "contact_query",
      get: function get() {
        return this.$$.ctx[4];
      },
      set: function set(e) {
        this.$$set({
          contact_query: e
        }), fe();
      }
    }, {
      key: "height",
      get: function get() {
        return this.$$.ctx[1];
      },
      set: function set(e) {
        this.$$set({
          height: e
        }), fe();
      }
    }, {
      key: "width",
      get: function get() {
        return this.$$.ctx[2];
      },
      set: function set(e) {
        this.$$set({
          width: e
        }), fe();
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["contact", "contact_query", "height", "width"];
      }
    }]);
  }(rn);
  customElements.define("nylas-contact-image", qo);
  var _r = function _r(n) {
    return n.content_disposition === "attachment" && !!n.filename && !uo.includes(n.content_type);
  };
  var es = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
  function ts(n, e, t) {
    return t = {
      path: e,
      exports: {},
      require: function require(i, r) {
        return ns(i, r == null ? t.path : r);
      }
    }, n(t, t.exports), t.exports;
  }
  function ns() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }
  var on = ts(function (n, e) {
    /*! @license DOMPurify 2.4.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.0/LICENSE */(function (t, i) {
      n.exports = i();
    })(es, function () {
      function t(R) {
        return t = typeof Symbol == "function" && _typeof(Symbol.iterator) == "symbol" ? function (h) {
          return _typeof(h);
        } : function (h) {
          return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : _typeof(h);
        }, t(R);
      }
      function i(R, h) {
        return i = Object.setPrototypeOf || function (pe, Ne) {
          return pe.__proto__ = Ne, pe;
        }, i(R, h);
      }
      function r() {
        if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
        if (typeof Proxy == "function") return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (R) {
          return !1;
        }
      }
      function l(R, h, $) {
        return r() ? l = Reflect.construct : l = function l(Ne, gt, et) {
          var dt = [null];
          dt.push.apply(dt, gt);
          var At = Function.bind.apply(Ne, dt),
            Nt = new At();
          return et && i(Nt, et.prototype), Nt;
        }, l.apply(null, arguments);
      }
      function a(R) {
        return s(R) || o(R) || c(R) || g();
      }
      function s(R) {
        if (Array.isArray(R)) return f(R);
      }
      function o(R) {
        if (typeof Symbol != "undefined" && R[Symbol.iterator] != null || R["@@iterator"] != null) return Array.from(R);
      }
      function c(R, h) {
        if (!!R) {
          if (typeof R == "string") return f(R, h);
          var $ = Object.prototype.toString.call(R).slice(8, -1);
          if ($ === "Object" && R.constructor && ($ = R.constructor.name), $ === "Map" || $ === "Set") return Array.from(R);
          if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($)) return f(R, h);
        }
      }
      function f(R, h) {
        (h == null || h > R.length) && (h = R.length);
        for (var $ = 0, pe = new Array(h); $ < h; $++) pe[$] = R[$];
        return pe;
      }
      function g() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var y = Object.hasOwnProperty,
        S = Object.setPrototypeOf,
        k = Object.isFrozen,
        L = Object.getPrototypeOf,
        j = Object.getOwnPropertyDescriptor,
        E = Object.freeze,
        O = Object.seal,
        B = Object.create,
        ae = typeof Reflect != "undefined" && Reflect,
        V = ae.apply,
        Q = ae.construct;
      V || (V = function V(h, $, pe) {
        return h.apply($, pe);
      }), E || (E = function E(h) {
        return h;
      }), O || (O = function O(h) {
        return h;
      }), Q || (Q = function Q(h, $) {
        return l(h, a($));
      });
      var z = de(Array.prototype.forEach),
        Y = de(Array.prototype.pop),
        A = de(Array.prototype.push),
        W = de(String.prototype.toLowerCase),
        Oe = de(String.prototype.match),
        _e = de(String.prototype.replace),
        se = de(String.prototype.indexOf),
        re = de(String.prototype.trim),
        J = de(RegExp.prototype.test),
        q = ee(TypeError);
      function de(R) {
        return function (h) {
          for (var $ = arguments.length, pe = new Array($ > 1 ? $ - 1 : 0), Ne = 1; Ne < $; Ne++) pe[Ne - 1] = arguments[Ne];
          return V(R, h, pe);
        };
      }
      function ee(R) {
        return function () {
          for (var h = arguments.length, $ = new Array(h), pe = 0; pe < h; pe++) $[pe] = arguments[pe];
          return Q(R, $);
        };
      }
      function Z(R, h, $) {
        $ = $ || W, S && S(R, null);
        for (var pe = h.length; pe--;) {
          var Ne = h[pe];
          if (typeof Ne == "string") {
            var gt = $(Ne);
            gt !== Ne && (k(h) || (h[pe] = gt), Ne = gt);
          }
          R[Ne] = !0;
        }
        return R;
      }
      function he(R) {
        var h = B(null),
          $;
        for ($ in R) V(y, R, [$]) && (h[$] = R[$]);
        return h;
      }
      function le(R, h) {
        for (; R !== null;) {
          var $ = j(R, h);
          if ($) {
            if ($.get) return de($.get);
            if (typeof $.value == "function") return de($.value);
          }
          R = L(R);
        }
        function pe(Ne) {
          return console.warn("fallback value for", Ne), null;
        }
        return pe;
      }
      var ke = E(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
        D = E(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
        ce = E(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
        xe = E(["animate", "color-profile", "cursor", "discard", "fedropshadow", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
        P = E(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]),
        oe = E(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
        N = E(["#text"]),
        pt = E(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]),
        ct = E(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
        it = E(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
        $e = E(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
        Ce = O(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
        be = O(/<%[\w\W]*|[\w\W]*%>/gm),
        qe = O(/^data-[\-\w.\u00B7-\uFFFF]/),
        Zt = O(/^aria-[\-\w]+$/),
        Ct = O(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
        Yt = O(/^(?:\w+script|data):/i),
        Ut = O(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
        wt = O(/^html$/i),
        Et = function Et() {
          return typeof window == "undefined" ? null : window;
        },
        Tt = function Tt(h, $) {
          if (t(h) !== "object" || typeof h.createPolicy != "function") return null;
          var pe = null,
            Ne = "data-tt-policy-suffix";
          $.currentScript && $.currentScript.hasAttribute(Ne) && (pe = $.currentScript.getAttribute(Ne));
          var gt = "dompurify" + (pe ? "#" + pe : "");
          try {
            return h.createPolicy(gt, {
              createHTML: function createHTML(dt) {
                return dt;
              },
              createScriptURL: function createScriptURL(dt) {
                return dt;
              }
            });
          } catch (et) {
            return console.warn("TrustedTypes policy " + gt + " could not be created."), null;
          }
        };
      function yn() {
        var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Et(),
          h = function h(_) {
            return yn(_);
          };
        if (h.version = "2.4.0", h.removed = [], !R || !R.document || R.document.nodeType !== 9) return h.isSupported = !1, h;
        var $ = R.document,
          pe = R.document,
          Ne = R.DocumentFragment,
          gt = R.HTMLTemplateElement,
          et = R.Node,
          dt = R.Element,
          At = R.NodeFilter,
          Nt = R.NamedNodeMap,
          Gn = Nt === void 0 ? R.NamedNodeMap || R.MozNamedAttrMap : Nt,
          _i = R.HTMLFormElement,
          Vn = R.DOMParser,
          cn = R.trustedTypes,
          fn = dt.prototype,
          hi = le(fn, "cloneNode"),
          pi = le(fn, "nextSibling"),
          Xt = le(fn, "childNodes"),
          Kt = le(fn, "parentNode");
        if (typeof gt == "function") {
          var kn = pe.createElement("template");
          kn.content && kn.content.ownerDocument && (pe = kn.content.ownerDocument);
        }
        var rt = Tt(cn, $),
          En = rt ? rt.createHTML("") : "",
          yt = pe,
          Tn = yt.implementation,
          Wn = yt.createNodeIterator,
          Jn = yt.createDocumentFragment,
          xn = yt.getElementsByTagName,
          gi = $.importNode,
          Zn = {};
        try {
          Zn = he(pe).documentMode ? pe.documentMode : {};
        } catch (K) {}
        var at = {};
        h.isSupported = typeof Kt == "function" && Tn && typeof Tn.createHTMLDocument != "undefined" && Zn !== 9;
        var An = Ce,
          On = be,
          Yn = qe,
          Xn = Zt,
          vi = Yt,
          Sn = Ut,
          Qt = Ct,
          ze = null,
          Ht = Z({}, [].concat(a(ke), a(D), a(ce), a(P), a(N))),
          Ue = null,
          Cn = Z({}, [].concat(a(pt), a(ct), a(it), a($e))),
          Ie = Object.seal(Object.create(null, {
            tagNameCheck: {
              writable: !0,
              configurable: !1,
              enumerable: !0,
              value: null
            },
            attributeNameCheck: {
              writable: !0,
              configurable: !1,
              enumerable: !0,
              value: null
            },
            allowCustomizedBuiltInElements: {
              writable: !0,
              configurable: !1,
              enumerable: !0,
              value: !1
            }
          })),
          Lt = null,
          Nn = null,
          Kn = !0,
          Ln = !0,
          Qn = !1,
          zt = !1,
          Mt = !1,
          Mn = !1,
          Dn = !1,
          Bt = !1,
          dn = !1,
          un = !1,
          $n = !0,
          qn = !1,
          bi = "user-content-",
          Pn = !0,
          $t = !1,
          Gt = {},
          Vt = null,
          u = Z({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]),
          v = null,
          I = Z({}, ["audio", "video", "img", "source", "image", "track"]),
          X = null,
          De = Z({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
          we = "http://www.w3.org/1998/Math/MathML",
          je = "http://www.w3.org/2000/svg",
          vt = "http://www.w3.org/1999/xhtml",
          Wt = vt,
          Dt = !1,
          Ze,
          Ot = ["application/xhtml+xml", "text/html"],
          qt = "text/html",
          Pe,
          mn = null,
          Yc = pe.createElement("form"),
          za = function za(_) {
            return _ instanceof RegExp || _ instanceof Function;
          },
          wi = function wi(_) {
            mn && mn === _ || ((!_ || t(_) !== "object") && (_ = {}), _ = he(_), Ze = Ot.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? Ze = qt : Ze = _.PARSER_MEDIA_TYPE, Pe = Ze === "application/xhtml+xml" ? function (M) {
              return M;
            } : W, ze = "ALLOWED_TAGS" in _ ? Z({}, _.ALLOWED_TAGS, Pe) : Ht, Ue = "ALLOWED_ATTR" in _ ? Z({}, _.ALLOWED_ATTR, Pe) : Cn, X = "ADD_URI_SAFE_ATTR" in _ ? Z(he(De), _.ADD_URI_SAFE_ATTR, Pe) : De, v = "ADD_DATA_URI_TAGS" in _ ? Z(he(I), _.ADD_DATA_URI_TAGS, Pe) : I, Vt = "FORBID_CONTENTS" in _ ? Z({}, _.FORBID_CONTENTS, Pe) : u, Lt = "FORBID_TAGS" in _ ? Z({}, _.FORBID_TAGS, Pe) : {}, Nn = "FORBID_ATTR" in _ ? Z({}, _.FORBID_ATTR, Pe) : {}, Gt = "USE_PROFILES" in _ ? _.USE_PROFILES : !1, Kn = _.ALLOW_ARIA_ATTR !== !1, Ln = _.ALLOW_DATA_ATTR !== !1, Qn = _.ALLOW_UNKNOWN_PROTOCOLS || !1, zt = _.SAFE_FOR_TEMPLATES || !1, Mt = _.WHOLE_DOCUMENT || !1, Bt = _.RETURN_DOM || !1, dn = _.RETURN_DOM_FRAGMENT || !1, un = _.RETURN_TRUSTED_TYPE || !1, Dn = _.FORCE_BODY || !1, $n = _.SANITIZE_DOM !== !1, qn = _.SANITIZE_NAMED_PROPS || !1, Pn = _.KEEP_CONTENT !== !1, $t = _.IN_PLACE || !1, Qt = _.ALLOWED_URI_REGEXP || Qt, Wt = _.NAMESPACE || vt, _.CUSTOM_ELEMENT_HANDLING && za(_.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Ie.tagNameCheck = _.CUSTOM_ELEMENT_HANDLING.tagNameCheck), _.CUSTOM_ELEMENT_HANDLING && za(_.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Ie.attributeNameCheck = _.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), _.CUSTOM_ELEMENT_HANDLING && typeof _.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Ie.allowCustomizedBuiltInElements = _.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), zt && (Ln = !1), dn && (Bt = !0), Gt && (ze = Z({}, a(N)), Ue = [], Gt.html === !0 && (Z(ze, ke), Z(Ue, pt)), Gt.svg === !0 && (Z(ze, D), Z(Ue, ct), Z(Ue, $e)), Gt.svgFilters === !0 && (Z(ze, ce), Z(Ue, ct), Z(Ue, $e)), Gt.mathMl === !0 && (Z(ze, P), Z(Ue, it), Z(Ue, $e))), _.ADD_TAGS && (ze === Ht && (ze = he(ze)), Z(ze, _.ADD_TAGS, Pe)), _.ADD_ATTR && (Ue === Cn && (Ue = he(Ue)), Z(Ue, _.ADD_ATTR, Pe)), _.ADD_URI_SAFE_ATTR && Z(X, _.ADD_URI_SAFE_ATTR, Pe), _.FORBID_CONTENTS && (Vt === u && (Vt = he(Vt)), Z(Vt, _.FORBID_CONTENTS, Pe)), Pn && (ze["#text"] = !0), Mt && Z(ze, ["html", "head", "body"]), ze.table && (Z(ze, ["tbody"]), delete Lt.tbody), E && E(_), mn = _);
          },
          Ba = Z({}, ["mi", "mo", "mn", "ms", "mtext"]),
          Ga = Z({}, ["foreignobject", "desc", "title", "annotation-xml"]),
          Xc = Z({}, ["title", "style", "font", "a", "script"]),
          ei = Z({}, D);
        Z(ei, ce), Z(ei, xe);
        var yi = Z({}, P);
        Z(yi, oe);
        var Kc = function Kc(_) {
            var M = Kt(_);
            (!M || !M.tagName) && (M = {
              namespaceURI: vt,
              tagName: "template"
            });
            var H = W(_.tagName),
              ye = W(M.tagName);
            return _.namespaceURI === je ? M.namespaceURI === vt ? H === "svg" : M.namespaceURI === we ? H === "svg" && (ye === "annotation-xml" || Ba[ye]) : Boolean(ei[H]) : _.namespaceURI === we ? M.namespaceURI === vt ? H === "math" : M.namespaceURI === je ? H === "math" && Ga[ye] : Boolean(yi[H]) : _.namespaceURI === vt ? M.namespaceURI === je && !Ga[ye] || M.namespaceURI === we && !Ba[ye] ? !1 : !yi[H] && (Xc[H] || !ei[H]) : !1;
          },
          Pt = function Pt(_) {
            A(h.removed, {
              element: _
            });
            try {
              _.parentNode.removeChild(_);
            } catch (M) {
              try {
                _.outerHTML = En;
              } catch (H) {
                _.remove();
              }
            }
          },
          ki = function ki(_, M) {
            try {
              A(h.removed, {
                attribute: M.getAttributeNode(_),
                from: M
              });
            } catch (H) {
              A(h.removed, {
                attribute: null,
                from: M
              });
            }
            if (M.removeAttribute(_), _ === "is" && !Ue[_]) if (Bt || dn) try {
              Pt(M);
            } catch (H) {} else try {
              M.setAttribute(_, "");
            } catch (H) {}
          },
          Va = function Va(_) {
            var M, H;
            if (Dn) _ = "<remove></remove>" + _;else {
              var ye = Oe(_, /^[\r\n\t ]+/);
              H = ye && ye[0];
            }
            Ze === "application/xhtml+xml" && (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + "</body></html>");
            var lt = rt ? rt.createHTML(_) : _;
            if (Wt === vt) try {
              M = new Vn().parseFromString(lt, Ze);
            } catch (Qe) {}
            if (!M || !M.documentElement) {
              M = Tn.createDocument(Wt, "template", null);
              try {
                M.documentElement.innerHTML = Dt ? "" : lt;
              } catch (Qe) {}
            }
            var tt = M.body || M.documentElement;
            return _ && H && tt.insertBefore(pe.createTextNode(H), tt.childNodes[0] || null), Wt === vt ? xn.call(M, Mt ? "html" : "body")[0] : Mt ? M.documentElement : tt;
          },
          Wa = function Wa(_) {
            return Wn.call(_.ownerDocument || _, _, At.SHOW_ELEMENT | At.SHOW_COMMENT | At.SHOW_TEXT, null, !1);
          },
          Qc = function Qc(_) {
            return _ instanceof _i && (typeof _.nodeName != "string" || typeof _.textContent != "string" || typeof _.removeChild != "function" || !(_.attributes instanceof Gn) || typeof _.removeAttribute != "function" || typeof _.setAttribute != "function" || typeof _.namespaceURI != "string" || typeof _.insertBefore != "function");
          },
          Rn = function Rn(_) {
            return t(et) === "object" ? _ instanceof et : _ && t(_) === "object" && typeof _.nodeType == "number" && typeof _.nodeName == "string";
          },
          Rt = function Rt(_, M, H) {
            !at[_] || z(at[_], function (ye) {
              ye.call(h, M, H, mn);
            });
          },
          Ja = function Ja(_) {
            var M;
            if (Rt("beforeSanitizeElements", _, null), Qc(_) || J(/[\u0080-\uFFFF]/, _.nodeName)) return Pt(_), !0;
            var H = Pe(_.nodeName);
            if (Rt("uponSanitizeElement", _, {
              tagName: H,
              allowedTags: ze
            }), _.hasChildNodes() && !Rn(_.firstElementChild) && (!Rn(_.content) || !Rn(_.content.firstElementChild)) && J(/<[/\w]/g, _.innerHTML) && J(/<[/\w]/g, _.textContent) || H === "select" && J(/<template/i, _.innerHTML)) return Pt(_), !0;
            if (!ze[H] || Lt[H]) {
              if (!Lt[H] && Za(H) && (Ie.tagNameCheck instanceof RegExp && J(Ie.tagNameCheck, H) || Ie.tagNameCheck instanceof Function && Ie.tagNameCheck(H))) return !1;
              if (Pn && !Vt[H]) {
                var ye = Kt(_) || _.parentNode,
                  lt = Xt(_) || _.childNodes;
                if (lt && ye) for (var tt = lt.length, Qe = tt - 1; Qe >= 0; --Qe) ye.insertBefore(hi(lt[Qe], !0), pi(_));
              }
              return Pt(_), !0;
            }
            return _ instanceof dt && !Kc(_) || (H === "noscript" || H === "noembed") && J(/<\/no(script|embed)/i, _.innerHTML) ? (Pt(_), !0) : (zt && _.nodeType === 3 && (M = _.textContent, M = _e(M, An, " "), M = _e(M, On, " "), _.textContent !== M && (A(h.removed, {
              element: _.cloneNode()
            }), _.textContent = M)), Rt("afterSanitizeElements", _, null), !1);
          },
          xa = function xa(_, M, H) {
            if ($n && (M === "id" || M === "name") && (H in pe || H in Yc)) return !1;
            if (!(Ln && !Nn[M] && J(Yn, M))) {
              if (!(Kn && J(Xn, M))) {
                if (!Ue[M] || Nn[M]) {
                  if (!(Za(_) && (Ie.tagNameCheck instanceof RegExp && J(Ie.tagNameCheck, _) || Ie.tagNameCheck instanceof Function && Ie.tagNameCheck(_)) && (Ie.attributeNameCheck instanceof RegExp && J(Ie.attributeNameCheck, M) || Ie.attributeNameCheck instanceof Function && Ie.attributeNameCheck(M)) || M === "is" && Ie.allowCustomizedBuiltInElements && (Ie.tagNameCheck instanceof RegExp && J(Ie.tagNameCheck, H) || Ie.tagNameCheck instanceof Function && Ie.tagNameCheck(H)))) return !1;
                } else if (!X[M]) {
                  if (!J(Qt, _e(H, Sn, ""))) {
                    if (!((M === "src" || M === "xlink:href" || M === "href") && _ !== "script" && se(H, "data:") === 0 && v[_])) {
                      if (!(Qn && !J(vi, _e(H, Sn, "")))) {
                        if (H) return !1;
                      }
                    }
                  }
                }
              }
            }
            return !0;
          },
          Za = function Za(_) {
            return _.indexOf("-") > 0;
          },
          Ya = function Ya(_) {
            var M, H, ye, lt;
            Rt("beforeSanitizeAttributes", _, null);
            var tt = _.attributes;
            if (!!tt) {
              var Qe = {
                attrName: "",
                attrValue: "",
                keepAttr: !0,
                allowedAttributes: Ue
              };
              for (lt = tt.length; lt--;) {
                M = tt[lt];
                var ti = M,
                  nt = ti.name,
                  Ei = ti.namespaceURI;
                if (H = nt === "value" ? M.value : re(M.value), ye = Pe(nt), Qe.attrName = ye, Qe.attrValue = H, Qe.keepAttr = !0, Qe.forceKeepAttr = void 0, Rt("uponSanitizeAttribute", _, Qe), H = Qe.attrValue, !Qe.forceKeepAttr && (ki(nt, _), !!Qe.keepAttr)) {
                  if (J(/\/>/i, H)) {
                    ki(nt, _);
                    continue;
                  }
                  zt && (H = _e(H, An, " "), H = _e(H, On, " "));
                  var Xa = Pe(_.nodeName);
                  if (!!xa(Xa, ye, H)) {
                    if (qn && (ye === "id" || ye === "name") && (ki(nt, _), H = bi + H), rt && t(cn) === "object" && typeof cn.getAttributeType == "function" && !Ei) switch (cn.getAttributeType(Xa, ye)) {
                      case "TrustedHTML":
                        H = rt.createHTML(H);
                        break;
                      case "TrustedScriptURL":
                        H = rt.createScriptURL(H);
                        break;
                    }
                    try {
                      Ei ? _.setAttributeNS(Ei, nt, H) : _.setAttribute(nt, H), Y(h.removed);
                    } catch (qc) {}
                  }
                }
              }
              Rt("afterSanitizeAttributes", _, null);
            }
          },
          $c = function K(_) {
            var M,
              H = Wa(_);
            for (Rt("beforeSanitizeShadowDOM", _, null); M = H.nextNode();) Rt("uponSanitizeShadowNode", M, null), !Ja(M) && (M.content instanceof Ne && K(M.content), Ya(M));
            Rt("afterSanitizeShadowDOM", _, null);
          };
        return h.sanitize = function (K) {
          var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
            M,
            H,
            ye,
            lt,
            tt;
          if (Dt = !K, Dt && (K = "<!-->"), typeof K != "string" && !Rn(K)) {
            if (typeof K.toString != "function") throw q("toString is not a function");
            if (K = K.toString(), typeof K != "string") throw q("dirty is not a string, aborting");
          }
          if (!h.isSupported) {
            if (t(R.toStaticHTML) === "object" || typeof R.toStaticHTML == "function") {
              if (typeof K == "string") return R.toStaticHTML(K);
              if (Rn(K)) return R.toStaticHTML(K.outerHTML);
            }
            return K;
          }
          if (Mn || wi(_), h.removed = [], typeof K == "string" && ($t = !1), $t) {
            if (K.nodeName) {
              var Qe = Pe(K.nodeName);
              if (!ze[Qe] || Lt[Qe]) throw q("root node is forbidden and cannot be sanitized in-place");
            }
          } else if (K instanceof et) M = Va("<!---->"), H = M.ownerDocument.importNode(K, !0), H.nodeType === 1 && H.nodeName === "BODY" || H.nodeName === "HTML" ? M = H : M.appendChild(H);else {
            if (!Bt && !zt && !Mt && K.indexOf("<") === -1) return rt && un ? rt.createHTML(K) : K;
            if (M = Va(K), !M) return Bt ? null : un ? En : "";
          }
          M && Dn && Pt(M.firstChild);
          for (var ti = Wa($t ? K : M); ye = ti.nextNode();) ye.nodeType === 3 && ye === lt || Ja(ye) || (ye.content instanceof Ne && $c(ye.content), Ya(ye), lt = ye);
          if (lt = null, $t) return K;
          if (Bt) {
            if (dn) for (tt = Jn.call(M.ownerDocument); M.firstChild;) tt.appendChild(M.firstChild);else tt = M;
            return Ue.shadowroot && (tt = gi.call($, tt, !0)), tt;
          }
          var nt = Mt ? M.outerHTML : M.innerHTML;
          return Mt && ze["!doctype"] && M.ownerDocument && M.ownerDocument.doctype && M.ownerDocument.doctype.name && J(wt, M.ownerDocument.doctype.name) && (nt = "<!DOCTYPE " + M.ownerDocument.doctype.name + ">\n" + nt), zt && (nt = _e(nt, An, " "), nt = _e(nt, On, " ")), rt && un ? rt.createHTML(nt) : nt;
        }, h.setConfig = function (K) {
          wi(K), Mn = !0;
        }, h.clearConfig = function () {
          mn = null, Mn = !1;
        }, h.isValidAttribute = function (K, _, M) {
          mn || wi({});
          var H = Pe(K),
            ye = Pe(_);
          return xa(H, ye, M);
        }, h.addHook = function (K, _) {
          typeof _ == "function" && (at[K] = at[K] || [], A(at[K], _));
        }, h.removeHook = function (K) {
          if (at[K]) return Y(at[K]);
        }, h.removeHooks = function (K) {
          at[K] && (at[K] = []);
        }, h.removeAllHooks = function () {
          at = {};
        }, h;
      }
      var ft = yn();
      return ft;
    });
  });
  function hr(n, e, t) {
    var i = n.slice();
    return i[6] = e[t], i;
  }
  function pr(n) {
    var e,
      t,
      i = n[2] && Array.isArray(n[2]) && n[2].length > 0,
      r = _typeof(n[1]) !== null && gr(n),
      l = i && vr(n);
    return {
      c: function c() {
        r && r.c(), e = G(), t = b("div"), l && l.c(), d(t, "class", "attachment");
      },
      m: function m(a, s) {
        r && r.m(a, s), p(a, e, s), p(a, t, s), l && l.m(t, null);
      },
      p: function p(a, s) {
        _typeof(a[1]) !== null ? r ? r.p(a, s) : (r = gr(a), r.c(), r.m(e.parentNode, e)) : r && (r.d(1), r = null), s & 4 && (i = a[2] && Array.isArray(a[2]) && a[2].length > 0), i ? l ? l.p(a, s) : (l = vr(a), l.c(), l.m(t, null)) : l && (l.d(1), l = null);
      },
      d: function d(a) {
        r && r.d(a), a && m(e), a && m(t), l && l.d();
      }
    };
  }
  function gr(n) {
    var e,
      t = on.sanitize(n[1]) + "",
      i;
    return {
      c: function c() {
        e = new pn(!1), i = Le(), e.a = i;
      },
      m: function m(r, l) {
        e.m(t, r, l), p(r, i, l);
      },
      p: function p(r, l) {
        l & 2 && t !== (t = on.sanitize(r[1]) + "") && e.p(t);
      },
      d: function d(r) {
        r && m(i), r && e.d();
      }
    };
  }
  function vr(n) {
    var e,
      t = n[2],
      i = [];
    for (var r = 0; r < t.length; r += 1) i[r] = br(hr(n, t, r));
    return {
      c: function c() {
        for (var _r2 = 0; _r2 < i.length; _r2 += 1) i[_r2].c();
        e = Le();
      },
      m: function m(r, l) {
        for (var a = 0; a < i.length; a += 1) i[a].m(r, l);
        p(r, e, l);
      },
      p: function p(r, l) {
        if (l & 12) {
          t = r[2];
          var a;
          for (a = 0; a < t.length; a += 1) {
            var s = hr(r, t, a);
            i[a] ? i[a].p(s, l) : (i[a] = br(s), i[a].c(), i[a].m(e.parentNode, e));
          }
          for (; a < i.length; a += 1) i[a].d(1);
          i.length = t.length;
        }
      },
      d: function d(r) {
        kt(i, r), r && m(e);
      }
    };
  }
  function br(n) {
    var e,
      t = (n[6].filename || n[6].id) + "",
      i,
      r,
      l,
      a;
    function s() {
      var _n2;
      for (var _len3 = arguments.length, o = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        o[_key3] = arguments[_key3];
      }
      return (_n2 = n)[4].apply(_n2, [n[6]].concat(o));
    }
    return {
      c: function c() {
        e = b("button"), i = x(t), r = G();
      },
      m: function m(o, c) {
        p(o, e, c), w(e, i), w(e, r), l || (a = ge(e, "click", Xe(s)), l = !0);
      },
      p: function p(o, c) {
        n = o, c & 4 && t !== (t = (n[6].filename || n[6].id) + "") && me(i, t);
      },
      d: function d(o) {
        o && m(e), l = !1, a();
      }
    };
  }
  function is(n) {
    var e,
      t = n[0] && pr(n);
    return {
      c: function c() {
        e = b("div"), t && t.c(), this.c = T;
      },
      m: function m(i, r) {
        p(i, e, r), t && t.m(e, null);
      },
      p: function p(i, _ref40) {
        var _ref41 = _slicedToArray(_ref40, 1),
          r = _ref41[0];
        i[0] ? t ? t.p(i, r) : (t = pr(i), t.c(), t.m(e, null)) : t && (t.d(1), t = null);
      },
      i: T,
      o: T,
      d: function d(i) {
        i && m(e), t && t.d();
      }
    };
  }
  function rs(n, e, t) {
    var i = e.message,
      r = e.body;
    var l = di(tn());
    function a(_x42, _x43) {
      return _a4.apply(this, arguments);
    }
    function _a4() {
      _a4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(c, f) {
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              c.stopImmediatePropagation(), l("downloadClicked", {
                event: c,
                message: i,
                file: f
              });
            case 1:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }));
      return _a4.apply(this, arguments);
    }
    var s = [];
    Ci(function () {
      if (i && i.files.length > 0) {
        var _iterator13 = _createForOfIteratorHelper(i.files.entries()),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _ref42 = _step13.value;
            var _ref43 = _slicedToArray(_ref42, 2);
            var c = _ref43[0];
            var f = _ref43[1];
            _r(f) && t(2, s = [].concat(_toConsumableArray(s), [i.files[c]]));
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }
    });
    var o = function o(c, f) {
      return a(f, c);
    };
    return n.$$set = function (c) {
      "message" in c && t(0, i = c.message), "body" in c && t(1, r = c.body);
    }, [i, r, s, a, o];
  }
  var as = /*#__PURE__*/function (_rn3) {
    function as(e) {
      var _this12;
      _classCallCheck(this, as);
      _this12 = _callSuper(this, as);
      _this12.shadowRoot.innerHTML = "<style>div{width:inherit}div div.attachment{margin:1rem 0 0 0;display:flex;gap:0.5rem}div div.attachment button{height:fit-content;width:max-content;padding:0.3rem 1rem;border:1px solid var(--grey);border-radius:30px;background:white;cursor:pointer}div div.attachment button:hover{background:var(--grey-light)}</style>", Ke(_this12, {
        target: _this12.shadowRoot,
        props: gn(_this12.attributes),
        customElement: !0
      }, rs, is, Ye, {
        message: 0,
        body: 1
      }, null), e && (e.target && p(e.target, _this12, e.anchor), e.props && (_this12.$set(e.props), fe()));
      return _this12;
    }
    _inherits(as, _rn3);
    return _createClass(as, [{
      key: "message",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(e) {
        this.$$set({
          message: e
        }), fe();
      }
    }, {
      key: "body",
      get: function get() {
        return this.$$.ctx[1];
      },
      set: function set(e) {
        this.$$set({
          body: e
        }), fe();
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["message", "body"];
      }
    }]);
  }(rn);
  customElements.define("nylas-message-body", as);
  function wr(n) {
    var e, t;
    return {
      c: function c() {
        e = b("p"), t = x(n[3]);
      },
      m: function m(i, r) {
        p(i, e, r), w(e, t);
      },
      p: function p(i, r) {
        r & 8 && me(t, i[3]);
      },
      d: function d(i) {
        i && m(e);
      }
    };
  }
  function yr(n) {
    var e, t, _i2;
    var r = n[2];
    function l(a) {
      return {
        props: {
          "aria-hidden": "true"
        }
      };
    }
    return r && (t = new r(l())), {
      c: function c() {
        e = b("div"), t && He(t.$$.fragment), d(e, "class", "icon-container"), Ae(e, "reverse-icon", n[2] && n[4]);
      },
      m: function m(a, s) {
        p(a, e, s), t && Fe(t, e, null), _i2 = !0;
      },
      p: function p(a, s) {
        if (r !== (r = a[2])) {
          if (t) {
            Ee();
            var o = t;
            F(o.$$.fragment, 1, 0, function () {
              Re(o, 1);
            }), Te();
          }
          r ? (t = new r(l()), He(t.$$.fragment), C(t.$$.fragment, 1), Fe(t, e, null)) : t = null;
        }
        s & 20 && Ae(e, "reverse-icon", a[2] && a[4]);
      },
      i: function i(a) {
        _i2 || (t && C(t.$$.fragment, a), _i2 = !0);
      },
      o: function o(a) {
        t && F(t.$$.fragment, a), _i2 = !1;
      },
      d: function d(a) {
        a && m(e), t && Re(t);
      }
    };
  }
  function kr(n) {
    var e, t;
    return {
      c: function c() {
        e = b("p"), t = x(n[0]), d(e, "id", n[1]), d(e, "role", "tooltip"), d(e, "tabindex", "0"), d(e, "class", "tooltip");
      },
      m: function m(i, r) {
        p(i, e, r), w(e, t);
      },
      p: function p(i, r) {
        r & 1 && me(t, i[0]), r & 2 && d(e, "id", i[1]);
      },
      d: function d(i) {
        i && m(e);
      }
    };
  }
  function ls(n) {
    var e,
      t,
      i,
      r,
      l,
      a,
      s,
      _o8,
      c,
      f,
      g = n[3] && wr(n),
      y = n[2] && yr(n),
      S = n[4] && kr(n);
    return {
      c: function c() {
        e = b("button"), g && g.c(), t = G(), y && y.c(), a = G(), S && S.c(), s = Le(), this.c = T, d(e, "class", "tooltip-trigger"), d(e, "aria-expanded", i = n[4] ? "true" : "false"), d(e, "id", r = n[1] ? "tooltip-trigger-".concat(n[1]) : ""), d(e, "aria-describedby", n[1]), d(e, "aria-label", l = n[4] ? "hide email" : "show email");
      },
      m: function m(k, L) {
        p(k, e, L), g && g.m(e, null), w(e, t), y && y.m(e, null), p(k, a, L), S && S.m(k, L), p(k, s, L), _o8 = !0, c || (f = ge(e, "click", Xe(n[7])), c = !0);
      },
      p: function p(k, _ref44) {
        var _ref45 = _slicedToArray(_ref44, 1),
          L = _ref45[0];
        k[3] ? g ? g.p(k, L) : (g = wr(k), g.c(), g.m(e, t)) : g && (g.d(1), g = null), k[2] ? y ? (y.p(k, L), L & 4 && C(y, 1)) : (y = yr(k), y.c(), C(y, 1), y.m(e, null)) : y && (Ee(), F(y, 1, 1, function () {
          y = null;
        }), Te()), (!_o8 || L & 16 && i !== (i = k[4] ? "true" : "false")) && d(e, "aria-expanded", i), (!_o8 || L & 2 && r !== (r = k[1] ? "tooltip-trigger-".concat(k[1]) : "")) && d(e, "id", r), (!_o8 || L & 2) && d(e, "aria-describedby", k[1]), (!_o8 || L & 16 && l !== (l = k[4] ? "hide email" : "show email")) && d(e, "aria-label", l), k[4] ? S ? S.p(k, L) : (S = kr(k), S.c(), S.m(s.parentNode, s)) : S && (S.d(1), S = null);
      },
      i: function i(k) {
        _o8 || (C(y), _o8 = !0);
      },
      o: function o(k) {
        F(y), _o8 = !1;
      },
      d: function d(k) {
        k && m(e), g && g.d(), y && y.d(), k && m(a), S && S.d(k), k && m(s), c = !1, f();
      }
    };
  }
  function os(n, e, t) {
    var i;
    var r = di(tn());
    var l = e.current_tooltip_id,
      a = e.content,
      s = e.id,
      o = e.icon,
      c = e.text;
    function f() {
      l !== s ? r("toggleTooltip", {
        tooltipID: s
      }) : t(4, i = !i);
    }
    var g = function g(y) {
      return f();
    };
    return n.$$set = function (y) {
      "current_tooltip_id" in y && t(6, l = y.current_tooltip_id), "content" in y && t(0, a = y.content), "id" in y && t(1, s = y.id), "icon" in y && t(2, o = y.icon), "text" in y && t(3, c = y.text);
    }, n.$$.update = function () {
      n.$$.dirty & 66 && t(4, i = !!(l && l === s));
    }, [a, s, o, c, i, f, l, g];
  }
  var ss = /*#__PURE__*/function (_rn4) {
    function ss(e) {
      var _this13;
      _classCallCheck(this, ss);
      _this13 = _callSuper(this, ss);
      _this13.shadowRoot.innerHTML = "<style>button.tooltip-trigger{background:transparent;border:none;box-shadow:none;cursor:pointer;padding:0;height:auto;display:flex;flex-direction:row;align-items:center;align-content:center;justify-content:center}.icon-container{width:1rem}.icon-container.reverse-icon{transform:rotate(180deg)}p.tooltip{background:var(--grey-lightest);border-radius:2px;color:var(--grey-dark);box-shadow:0px 3px 2px rgba(0, 0, 0, 0.25);left:50%;padding:0.5rem;position:absolute;top:8px;transform:translate(-50%, 0);width:max-content;max-width:240px;max-height:240px;overflow-y:scroll;word-break:break-word;white-space:pre-line;z-index:1}</style>", Ke(_this13, {
        target: _this13.shadowRoot,
        props: gn(_this13.attributes),
        customElement: !0
      }, os, ls, Ye, {
        current_tooltip_id: 6,
        content: 0,
        id: 1,
        icon: 2,
        text: 3
      }, null), e && (e.target && p(e.target, _this13, e.anchor), e.props && (_this13.$set(e.props), fe()));
      return _this13;
    }
    _inherits(ss, _rn4);
    return _createClass(ss, [{
      key: "current_tooltip_id",
      get: function get() {
        return this.$$.ctx[6];
      },
      set: function set(e) {
        this.$$set({
          current_tooltip_id: e
        }), fe();
      }
    }, {
      key: "content",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(e) {
        this.$$set({
          content: e
        }), fe();
      }
    }, {
      key: "id",
      get: function get() {
        return this.$$.ctx[1];
      },
      set: function set(e) {
        this.$$set({
          id: e
        }), fe();
      }
    }, {
      key: "icon",
      get: function get() {
        return this.$$.ctx[2];
      },
      set: function set(e) {
        this.$$set({
          icon: e
        }), fe();
      }
    }, {
      key: "text",
      get: function get() {
        return this.$$.ctx[3];
      },
      set: function set(e) {
        this.$$set({
          text: e
        }), fe();
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["current_tooltip_id", "content", "id", "icon", "text"];
      }
    }]);
  }(rn);
  customElements.define("nylas-tooltip", ss);
  var zn;
  (function (n) {
    n.Label = "label", n.Folder = "folder";
  })(zn || (zn = {}));
  var Er;
  (function (n) {
    n.RUNNING = "running", n.PARTIAL = "partial", n.STOPPED = "stopped";
  })(Er || (Er = {}));
  var Tr;
  (function (n) {
    n.SELECTALL = "selectall", n.DELETE = "delete", n.STAR = "star", n.UNREAD = "unread";
  })(Tr || (Tr = {}));
  var jt;
  (function (n) {
    n.DRAFTS = "drafts", n.MESSAGES = "messages";
  })(jt || (jt = {}));
  var Ar;
  (function (n) {
    n.DEFAULT = "default", n.CUSTOM = "custom";
  })(Ar || (Ar = {}));
  var cs = /*#__PURE__*/function () {
    var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(n) {
      var e;
      return _regeneratorRuntime().wrap(function _callee26$(_context26) {
        while (1) switch (_context26.prev = _context26.next) {
          case 0:
            e = "".concat(Ve(n.component_id), "/labels");
            _context26.next = 3;
            return fetch(e, Ge(n)).then(function (t) {
              return Be(t);
            }).then(function (t) {
              return t.response;
            }).catch(function (t) {
              return We(n.component_id, t);
            });
          case 3:
            return _context26.abrupt("return", _context26.sent);
          case 4:
          case "end":
            return _context26.stop();
        }
      }, _callee26);
    }));
    return function cs(_x44) {
      return _ref46.apply(this, arguments);
    };
  }();
  var fs = Object.defineProperty,
    Or = Object.getOwnPropertySymbols,
    ds = Object.prototype.hasOwnProperty,
    us = Object.prototype.propertyIsEnumerable,
    Sr = function Sr(n, e, t) {
      return e in n ? fs(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    ms = function ms(n, e) {
      for (var t in e || (e = {})) ds.call(e, t) && Sr(n, t, e[t]);
      if (Or) {
        var _iterator14 = _createForOfIteratorHelper(Or(e)),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var t = _step14.value;
            us.call(e, t) && Sr(n, t, e[t]);
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
      }
      return n;
    };
  function _s() {
    var _bt5 = bt({}),
      n = _bt5.subscribe,
      e = _bt5.set,
      t = _bt5.update,
      i = {};
    return {
      subscribe: n,
      getLabels: function () {
        var _getLabels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(r) {
          var l,
            a,
            _args27 = arguments;
          return _regeneratorRuntime().wrap(function _callee27$(_context27) {
            while (1) switch (_context27.prev = _context27.next) {
              case 0:
                l = _args27.length > 1 && _args27[1] !== undefined ? _args27[1] : !1;
                a = JSON.stringify(r);
                _context27.t0 = (!i[a] || l) && (r.component_id || r.access_token);
                if (!_context27.t0) {
                  _context27.next = 7;
                  break;
                }
                _context27.next = 6;
                return cs(r);
              case 6:
                i[a] = _context27.sent.map(function (s) {
                  return s.toString = function () {
                    return s.id;
                  }, s;
                });
              case 7:
                t(function (s) {
                  return s[a] = i[a], ms({}, s);
                });
                return _context27.abrupt("return", i[a]);
              case 9:
              case "end":
                return _context27.stop();
            }
          }, _callee27);
        }));
        function getLabels(_x45) {
          return _getLabels.apply(this, arguments);
        }
        return getLabels;
      }(),
      reset: function reset() {
        return e({});
      }
    };
  }
  var hs = _s(),
    ps = /*#__PURE__*/function () {
      var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(n) {
        var e;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              e = "".concat(Ve(n.component_id), "/folders");
              _context28.next = 3;
              return fetch(e, Ge(n)).then(function (t) {
                return Be(t);
              }).then(function (t) {
                return t.response;
              }).catch(function (t) {
                return We(n.component_id, t);
              });
            case 3:
              return _context28.abrupt("return", _context28.sent);
            case 4:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }));
      return function ps(_x46) {
        return _ref47.apply(this, arguments);
      };
    }();
  var gs = Object.defineProperty,
    Cr = Object.getOwnPropertySymbols,
    vs = Object.prototype.hasOwnProperty,
    bs = Object.prototype.propertyIsEnumerable,
    Nr = function Nr(n, e, t) {
      return e in n ? gs(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }) : n[e] = t;
    },
    ws = function ws(n, e) {
      for (var t in e || (e = {})) vs.call(e, t) && Nr(n, t, e[t]);
      if (Cr) {
        var _iterator15 = _createForOfIteratorHelper(Cr(e)),
          _step15;
        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var t = _step15.value;
            bs.call(e, t) && Nr(n, t, e[t]);
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }
      }
      return n;
    };
  function ys() {
    var _bt6 = bt({}),
      n = _bt6.subscribe,
      e = _bt6.set,
      t = _bt6.update,
      i = {};
    return {
      subscribe: n,
      getFolders: function () {
        var _getFolders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(r) {
          var l,
            a,
            _args29 = arguments;
          return _regeneratorRuntime().wrap(function _callee29$(_context29) {
            while (1) switch (_context29.prev = _context29.next) {
              case 0:
                l = _args29.length > 1 && _args29[1] !== undefined ? _args29[1] : !1;
                a = JSON.stringify(r);
                _context29.t0 = (!i[a] || l) && (r.component_id || r.access_token);
                if (!_context29.t0) {
                  _context29.next = 7;
                  break;
                }
                _context29.next = 6;
                return ps(r);
              case 6:
                i[a] = _context29.sent.map(function (s) {
                  return s.toString = function () {
                    return s.id;
                  }, s;
                });
              case 7:
                t(function (s) {
                  return s[a] = i[a], ws({}, s);
                });
                return _context29.abrupt("return", i[a]);
              case 9:
              case "end":
                return _context29.stop();
            }
          }, _callee29);
        }));
        function getFolders(_x47) {
          return _getFolders.apply(this, arguments);
        }
        return getFolders;
      }(),
      reset: function reset() {
        return e({});
      }
    };
  }
  var ks = ys();
  function Es(n) {
    var e,
      t,
      i,
      r,
      _l8,
      a,
      s,
      o,
      _c7,
      f,
      g,
      y = [{
        id: "Capa_1"
      }, {
        "enable-background": "new 0 0 497 497"
      }, {
        height: "512"
      }, {
        viewBox: "0 0 497 497"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      S = {};
    for (var k = 0; k < y.length; k += 1) S = ue(S, y[k]);
    return {
      c: function c() {
        e = te("svg"), t = te("g"), i = te("circle"), r = te("circle"), _l8 = te("circle"), a = te("ellipse"), s = te("ellipse"), o = te("ellipse"), _c7 = te("ellipse"), f = te("ellipse"), g = te("circle"), this.h();
      },
      l: function l(k) {
        e = ie(k, "svg", {
          id: !0,
          "enable-background": !0,
          height: !0,
          viewBox: !0,
          xmlns: !0
        });
        var L = ne(e);
        t = ie(L, "g", {});
        var j = ne(t);
        i = ie(j, "circle", {
          cx: !0,
          cy: !0,
          fill: !0,
          r: !0
        }), ne(i).forEach(m), r = ie(j, "circle", {
          cx: !0,
          cy: !0,
          fill: !0,
          r: !0
        }), ne(r).forEach(m), _l8 = ie(j, "circle", {
          cx: !0,
          cy: !0,
          fill: !0,
          r: !0
        }), ne(_l8).forEach(m), a = ie(j, "ellipse", {
          cx: !0,
          cy: !0,
          fill: !0,
          rx: !0,
          ry: !0
        }), ne(a).forEach(m), s = ie(j, "ellipse", {
          cx: !0,
          cy: !0,
          fill: !0,
          rx: !0,
          ry: !0
        }), ne(s).forEach(m), o = ie(j, "ellipse", {
          cx: !0,
          cy: !0,
          fill: !0,
          rx: !0,
          ry: !0
        }), ne(o).forEach(m), _c7 = ie(j, "ellipse", {
          cx: !0,
          cy: !0,
          fill: !0,
          rx: !0,
          ry: !0
        }), ne(_c7).forEach(m), f = ie(j, "ellipse", {
          cx: !0,
          cy: !0,
          fill: !0,
          rx: !0,
          ry: !0
        }), ne(f).forEach(m), g = ie(j, "circle", {
          cx: !0,
          cy: !0,
          fill: !0,
          r: !0
        }), ne(g).forEach(m), j.forEach(m), L.forEach(m), this.h();
      },
      h: function h() {
        d(i, "cx", "98"), d(i, "cy", "376"), d(i, "fill", "#909ba6"), d(i, "r", "53"), d(r, "cx", "439"), d(r, "cy", "336"), d(r, "fill", "#c8d2dc"), d(r, "r", "46"), d(_l8, "cx", "397"), d(_l8, "cy", "112"), d(_l8, "fill", "#e9edf1"), d(_l8, "r", "38"), d(a, "cx", "56.245"), d(a, "cy", "244.754"), d(a, "fill", "#7e8b96"), d(a, "rx", "56.245"), d(a, "ry", "54.874"), d(s, "cx", "217.821"), d(s, "cy", "447.175"), d(s, "fill", "#a2abb8"), d(s, "rx", "51.132"), d(s, "ry", "49.825"), d(o, "cx", "349.229"), d(o, "cy", "427.873"), d(o, "fill", "#b9c3cd"), d(o, "rx", "48.575"), d(o, "ry", "47.297"), d(_c7, "cx", "117.092"), d(_c7, "cy", "114.794"), d(_c7, "fill", "#5f6c75"), d(_c7, "rx", "58.801"), d(_c7, "ry", "57.397"), d(f, "cx", "453.538"), d(f, "cy", "216.477"), d(f, "fill", "#dce6eb"), d(f, "rx", "43.462"), d(f, "ry", "42.656"), d(g, "cx", "263"), d(g, "cy", "62"), d(g, "fill", "#4e5a61"), d(g, "r", "62"), Me(e, S);
      },
      m: function m(k, L) {
        ut(k, e, L), ve(e, t), ve(t, i), ve(t, r), ve(t, _l8), ve(t, a), ve(t, s), ve(t, o), ve(t, _c7), ve(t, f), ve(t, g);
      },
      p: function p(k, _ref48) {
        var _ref49 = _slicedToArray(_ref48, 1),
          L = _ref49[0];
        Me(e, S = _t(y, [{
          id: "Capa_1"
        }, {
          "enable-background": "new 0 0 497 497"
        }, {
          height: "512"
        }, {
          viewBox: "0 0 497 497"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, L & 1 && k[0]]));
      },
      i: T,
      o: T,
      d: function d(k) {
        k && m(e);
      }
    };
  }
  function Ts(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var As = /*#__PURE__*/function (_ht9) {
    function As(e) {
      var _this14;
      _classCallCheck(this, As);
      _this14 = _callSuper(this, As);
      Ke(_this14, e, Ts, Es, Ye, {});
      return _this14;
    }
    _inherits(As, _ht9);
    return _createClass(As);
  }(ht);
  function Os(n) {
    var e,
      t,
      i,
      r,
      l = [{
        width: "21px"
      }, {
        height: "21px"
      }, {
        viewBox: "0 0 21 21"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      a = {};
    for (var s = 0; s < l.length; s += 1) a = ue(a, l[s]);
    return {
      c: function c() {
        e = te("svg"), t = te("g"), i = te("path"), r = te("path"), this.h();
      },
      l: function l(s) {
        e = ie(s, "svg", {
          width: !0,
          height: !0,
          viewBox: !0,
          xmlns: !0
        });
        var o = ne(e);
        t = ie(o, "g", {
          fill: !0,
          "fill-rule": !0,
          stroke: !0,
          "stroke-linecap": !0,
          "stroke-linejoin": !0,
          "stroke-width": !0,
          transform: !0
        });
        var c = ne(t);
        i = ie(c, "path", {
          d: !0
        }), ne(i).forEach(m), r = ie(c, "path", {
          d: !0
        }), ne(r).forEach(m), c.forEach(m), o.forEach(m), this.h();
      },
      h: function h() {
        d(i, "d", "m11 8v-2c0-1.65685425-1.34314575-3-3-3h-8"), d(r, "d", "m3 6-3.001-3 3.001-3"), d(t, "fill", "none"), d(t, "fill-rule", "evenodd"), d(t, "stroke", "currentColor"), d(t, "stroke-linecap", "round"), d(t, "stroke-linejoin", "round"), d(t, "stroke-width", "1.5px"), d(t, "transform", "translate(4.5 6.5)"), Me(e, a);
      },
      m: function m(s, o) {
        ut(s, e, o), ve(e, t), ve(t, i), ve(t, r);
      },
      p: function p(s, _ref50) {
        var _ref51 = _slicedToArray(_ref50, 1),
          o = _ref51[0];
        Me(e, a = _t(l, [{
          width: "21px"
        }, {
          height: "21px"
        }, {
          viewBox: "0 0 21 21"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, o & 1 && s[0]]));
      },
      i: T,
      o: T,
      d: function d(s) {
        s && m(e);
      }
    };
  }
  function Ss(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var Lr = /*#__PURE__*/function (_ht10) {
    function Lr(e) {
      var _this15;
      _classCallCheck(this, Lr);
      _this15 = _callSuper(this, Lr);
      Ke(_this15, e, Ss, Os, Ye, {});
      return _this15;
    }
    _inherits(Lr, _ht10);
    return _createClass(Lr);
  }(ht);
  function Cs(n) {
    var e,
      t,
      i,
      r,
      _l9,
      a = [{
        width: "21px"
      }, {
        height: "21px"
      }, {
        viewBox: "0 0 21 21"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      s = {};
    for (var o = 0; o < a.length; o += 1) s = ue(s, a[o]);
    return {
      c: function c() {
        e = te("svg"), t = te("g"), i = te("path"), r = te("path"), _l9 = te("path"), this.h();
      },
      l: function l(o) {
        e = ie(o, "svg", {
          width: !0,
          height: !0,
          viewBox: !0,
          xmlns: !0
        });
        var c = ne(e);
        t = ie(c, "g", {
          fill: !0,
          "fill-rule": !0,
          stroke: !0,
          "stroke-linecap": !0,
          "stroke-linejoin": !0,
          "stroke-width": !0,
          transform: !0
        });
        var f = ne(t);
        i = ie(f, "path", {
          d: !0
        }), ne(i).forEach(m), r = ie(f, "path", {
          d: !0
        }), ne(r).forEach(m), _l9 = ie(f, "path", {
          d: !0
        }), ne(_l9).forEach(m), f.forEach(m), c.forEach(m), this.h();
      },
      h: function h() {
        d(i, "d", "m14 8v-2c0-1.65685425-1.3431458-3-3-3h-8"), d(r, "d", "m3 6-3.001-3 3.001-3"), d(_l9, "d", "m6 6-3.001-3 3.001-3"), d(t, "fill", "none"), d(t, "fill-rule", "evenodd"), d(t, "stroke", "currentColor"), d(t, "stroke-linecap", "round"), d(t, "stroke-linejoin", "round"), d(t, "stroke-width", "1.5px"), d(t, "transform", "translate(3.5 6.5)"), Me(e, s);
      },
      m: function m(o, c) {
        ut(o, e, c), ve(e, t), ve(t, i), ve(t, r), ve(t, _l9);
      },
      p: function p(o, _ref52) {
        var _ref53 = _slicedToArray(_ref52, 1),
          c = _ref53[0];
        Me(e, s = _t(a, [{
          width: "21px"
        }, {
          height: "21px"
        }, {
          viewBox: "0 0 21 21"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, c & 1 && o[0]]));
      },
      i: T,
      o: T,
      d: function d(o) {
        o && m(e);
      }
    };
  }
  function Ns(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var Mr = /*#__PURE__*/function (_ht11) {
    function Mr(e) {
      var _this16;
      _classCallCheck(this, Mr);
      _this16 = _callSuper(this, Mr);
      Ke(_this16, e, Ns, Cs, Ye, {});
      return _this16;
    }
    _inherits(Mr, _ht11);
    return _createClass(Mr);
  }(ht);
  function Ls(n) {
    var e,
      t,
      i,
      r,
      l = [{
        width: "21px"
      }, {
        height: "21px"
      }, {
        viewBox: "0 0 21 21"
      }, {
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0]],
      a = {};
    for (var s = 0; s < l.length; s += 1) a = ue(a, l[s]);
    return {
      c: function c() {
        e = te("svg"), t = te("g"), i = te("path"), r = te("path"), this.h();
      },
      l: function l(s) {
        e = ie(s, "svg", {
          width: !0,
          height: !0,
          viewBox: !0,
          xmlns: !0
        });
        var o = ne(e);
        t = ie(o, "g", {
          fill: !0,
          "fill-rule": !0,
          stroke: !0,
          "stroke-linecap": !0,
          "stroke-linejoin": !0,
          "stroke-width": !0,
          transform: !0
        });
        var c = ne(t);
        i = ie(c, "path", {
          d: !0
        }), ne(i).forEach(m), r = ie(c, "path", {
          d: !0
        }), ne(r).forEach(m), c.forEach(m), o.forEach(m), this.h();
      },
      h: function h() {
        d(i, "d", "m0 8v-2c0-1.65685425 1.34314575-3 3-3h8"), d(r, "d", "m7.999 6 3.001-3-3.001-3"), d(t, "fill", "none"), d(t, "fill-rule", "evenodd"), d(t, "stroke", "currentColor"), d(t, "stroke-linecap", "round"), d(t, "stroke-linejoin", "round"), d(t, "stroke-width", "1.5px"), d(t, "transform", "translate(5.5 6.5)"), Me(e, a);
      },
      m: function m(s, o) {
        ut(s, e, o), ve(e, t), ve(t, i), ve(t, r);
      },
      p: function p(s, _ref54) {
        var _ref55 = _slicedToArray(_ref54, 1),
          o = _ref55[0];
        Me(e, a = _t(l, [{
          width: "21px"
        }, {
          height: "21px"
        }, {
          viewBox: "0 0 21 21"
        }, {
          xmlns: "http://www.w3.org/2000/svg"
        }, o & 1 && s[0]]));
      },
      i: T,
      o: T,
      d: function d(s) {
        s && m(e);
      }
    };
  }
  function Ms(n, e, t) {
    return n.$$set = function (i) {
      t(0, e = ue(ue({}, e), Se(i)));
    }, e = Se(e), [e];
  }
  var Dr = /*#__PURE__*/function (_ht12) {
    function Dr(e) {
      var _this17;
      _classCallCheck(this, Dr);
      _this17 = _callSuper(this, Dr);
      Ke(_this17, e, Ms, Ls, Ye, {});
      return _this17;
    }
    _inherits(Dr, _ht12);
    return _createClass(Dr);
  }(ht);
  var Ds = "@nylas/components-email",
    Ps = "1.1.7-canary.32",
    Rs = {
      type: "git",
      url: "github:nylas/components.git",
      directory: "components/email"
    },
    Is = {
      build: "rollup -c",
      dev: "rollup -c -w",
      tscheck: "tsc && svelte-check",
      start: "echo 'Nothing to start'"
    },
    js = "index.js",
    Fs = "cca94159c114ecff613f41caa0a4468e0f698e2c",
    Us = {
      "@types/dompurify": "^2.3.1"
    },
    Hs = {
      dompurify: "^2.3.3"
    },
    zs = {
      name: Ds,
      version: Ps,
      repository: Rs,
      scripts: Is,
      main: js,
      gitHead: Fs,
      devDependencies: Us,
      dependencies: Hs
    };
  function Pr(n, e, t) {
    var i = n.slice();
    return i[124] = e[t], i[126] = t, i;
  }
  function Rr(n, e, t) {
    var i = n.slice();
    return i[134] = e[t], i;
  }
  function Ir(n, e, t) {
    var i = n.slice();
    return i[129] = e[t], i;
  }
  function jr(n, e, t) {
    var i = n.slice();
    return i[139] = e[t], i[141] = t, i;
  }
  function Fr(n, e, t) {
    var i = n.slice();
    return i[120] = e[t], i[121] = e, i[122] = t, i;
  }
  function Ur(n, e, t) {
    var i = n.slice();
    return i[124] = e[t], i[126] = t, i;
  }
  function Hr(n, e, t) {
    var i = n.slice();
    return i[2] = e[t], i[127] = e, i[128] = t, i;
  }
  function zr(n, e, t) {
    var i = n.slice();
    return i[129] = e[t], i;
  }
  function Br(n, e, t) {
    var i = n.slice();
    return i[124] = e[t], i[126] = t, i;
  }
  function Gr(n) {
    var e, t, i;
    return {
      c: function c() {
        e = b("link"), d(e, "rel", "stylesheet"), d(e, "href", n[16]);
      },
      m: function m(r, l) {
        p(r, e, l), t || (i = [ge(e, "load", n[78]), ge(e, "error", n[79])], t = !0);
      },
      p: function p(r, l) {
        l[0] & 65536 && d(e, "href", r[16]);
      },
      d: function d(r) {
        r && m(e), t = !1, ot(i);
      }
    };
  }
  function Bs(n) {
    var e = Object.keys(n[4].message).length > 0,
      t,
      _i3,
      r = e && Vr(n);
    return {
      c: function c() {
        r && r.c(), t = Le();
      },
      m: function m(l, a) {
        r && r.m(l, a), p(l, t, a), _i3 = !0;
      },
      p: function p(l, a) {
        a[0] & 16 && (e = Object.keys(l[4].message).length > 0), e ? r ? (r.p(l, a), a[0] & 16 && C(r, 1)) : (r = Vr(l), r.c(), C(r, 1), r.m(t.parentNode, t)) : r && (Ee(), F(r, 1, 1, function () {
          r = null;
        }), Te());
      },
      i: function i(l) {
        _i3 || (C(r), _i3 = !0);
      },
      o: function o(l) {
        F(r), _i3 = !1;
      },
      d: function d(l) {
        r && r.d(l), l && m(t);
      }
    };
  }
  function Gs(n) {
    var e,
      t,
      _i4,
      r = {
        ctx: n,
        current: null,
        token: null,
        hasCatch: !1,
        pending: Wc,
        then: ec,
        catch: qs,
        value: 3,
        blocks: [,,,]
      };
    return mt(t = n[7], r), {
      c: function c() {
        e = Le(), r.block.c();
      },
      m: function m(l, a) {
        p(l, e, a), r.block.m(l, r.anchor = a), r.mount = function () {
          return e.parentNode;
        }, r.anchor = e, _i4 = !0;
      },
      p: function p(l, a) {
        n = l, r.ctx = n, a[0] & 128 && t !== (t = n[7]) && mt(t, r) || nn(r, n, a);
      },
      i: function i(l) {
        _i4 || (C(r.block), _i4 = !0);
      },
      o: function o(l) {
        for (var a = 0; a < 3; a += 1) {
          var s = r.blocks[a];
          F(s);
        }
        _i4 = !1;
      },
      d: function d(l) {
        l && m(e), r.block.d(l), r.token = null, r = null;
      }
    };
  }
  function Vr(n) {
    var oe, N, pt, ct, it, $e;
    var e,
      t,
      i = ((oe = n[4].message) == null ? void 0 : oe.subject) + "",
      r,
      l,
      a,
      s,
      o,
      _c8,
      f,
      g,
      y,
      S = (n[8] && ((N = n[4].message) == null ? void 0 : N.from[0].email) === n[8] ? "me" : ((ct = (pt = n[4].message) == null ? void 0 : pt.from[0]) == null ? void 0 : ct.name) || (($e = (it = n[4].message) == null ? void 0 : it.from[0]) == null ? void 0 : $e.email)) + "",
      k,
      L,
      j,
      E,
      O,
      B,
      ae,
      V,
      Q,
      z,
      Y,
      A,
      W,
      Oe = n[4].show_reply_all && n[28](n[4].message),
      _e,
      se,
      re,
      J,
      q,
      de,
      ee = n[4].show_contact_avatar && Wr(n),
      Z = {
        ctx: n,
        current: null,
        token: null,
        hasCatch: !1,
        pending: Ks,
        then: Ws,
        catch: Vs,
        value: 123
      };
    mt(V = n[38]({
      to: n[4].message.to,
      cc: n[4].message.cc,
      bcc: n[4].message.bcc
    }), Z);
    var he = n[4].show_received_timestamp && Zr(n),
      le = n[4].show_reply && Yr(n),
      ke = Oe && Xr(n),
      D = n[4].show_forward && Kr(n);
    function ce(Ce, be) {
      if (Ce[4].clean_conversation && Ce[4].message.conversation) return $s;
      if (Ce[4].message) return Qs;
    }
    var xe = ce(n),
      P = xe && xe(n);
    return {
      c: function c() {
        var Ce, be;
        e = b("div"), t = b("header"), r = x(i), l = G(), a = b("div"), s = b("div"), o = b("div"), _c8 = b("div"), ee && ee.c(), f = G(), g = b("div"), y = b("span"), k = x(S), L = G(), j = b("nylas-tooltip"), B = G(), ae = b("div"), Z.block.c(), Q = G(), z = b("section"), he && he.c(), Y = G(), A = b("div"), le && le.c(), W = G(), ke && ke.c(), _e = G(), D && D.c(), se = G(), re = b("div"), P && P.c(), d(y, "class", "name"), U(j, "id", E = (Ce = n[4].message) == null ? void 0 : Ce.id), U(j, "current_tooltip_id", n[13]), U(j, "icon", ln), U(j, "content", O = (be = n[4].message) == null ? void 0 : be.from[0].email), d(g, "class", "message-from"), d(_c8, "class", "avatar-info"), d(ae, "class", "message-to"), d(o, "class", "message-from-to"), d(A, "aria-label", "Email Actions"), d(A, "role", "toolbar"), d(z, "class", ""), d(s, "class", "message-head"), d(re, "class", "message-body"), d(a, "class", "individual-message expanded"), d(e, "class", "email-row expanded singular");
      },
      m: function m(Ce, be) {
        p(Ce, e, be), w(e, t), w(t, r), w(e, l), w(e, a), w(a, s), w(s, o), w(o, _c8), ee && ee.m(_c8, null), w(_c8, f), w(_c8, g), w(g, y), w(y, k), w(g, L), w(g, j), w(o, B), w(o, ae), Z.block.m(ae, Z.anchor = null), Z.mount = function () {
          return ae;
        }, Z.anchor = null, w(s, Q), w(s, z), he && he.m(z, null), w(z, Y), w(z, A), le && le.m(A, null), w(A, W), ke && ke.m(A, null), w(A, _e), D && D.m(A, null), w(a, se), w(a, re), P && P.m(re, null), J = !0, q || (de = ge(j, "toggleTooltip", n[34]), q = !0);
      },
      p: function p(Ce, be) {
        var qe, Zt, Ct, Yt, Ut, wt, Et, Tt;
        n = Ce, (!J || be[0] & 16) && i !== (i = ((qe = n[4].message) == null ? void 0 : qe.subject) + "") && me(r, i), n[4].show_contact_avatar ? ee ? ee.p(n, be) : (ee = Wr(n), ee.c(), ee.m(_c8, f)) : ee && (ee.d(1), ee = null), (!J || be[0] & 272) && S !== (S = (n[8] && ((Zt = n[4].message) == null ? void 0 : Zt.from[0].email) === n[8] ? "me" : ((Yt = (Ct = n[4].message) == null ? void 0 : Ct.from[0]) == null ? void 0 : Yt.name) || ((wt = (Ut = n[4].message) == null ? void 0 : Ut.from[0]) == null ? void 0 : wt.email)) + "") && me(k, S), (!J || be[0] & 16 && E !== (E = (Et = n[4].message) == null ? void 0 : Et.id)) && U(j, "id", E), (!J || be[0] & 8192) && U(j, "current_tooltip_id", n[13]), (!J || be[0] & 16 && O !== (O = (Tt = n[4].message) == null ? void 0 : Tt.from[0].email)) && U(j, "content", O), Z.ctx = n, be[0] & 16 && V !== (V = n[38]({
          to: n[4].message.to,
          cc: n[4].message.cc,
          bcc: n[4].message.bcc
        })) && mt(V, Z) || nn(Z, n, be), n[4].show_received_timestamp ? he ? he.p(n, be) : (he = Zr(n), he.c(), he.m(z, Y)) : he && (he.d(1), he = null), n[4].show_reply ? le ? (le.p(n, be), be[0] & 16 && C(le, 1)) : (le = Yr(n), le.c(), C(le, 1), le.m(A, W)) : le && (Ee(), F(le, 1, 1, function () {
          le = null;
        }), Te()), be[0] & 16 && (Oe = n[4].show_reply_all && n[28](n[4].message)), Oe ? ke ? (ke.p(n, be), be[0] & 16 && C(ke, 1)) : (ke = Xr(n), ke.c(), C(ke, 1), ke.m(A, _e)) : ke && (Ee(), F(ke, 1, 1, function () {
          ke = null;
        }), Te()), n[4].show_forward ? D ? (D.p(n, be), be[0] & 16 && C(D, 1)) : (D = Kr(n), D.c(), C(D, 1), D.m(A, null)) : D && (Ee(), F(D, 1, 1, function () {
          D = null;
        }), Te()), xe === (xe = ce(n)) && P ? P.p(n, be) : (P && P.d(1), P = xe && xe(n), P && (P.c(), P.m(re, null)));
      },
      i: function i(Ce) {
        J || (C(le), C(ke), C(D), J = !0);
      },
      o: function o(Ce) {
        F(le), F(ke), F(D), J = !1;
      },
      d: function d(Ce) {
        Ce && m(e), ee && ee.d(), Z.block.d(), Z.token = null, Z = null, he && he.d(), le && le.d(), ke && ke.d(), D && D.d(), P && P.d(), q = !1, de();
      }
    };
  }
  function Wr(n) {
    var e, t;
    return {
      c: function c() {
        e = b("div"), t = b("nylas-contact-image"), U(t, "contact_query", n[12]), U(t, "contact", n[17]), d(e, "class", "default-avatar");
      },
      m: function m(i, r) {
        p(i, e, r), w(e, t);
      },
      p: function p(i, r) {
        r[0] & 4096 && U(t, "contact_query", i[12]), r[0] & 131072 && U(t, "contact", i[17]);
      },
      d: function d(i) {
        i && m(e);
      }
    };
  }
  function Vs(n) {
    return {
      c: T,
      m: T,
      p: T,
      d: T
    };
  }
  function Ws(n) {
    var e,
      t,
      i = n[123].slice(0, Je),
      r = [];
    for (var a = 0; a < i.length; a += 1) r[a] = Jr(Pr(n, i, a));
    var l = n[123].length > Je && xr(n);
    return {
      c: function c() {
        for (var _a5 = 0; _a5 < r.length; _a5 += 1) r[_a5].c();
        e = G(), l && l.c(), t = Le();
      },
      m: function m(a, s) {
        for (var o = 0; o < r.length; o += 1) r[o].m(a, s);
        p(a, e, s), l && l.m(a, s), p(a, t, s);
      },
      p: function p(a, s) {
        if (s[0] & 16 | s[1] & 128) {
          i = a[123].slice(0, Je);
          var o;
          for (o = 0; o < i.length; o += 1) {
            var c = Pr(a, i, o);
            r[o] ? r[o].p(c, s) : (r[o] = Jr(c), r[o].c(), r[o].m(e.parentNode, e));
          }
          for (; o < r.length; o += 1) r[o].d(1);
          r.length = i.length;
        }
        a[123].length > Je ? l ? l.p(a, s) : (l = xr(a), l.c(), l.m(t.parentNode, t)) : l && (l.d(1), l = null);
      },
      d: function d(a) {
        kt(r, a), a && m(e), l && l.d(a), a && m(t);
      }
    };
  }
  function Js(n) {
    var e;
    return {
      c: function c() {
        e = x("bcc:");
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function xs(n) {
    var e;
    return {
      c: function c() {
        e = x("cc:");
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function Zs(n) {
    var e = "to ".concat(n[4].you && n[124].email === n[4].you.email_address ? "Me" : ""),
      t;
    return {
      c: function c() {
        t = x(e);
      },
      m: function m(i, r) {
        p(i, t, r);
      },
      p: function p(i, r) {
        r[0] & 16 && e !== (e = "to ".concat(i[4].you && i[124].email === i[4].you.email_address ? "Me" : "")) && me(t, e);
      },
      d: function d(i) {
        i && m(t);
      }
    };
  }
  function Ys(n) {
    var e = n[124].email + "",
      t;
    return {
      c: function c() {
        t = x(e);
      },
      m: function m(i, r) {
        p(i, t, r);
      },
      p: function p(i, r) {
        r[0] & 16 && e !== (e = i[124].email + "") && me(t, e);
      },
      d: function d(i) {
        i && m(t);
      }
    };
  }
  function Xs(n) {
    var s;
    var e = ((s = n[124].name) != null ? s : n[4].you.name) + "",
      t,
      i,
      r = n[124].email + "",
      l,
      a;
    return {
      c: function c() {
        t = x(e), i = x(" <"), l = x(r), a = x(">");
      },
      m: function m(o, c) {
        p(o, t, c), p(o, i, c), p(o, l, c), p(o, a, c);
      },
      p: function p(o, c) {
        var f;
        c[0] & 16 && e !== (e = ((f = o[124].name) != null ? f : o[4].you.name) + "") && me(t, e), c[0] & 16 && r !== (r = o[124].email + "") && me(l, r);
      },
      d: function d(o) {
        o && m(t), o && m(i), o && m(l), o && m(a);
      }
    };
  }
  function Jr(n) {
    var e, t;
    function i(c, f) {
      if (c[126] === 0) return Zs;
      if (c[124]._type === "cc" && c[126] === c[4].message.to.length) return xs;
      if (c[124]._type === "bcc" && c[126] === c[4].message.to.length + c[4].message.cc.length) return Js;
    }
    var r = i(n),
      l = r && r(n);
    function a(c, f) {
      if (c[124].email && c[124].name) return Xs;
      if (c[124].email && !c[124].name) return Ys;
    }
    var s = a(n),
      o = s && s(n);
    return {
      c: function c() {
        e = b("p"), l && l.c(), t = G(), o && o.c();
      },
      m: function m(c, f) {
        p(c, e, f), l && l.m(e, null), w(e, t), o && o.m(e, null);
      },
      p: function p(c, f) {
        r === (r = i(c)) && l ? l.p(c, f) : (l && l.d(1), l = r && r(c), l && (l.c(), l.m(e, t))), s === (s = a(c)) && o ? o.p(c, f) : (o && o.d(1), o = s && s(c), o && (o.c(), o.m(e, null)));
      },
      d: function d(c) {
        c && m(e), l && l.d(), o && o.d();
      }
    };
  }
  function xr(n) {
    var e, t, i, r, l, a, s;
    return {
      c: function c() {
        e = b("div"), t = b("nylas-tooltip"), U(t, "id", i = "show-more-participants-".concat(n[4].message.id)), U(t, "current_tooltip_id", n[13]), U(t, "icon", ln), U(t, "text", r = "And ".concat(n[123].length - Je, " more")), U(t, "content", l = "".concat(sn(n[123])));
      },
      m: function m(o, c) {
        p(o, e, c), w(e, t), a || (s = ge(t, "toggleTooltip", n[34]), a = !0);
      },
      p: function p(o, c) {
        c[0] & 16 && i !== (i = "show-more-participants-".concat(o[4].message.id)) && U(t, "id", i), c[0] & 8192 && U(t, "current_tooltip_id", o[13]), c[0] & 16 && r !== (r = "And ".concat(o[123].length - Je, " more")) && U(t, "text", r), c[0] & 16 && l !== (l = "".concat(sn(o[123]))) && U(t, "content", l);
      },
      d: function d(o) {
        o && m(e), a = !1, s();
      }
    };
  }
  function Ks(n) {
    return {
      c: T,
      m: T,
      p: T,
      d: T
    };
  }
  function Zr(n) {
    var e,
      t,
      i = Ft(new Date(n[4].message.date * 1e3)) + "",
      r;
    return {
      c: function c() {
        e = b("div"), t = b("span"), r = x(i), d(e, "class", "message-date");
      },
      m: function m(l, a) {
        p(l, e, a), w(e, t), w(t, r);
      },
      p: function p(l, a) {
        a[0] & 16 && i !== (i = Ft(new Date(l[4].message.date * 1e3)) + "") && me(r, i);
      },
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function Yr(n) {
    var e, t, _i5, r, l, a;
    return _i5 = new Lr({
      props: {
        "aria-hidden": "true"
      }
    }), {
      c: function c() {
        e = b("div"), t = b("button"), He(_i5.$$.fragment), d(t, "title", "Reply"), d(t, "aria-label", "Reply"), d(e, "class", "reply");
      },
      m: function m(s, o) {
        p(s, e, o), w(e, t), Fe(_i5, t, null), r = !0, l || (a = ge(t, "click", Xe(n[92])), l = !0);
      },
      p: T,
      i: function i(s) {
        r || (C(_i5.$$.fragment, s), r = !0);
      },
      o: function o(s) {
        F(_i5.$$.fragment, s), r = !1;
      },
      d: function d(s) {
        s && m(e), Re(_i5), l = !1, a();
      }
    };
  }
  function Xr(n) {
    var e, t, _i6, r, l, a;
    return _i6 = new Mr({
      props: {
        "aria-hidden": "true"
      }
    }), {
      c: function c() {
        e = b("div"), t = b("button"), He(_i6.$$.fragment), d(t, "title", "Reply all"), d(t, "aria-label", "Reply all"), d(e, "class", "reply-all");
      },
      m: function m(s, o) {
        p(s, e, o), w(e, t), Fe(_i6, t, null), r = !0, l || (a = ge(t, "click", Xe(n[93])), l = !0);
      },
      p: T,
      i: function i(s) {
        r || (C(_i6.$$.fragment, s), r = !0);
      },
      o: function o(s) {
        F(_i6.$$.fragment, s), r = !1;
      },
      d: function d(s) {
        s && m(e), Re(_i6), l = !1, a();
      }
    };
  }
  function Kr(n) {
    var e, t, _i7, r, l, a;
    return _i7 = new Dr({
      props: {
        "aria-hidden": "true"
      }
    }), {
      c: function c() {
        e = b("div"), t = b("button"), He(_i7.$$.fragment), d(t, "title", "Forward"), d(t, "aria-label", "Forward"), d(e, "class", "forward");
      },
      m: function m(s, o) {
        p(s, e, o), w(e, t), Fe(_i7, t, null), r = !0, l || (a = ge(t, "click", Xe(n[94])), l = !0);
      },
      p: T,
      i: function i(s) {
        r || (C(_i7.$$.fragment, s), r = !0);
      },
      o: function o(s) {
        F(_i7.$$.fragment, s), r = !1;
      },
      d: function d(s) {
        s && m(e), Re(_i7), l = !1, a();
      }
    };
  }
  function Qs(n) {
    var e, t, i, r, l;
    return {
      c: function c() {
        e = b("nylas-message-body"), U(e, "message", t = n[4].message), U(e, "body", i = n[4].message.body);
      },
      m: function m(a, s) {
        p(a, e, s), r || (l = ge(e, "downloadClicked", n[37]), r = !0);
      },
      p: function p(a, s) {
        s[0] & 16 && t !== (t = a[4].message) && U(e, "message", t), s[0] & 16 && i !== (i = a[4].message.body) && U(e, "body", i);
      },
      d: function d(a) {
        a && m(e), r = !1, l();
      }
    };
  }
  function $s(n) {
    var r, l;
    var e,
      t = on.sanitize((l = (r = n[4].message) == null ? void 0 : r.conversation) != null ? l : "") + "",
      i;
    return {
      c: function c() {
        e = new pn(!1), i = Le(), e.a = i;
      },
      m: function m(a, s) {
        e.m(t, a, s), p(a, i, s);
      },
      p: function p(a, s) {
        var o, c;
        s[0] & 16 && t !== (t = on.sanitize((c = (o = a[4].message) == null ? void 0 : o.conversation) != null ? c : "") + "") && e.p(t);
      },
      d: function d(a) {
        a && m(i), a && e.d();
      }
    };
  }
  function qs(n) {
    return {
      c: T,
      m: T,
      p: T,
      i: T,
      o: T,
      d: T
    };
  }
  function ec(n) {
    var e,
      t,
      _i8 = n[3] && n[7] && Qr(n);
    return {
      c: function c() {
        _i8 && _i8.c(), e = Le();
      },
      m: function m(r, l) {
        _i8 && _i8.m(r, l), p(r, e, l), t = !0;
      },
      p: function p(r, l) {
        r[3] && r[7] ? _i8 ? (_i8.p(r, l), l[0] & 128 && C(_i8, 1)) : (_i8 = Qr(r), _i8.c(), C(_i8, 1), _i8.m(e.parentNode, e)) : _i8 && (Ee(), F(_i8, 1, 1, function () {
          _i8 = null;
        }), Te());
      },
      i: function i(r) {
        t || (C(_i8), t = !0);
      },
      o: function o(r) {
        F(_i8), t = !1;
      },
      d: function d(r) {
        _i8 && _i8.d(r), r && m(e);
      }
    };
  }
  function Qr(n) {
    var e, t, i, r;
    var l = [nc, tc],
      a = [];
    function s(o, c) {
      return o[7].expanded ? 0 : 1;
    }
    return e = s(n), t = a[e] = l[e](n), {
      c: function c() {
        t.c(), i = Le();
      },
      m: function m(o, c) {
        a[e].m(o, c), p(o, i, c), r = !0;
      },
      p: function p(o, c) {
        var f = e;
        e = s(o), e === f ? a[e].p(o, c) : (Ee(), F(a[f], 1, 1, function () {
          a[f] = null;
        }), Te(), t = a[e], t ? t.p(o, c) : (t = a[e] = l[e](o), t.c()), C(t, 1), t.m(i.parentNode, i));
      },
      i: function i(o) {
        r || (C(t), r = !0);
      },
      o: function o(_o9) {
        F(t), r = !1;
      },
      d: function d(o) {
        a[e].d(o), o && m(i);
      }
    };
  }
  function tc(n) {
    var e,
      t,
      _i9,
      r = {
        ctx: n,
        current: null,
        token: null,
        hasCatch: !1,
        pending: gc,
        then: rc,
        catch: ic,
        value: 133,
        blocks: [,,,]
      };
    return mt(t = Ua(n[7]), r), {
      c: function c() {
        e = b("div"), r.block.c(), d(e, "class", "email-row condensed"), Ae(e, "show_star", n[4].show_star), Ae(e, "unread", n[7].unread), Ae(e, "disable-click", n[7] && n[7].messages.length <= 0 && !n[7].drafts.length);
      },
      m: function m(l, a) {
        p(l, e, a), r.block.m(e, r.anchor = null), r.mount = function () {
          return e;
        }, r.anchor = null, _i9 = !0;
      },
      p: function p(l, a) {
        n = l, r.ctx = n, a[0] & 128 && t !== (t = Ua(n[7])) && mt(t, r) || nn(r, n, a), a[0] & 16 && Ae(e, "show_star", n[4].show_star), a[0] & 128 && Ae(e, "unread", n[7].unread), a[0] & 128 && Ae(e, "disable-click", n[7] && n[7].messages.length <= 0 && !n[7].drafts.length);
      },
      i: function i(l) {
        _i9 || (C(r.block), _i9 = !0);
      },
      o: function o(l) {
        for (var a = 0; a < 3; a += 1) {
          var s = r.blocks[a];
          F(s);
        }
        _i9 = !1;
      },
      d: function d(l) {
        l && m(e), r.block.d(), r.token = null, r = null;
      }
    };
  }
  function nc(n) {
    var Y;
    var e,
      t,
      i,
      r,
      l,
      a = ((Y = n[3]) == null ? void 0 : Y.subject) + "",
      s,
      o,
      _c9,
      f,
      g,
      y,
      S,
      k,
      L,
      j,
      E = n[4].click_action === "mailbox" && ua(n),
      O = n[4].show_star && ma(n),
      B = n[4].show_thread_actions && _a(n);
    var ae = [yc, wc],
      V = [];
    function Q(A, W) {
      return A[7].messages.length ? 0 : 1;
    }
    y = Q(n), S = V[y] = ae[y](n);
    var z = n[7].drafts.length && Ca(n);
    return {
      c: function c() {
        e = b("div"), t = b("header"), i = b("div"), E && E.c(), r = G(), l = b("h1"), s = x(a), o = G(), _c9 = b("div"), O && O.c(), f = G(), B && B.c(), g = G(), S.c(), k = G(), z && z.c(), d(i, "class", "subject-title"), d(_c9, "role", "toolbar"), d(t, "class", "subject-header"), Ae(t, "mailbox", n[4].click_action === "mailbox"), d(e, "class", L = "email-row expanded " + (n[4].click_action === "mailbox" ? "expanded-mailbox-thread" : ""));
      },
      m: function m(A, W) {
        p(A, e, W), w(e, t), w(t, i), E && E.m(i, null), w(i, r), w(i, l), w(l, s), w(t, o), w(t, _c9), O && O.m(_c9, null), w(_c9, f), B && B.m(_c9, null), w(e, g), V[y].m(e, null), w(e, k), z && z.m(e, null), j = !0;
      },
      p: function p(A, W) {
        var _e;
        A[4].click_action === "mailbox" ? E ? (E.p(A, W), W[0] & 16 && C(E, 1)) : (E = ua(A), E.c(), C(E, 1), E.m(i, r)) : E && (Ee(), F(E, 1, 1, function () {
          E = null;
        }), Te()), (!j || W[0] & 128) && a !== (a = ((_e = A[3]) == null ? void 0 : _e.subject) + "") && me(s, a), A[4].show_star ? O ? O.p(A, W) : (O = ma(A), O.c(), O.m(_c9, f)) : O && (O.d(1), O = null), A[4].show_thread_actions ? B ? (B.p(A, W), W[0] & 16 && C(B, 1)) : (B = _a(A), B.c(), C(B, 1), B.m(_c9, null)) : B && (Ee(), F(B, 1, 1, function () {
          B = null;
        }), Te()), W[0] & 16 && Ae(t, "mailbox", A[4].click_action === "mailbox");
        var Oe = y;
        y = Q(A), y === Oe ? V[y].p(A, W) : (Ee(), F(V[Oe], 1, 1, function () {
          V[Oe] = null;
        }), Te(), S = V[y], S ? S.p(A, W) : (S = V[y] = ae[y](A), S.c()), C(S, 1), S.m(e, k)), A[7].drafts.length ? z ? (z.p(A, W), W[0] & 128 && C(z, 1)) : (z = Ca(A), z.c(), C(z, 1), z.m(e, null)) : z && (Ee(), F(z, 1, 1, function () {
          z = null;
        }), Te()), (!j || W[0] & 16 && L !== (L = "email-row expanded " + (A[4].click_action === "mailbox" ? "expanded-mailbox-thread" : ""))) && d(e, "class", L);
      },
      i: function i(A) {
        j || (C(E), C(B), C(S), C(z), j = !0);
      },
      o: function o(A) {
        F(E), F(B), F(S), F(z), j = !1;
      },
      d: function d(A) {
        A && m(e), E && E.d(), O && O.d(), B && B.d(), V[y].d(), z && z.d();
      }
    };
  }
  function ic(n) {
    return {
      c: T,
      m: T,
      p: T,
      i: T,
      o: T,
      d: T
    };
  }
  function rc(n) {
    var he, le, ke;
    var e,
      t,
      i,
      r,
      l,
      a,
      s,
      o,
      _c10,
      f,
      g,
      y,
      S = (n[14] ? "Sorry, looks like this thread is currently unavailable. It may\n                    have been deleted in your provider inbox." : !((he = n[3]) == null ? void 0 : he.snippet) && n[133] ? "This is a draft email" : ((le = n[3]) == null ? void 0 : le.snippet) ? n[3].snippet.replace(/\u200C /g, "") : "") + "",
      k,
      L,
      j = Object.keys(n[15]).length > 0,
      E,
      O,
      B = n[7].has_attachments && Object.keys(n[15]).length > 0,
      ae,
      V,
      Q,
      z,
      Y = n[4].show_star && $r(n),
      A = n[4].show_contact_avatar && qr(n);
    function W(D, ce) {
      return D[14] ? cc : sc;
    }
    var Oe = W(n),
      _e = Oe(n),
      se = n[4].show_number_of_messages && la(n),
      re = ((ke = n[3]) == null ? void 0 : ke.subject) && oa(n),
      J = j && sa(n),
      q = B && da();
    var de = [_c, mc],
      ee = [];
    function Z(D, ce) {
      return D[4].show_thread_actions ? 0 : D[4].show_received_timestamp ? 1 : -1;
    }
    return ~(V = Z(n)) && (Q = ee[V] = de[V](n)), {
      c: function c() {
        e = b("div"), Y && Y.c(), t = G(), i = b("div"), A && A.c(), r = G(), l = b("div"), _e.c(), s = G(), se && se.c(), o = G(), _c10 = b("div"), f = b("div"), re && re.c(), g = G(), y = b("span"), k = x(S), L = G(), J && J.c(), E = G(), O = b("div"), q && q.c(), ae = G(), Q && Q.c(), d(l, "class", "from-participants"), d(i, "class", "from-message-count"), d(e, "class", a = "from" + (n[4].show_star ? "-star" : "")), d(y, "class", "snippet"), Ae(y, "deleted", n[14]), d(f, "class", "subject-snippet"), d(_c10, "class", "subject-snippet-attachment"), Ae(O, "date", n[4].show_received_timestamp), Ae(O, "action-icons", n[4].show_thread_actions);
      },
      m: function m(D, ce) {
        p(D, e, ce), Y && Y.m(e, null), w(e, t), w(e, i), A && A.m(i, null), w(i, r), w(i, l), _e.m(l, null), p(D, s, ce), se && se.m(D, ce), p(D, o, ce), p(D, _c10, ce), w(_c10, f), re && re.m(f, null), w(f, g), w(f, y), w(y, k), w(_c10, L), J && J.m(_c10, null), p(D, E, ce), p(D, O, ce), q && q.m(O, null), w(O, ae), ~V && ee[V].m(O, null), z = !0;
      },
      p: function p(D, ce) {
        var P, oe, N;
        D[4].show_star ? Y ? Y.p(D, ce) : (Y = $r(D), Y.c(), Y.m(e, t)) : Y && (Y.d(1), Y = null), D[4].show_contact_avatar ? A ? (A.p(D, ce), ce[0] & 16 && C(A, 1)) : (A = qr(D), A.c(), C(A, 1), A.m(i, r)) : A && (Ee(), F(A, 1, 1, function () {
          A = null;
        }), Te()), Oe === (Oe = W(D)) && _e ? _e.p(D, ce) : (_e.d(1), _e = Oe(D), _e && (_e.c(), _e.m(l, null))), (!z || ce[0] & 16 && a !== (a = "from" + (D[4].show_star ? "-star" : ""))) && d(e, "class", a), D[4].show_number_of_messages ? se ? se.p(D, ce) : (se = la(D), se.c(), se.m(o.parentNode, o)) : se && (se.d(1), se = null), ((P = D[3]) == null ? void 0 : P.subject) ? re ? re.p(D, ce) : (re = oa(D), re.c(), re.m(f, g)) : re && (re.d(1), re = null), (!z || ce[0] & 16512) && S !== (S = (D[14] ? "Sorry, looks like this thread is currently unavailable. It may\n                    have been deleted in your provider inbox." : !((oe = D[3]) == null ? void 0 : oe.snippet) && D[133] ? "This is a draft email" : ((N = D[3]) == null ? void 0 : N.snippet) ? D[3].snippet.replace(/\u200C /g, "") : "") + "") && me(k, S), ce[0] & 16384 && Ae(y, "deleted", D[14]), ce[0] & 32768 && (j = Object.keys(D[15]).length > 0), j ? J ? J.p(D, ce) : (J = sa(D), J.c(), J.m(_c10, null)) : J && (J.d(1), J = null), ce[0] & 32896 && (B = D[7].has_attachments && Object.keys(D[15]).length > 0), B ? q ? ce[0] & 32896 && C(q, 1) : (q = da(), q.c(), C(q, 1), q.m(O, ae)) : q && (Ee(), F(q, 1, 1, function () {
          q = null;
        }), Te());
        var xe = V;
        V = Z(D), V === xe ? ~V && ee[V].p(D, ce) : (Q && (Ee(), F(ee[xe], 1, 1, function () {
          ee[xe] = null;
        }), Te()), ~V ? (Q = ee[V], Q ? Q.p(D, ce) : (Q = ee[V] = de[V](D), Q.c()), C(Q, 1), Q.m(O, null)) : Q = null), ce[0] & 16 && Ae(O, "date", D[4].show_received_timestamp), ce[0] & 16 && Ae(O, "action-icons", D[4].show_thread_actions);
      },
      i: function i(D) {
        z || (C(A), C(q), C(Q), z = !0);
      },
      o: function o(D) {
        F(A), F(q), F(Q), z = !1;
      },
      d: function d(D) {
        D && m(e), Y && Y.d(), A && A.d(), _e.d(), D && m(s), se && se.d(D), D && m(o), D && m(_c10), re && re.d(), J && J.d(), D && m(E), D && m(O), q && q.d(), ~V && ee[V].d();
      }
    };
  }
  function $r(n) {
    var e, t, i, r, l, a, s, o, c;
    return {
      c: function c() {
        e = b("div"), t = b("button"), d(t, "id", i = "thread-star-".concat(n[4].thread_id)), d(t, "class", r = n[7].starred ? "starred" : ""), t.value = l = n[4].thread_id, d(t, "role", "switch"), d(t, "aria-checked", a = n[7].starred), d(t, "aria-label", s = "Star button for thread ".concat(n[4].thread_id)), d(e, "class", "starred");
      },
      m: function m(f, g) {
        p(f, e, g), w(e, t), o || (c = ge(t, "click", nl(n[25])), o = !0);
      },
      p: function p(f, g) {
        g[0] & 16 && i !== (i = "thread-star-".concat(f[4].thread_id)) && d(t, "id", i), g[0] & 128 && r !== (r = f[7].starred ? "starred" : "") && d(t, "class", r), g[0] & 16 && l !== (l = f[4].thread_id) && (t.value = l), g[0] & 128 && a !== (a = f[7].starred) && d(t, "aria-checked", a), g[0] & 16 && s !== (s = "Star button for thread ".concat(f[4].thread_id)) && d(t, "aria-label", s);
      },
      d: function d(f) {
        f && m(e), o = !1, c();
      }
    };
  }
  function qr(n) {
    var e,
      t,
      _i10 = n[7] && ea(n);
    return {
      c: function c() {
        e = b("div"), _i10 && _i10.c(), d(e, "class", "default-avatar"), Ae(e, "deleted", n[14]), Ae(e, "draft-icon", n[133]);
      },
      m: function m(r, l) {
        p(r, e, l), _i10 && _i10.m(e, null), t = !0;
      },
      p: function p(r, l) {
        r[7] ? _i10 ? (_i10.p(r, l), l[0] & 128 && C(_i10, 1)) : (_i10 = ea(r), _i10.c(), C(_i10, 1), _i10.m(e, null)) : _i10 && (Ee(), F(_i10, 1, 1, function () {
          _i10 = null;
        }), Te()), l[0] & 16384 && Ae(e, "deleted", r[14]), l[0] & 128 && Ae(e, "draft-icon", r[133]);
      },
      i: function i(r) {
        t || (C(_i10), t = !0);
      },
      o: function o(r) {
        F(_i10), t = !1;
      },
      d: function d(r) {
        r && m(e), _i10 && _i10.d();
      }
    };
  }
  function ea(n) {
    var e, t, i, r;
    var l = [oc, lc, ac],
      a = [];
    function s(o, c) {
      return o[133] ? 0 : o[7].messages.length <= 0 ? 1 : 2;
    }
    return e = s(n), t = a[e] = l[e](n), {
      c: function c() {
        t.c(), i = Le();
      },
      m: function m(o, c) {
        a[e].m(o, c), p(o, i, c), r = !0;
      },
      p: function p(o, c) {
        var f = e;
        e = s(o), e === f ? a[e].p(o, c) : (Ee(), F(a[f], 1, 1, function () {
          a[f] = null;
        }), Te(), t = a[e], t ? t.p(o, c) : (t = a[e] = l[e](o), t.c()), C(t, 1), t.m(i.parentNode, i));
      },
      i: function i(o) {
        r || (C(t), r = !0);
      },
      o: function o(_o10) {
        F(t), r = !1;
      },
      d: function d(o) {
        a[e].d(o), o && m(i);
      }
    };
  }
  function ac(n) {
    var e;
    return {
      c: function c() {
        e = b("nylas-contact-image"), U(e, "contact_query", n[12]), U(e, "contact", n[10]);
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: function p(t, i) {
        i[0] & 4096 && U(e, "contact_query", t[12]), i[0] & 1024 && U(e, "contact", t[10]);
      },
      i: T,
      o: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function lc(n) {
    var e, t;
    return e = new xo({}), {
      c: function c() {
        He(e.$$.fragment);
      },
      m: function m(i, r) {
        Fe(e, i, r), t = !0;
      },
      p: T,
      i: function i(_i11) {
        t || (C(e.$$.fragment, _i11), t = !0);
      },
      o: function o(i) {
        F(e.$$.fragment, i), t = !1;
      },
      d: function d(i) {
        Re(e, i);
      }
    };
  }
  function oc(n) {
    var e, t;
    return e = new mr({}), {
      c: function c() {
        He(e.$$.fragment);
      },
      m: function m(i, r) {
        Fe(e, i, r), t = !0;
      },
      p: T,
      i: function i(_i12) {
        t || (C(e.$$.fragment, _i12), t = !0);
      },
      o: function o(i) {
        F(e.$$.fragment, i), t = !1;
      },
      d: function d(i) {
        Re(e, i);
      }
    };
  }
  function sc(n) {
    var e,
      t,
      i,
      r,
      l = Bn(n[7].messages, n[7].participants),
      a = {
        ctx: n,
        current: null,
        token: null,
        hasCatch: !1,
        pending: uc,
        then: dc,
        catch: fc,
        value: 18
      };
    mt(t = n[35](n[7]), a);
    var s = l && ia(n);
    return {
      c: function c() {
        e = b("span"), a.block.c(), i = G(), r = b("div"), s && s.c(), d(e, "class", "participants-name"), Ae(e, "condensed", Bn(n[7].messages, n[7].participants)), d(r, "class", "participants-count");
      },
      m: function m(o, c) {
        p(o, e, c), a.block.m(e, a.anchor = null), a.mount = function () {
          return e;
        }, a.anchor = null, p(o, i, c), p(o, r, c), s && s.m(r, null);
      },
      p: function p(o, c) {
        n = o, a.ctx = n, c[0] & 128 && t !== (t = n[35](n[7])) && mt(t, a) || nn(a, n, c), c[0] & 128 && Ae(e, "condensed", Bn(n[7].messages, n[7].participants)), c[0] & 128 && (l = Bn(n[7].messages, n[7].participants)), l ? s ? s.p(n, c) : (s = ia(n), s.c(), s.m(r, null)) : s && (s.d(1), s = null);
      },
      d: function d(o) {
        o && m(e), a.block.d(), a.token = null, a = null, o && m(i), o && m(r), s && s.d();
      }
    };
  }
  function cc(n) {
    var e;
    return {
      c: function c() {
        e = b("div"), e.innerHTML = '<span class="from-sub-section deleted-email">Deleted Email</span>', d(e, "class", "participants-name");
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function fc(n) {
    return {
      c: T,
      m: T,
      p: T,
      d: T
    };
  }
  function dc(n) {
    var e,
      t = n[18],
      i = [];
    for (var r = 0; r < t.length; r += 1) i[r] = na(jr(n, t, r));
    return {
      c: function c() {
        for (var _r3 = 0; _r3 < i.length; _r3 += 1) i[_r3].c();
        e = Le();
      },
      m: function m(r, l) {
        for (var a = 0; a < i.length; a += 1) i[a].m(r, l);
        p(r, e, l);
      },
      p: function p(r, l) {
        if (l[0] & 128 | l[1] & 16) {
          t = r[18];
          var a;
          for (a = 0; a < t.length; a += 1) {
            var s = jr(r, t, a);
            i[a] ? i[a].p(s, l) : (i[a] = na(s), i[a].c(), i[a].m(e.parentNode, e));
          }
          for (; a < i.length; a += 1) i[a].d(1);
          i.length = t.length;
        }
      },
      d: function d(r) {
        kt(i, r), r && m(e);
      }
    };
  }
  function ta(n) {
    var e;
    return {
      c: function c() {
        e = b("span"), e.textContent = ",\xA0", d(e, "class", "from-sub-section");
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function na(n) {
    var e,
      t = n[139] + "",
      i,
      r,
      l,
      a = n[141] < n[18].length - 1 && ta();
    return {
      c: function c() {
        e = b("span"), i = x(t), r = G(), a && a.c(), l = Le(), d(e, "class", "from-sub-section participant-label"), Ae(e, "draft-label", n[139] === "Draft");
      },
      m: function m(s, o) {
        p(s, e, o), w(e, i), p(s, r, o), a && a.m(s, o), p(s, l, o);
      },
      p: function p(s, o) {
        o[0] & 128 && t !== (t = s[139] + "") && me(i, t), o[0] & 128 | o[1] & 16 && Ae(e, "draft-label", s[139] === "Draft"), s[141] < s[18].length - 1 ? a || (a = ta(), a.c(), a.m(l.parentNode, l)) : a && (a.d(1), a = null);
      },
      d: function d(s) {
        s && m(e), s && m(r), a && a.d(s), s && m(l);
      }
    };
  }
  function uc(n) {
    return {
      c: T,
      m: T,
      p: T,
      d: T
    };
  }
  function ia(n) {
    var e,
      t,
      i = n[7].participants.length >= 2 && ra(n),
      r = n[7].participants.length > 2 && aa(n);
    return {
      c: function c() {
        i && i.c(), e = G(), r && r.c(), t = Le();
      },
      m: function m(l, a) {
        i && i.m(l, a), p(l, e, a), r && r.m(l, a), p(l, t, a);
      },
      p: function p(l, a) {
        l[7].participants.length >= 2 ? i ? i.p(l, a) : (i = ra(l), i.c(), i.m(e.parentNode, e)) : i && (i.d(1), i = null), l[7].participants.length > 2 ? r ? r.p(l, a) : (r = aa(l), r.c(), r.m(t.parentNode, t)) : r && (r.d(1), r = null);
      },
      d: function d(l) {
        i && i.d(l), l && m(e), r && r.d(l), l && m(t);
      }
    };
  }
  function ra(n) {
    var e,
      t,
      i = n[7].participants.length - ja + "",
      r;
    return {
      c: function c() {
        e = b("span"), t = x("+"), r = x(i), d(e, "class", "show-on-mobile");
      },
      m: function m(l, a) {
        p(l, e, a), w(e, t), w(e, r);
      },
      p: function p(l, a) {
        a[0] & 128 && i !== (i = l[7].participants.length - ja + "") && me(r, i);
      },
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function aa(n) {
    var e,
      t,
      i = n[7].participants.length - Ia + "",
      r;
    return {
      c: function c() {
        e = b("span"), t = x("\xA0 + "), r = x(i), d(e, "class", "show-on-desktop");
      },
      m: function m(l, a) {
        p(l, e, a), w(e, t), w(e, r);
      },
      p: function p(l, a) {
        a[0] & 128 && i !== (i = l[7].participants.length - Ia + "") && me(r, i);
      },
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function la(n) {
    var r, l;
    var e,
      t = (((l = (r = n[7]) == null ? void 0 : r.messages) == null ? void 0 : l.length) > 0 ? n[7].messages.length : "") + "",
      i;
    return {
      c: function c() {
        e = b("span"), i = x(t), d(e, "class", "thread-message-count");
      },
      m: function m(a, s) {
        p(a, e, s), w(e, i);
      },
      p: function p(a, s) {
        var o, c;
        s[0] & 128 && t !== (t = (((c = (o = a[7]) == null ? void 0 : o.messages) == null ? void 0 : c.length) > 0 ? a[7].messages.length : "") + "") && me(i, t);
      },
      d: function d(a) {
        a && m(e);
      }
    };
  }
  function oa(n) {
    var r;
    var e,
      t = ((r = n[3]) == null ? void 0 : r.subject) + "",
      i;
    return {
      c: function c() {
        e = b("span"), i = x(t), d(e, "class", "subject");
      },
      m: function m(l, a) {
        p(l, e, a), w(e, i);
      },
      p: function p(l, a) {
        var s;
        a[0] & 128 && t !== (t = ((s = l[3]) == null ? void 0 : s.subject) + "") && me(i, t);
      },
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function sa(n) {
    var e,
      t = Object.values(n[15]),
      i = [];
    for (var r = 0; r < t.length; r += 1) i[r] = fa(Rr(n, t, r));
    return {
      c: function c() {
        e = b("div");
        for (var _r4 = 0; _r4 < i.length; _r4 += 1) i[_r4].c();
        d(e, "class", "attachment");
      },
      m: function m(r, l) {
        p(r, e, l);
        for (var a = 0; a < i.length; a += 1) i[a].m(e, null);
      },
      p: function p(r, l) {
        if (l[0] & 32768 | l[1] & 32) {
          t = Object.values(r[15]);
          var a;
          for (a = 0; a < t.length; a += 1) {
            var s = Rr(r, t, a);
            i[a] ? i[a].p(s, l) : (i[a] = fa(s), i[a].c(), i[a].m(e, null));
          }
          for (; a < i.length; a += 1) i[a].d(1);
          i.length = t.length;
        }
      },
      d: function d(r) {
        r && m(e), kt(i, r);
      }
    };
  }
  function ca(n) {
    var e,
      t = (n[129].filename || n[129].id) + "",
      i,
      r,
      l,
      a;
    function s() {
      var _n3;
      for (var _len4 = arguments.length, o = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        o[_key4] = arguments[_key4];
      }
      return (_n3 = n)[91].apply(_n3, [n[129]].concat(o));
    }
    return {
      c: function c() {
        e = b("button"), i = x(t), r = G();
      },
      m: function m(o, c) {
        p(o, e, c), w(e, i), w(e, r), l || (a = ge(e, "click", s), l = !0);
      },
      p: function p(o, c) {
        n = o, c[0] & 32768 && t !== (t = (n[129].filename || n[129].id) + "") && me(i, t);
      },
      d: function d(o) {
        o && m(e), l = !1, a();
      }
    };
  }
  function fa(n) {
    var e,
      t = n[134],
      i = [];
    for (var r = 0; r < t.length; r += 1) i[r] = ca(Ir(n, t, r));
    return {
      c: function c() {
        for (var _r5 = 0; _r5 < i.length; _r5 += 1) i[_r5].c();
        e = Le();
      },
      m: function m(r, l) {
        for (var a = 0; a < i.length; a += 1) i[a].m(r, l);
        p(r, e, l);
      },
      p: function p(r, l) {
        if (l[0] & 32768 | l[1] & 32) {
          t = r[134];
          var a;
          for (a = 0; a < t.length; a += 1) {
            var s = Ir(r, t, a);
            i[a] ? i[a].p(s, l) : (i[a] = ca(s), i[a].c(), i[a].m(e.parentNode, e));
          }
          for (; a < i.length; a += 1) i[a].d(1);
          i.length = t.length;
        }
      },
      d: function d(r) {
        kt(i, r), r && m(e);
      }
    };
  }
  function da(n) {
    var e, t, _i13;
    return t = new zo({}), {
      c: function c() {
        e = b("span"), He(t.$$.fragment);
      },
      m: function m(r, l) {
        p(r, e, l), Fe(t, e, null), _i13 = !0;
      },
      i: function i(r) {
        _i13 || (C(t.$$.fragment, r), _i13 = !0);
      },
      o: function o(r) {
        F(t.$$.fragment, r), _i13 = !1;
      },
      d: function d(r) {
        r && m(e), Re(t);
      }
    };
  }
  function mc(n) {
    var e,
      t = n[33](new Date(n[3].last_message_timestamp * 1e3)) + "",
      i;
    return {
      c: function c() {
        e = b("span"), i = x(t);
      },
      m: function m(r, l) {
        p(r, e, l), w(e, i);
      },
      p: function p(r, l) {
        l[0] & 128 && t !== (t = r[33](new Date(r[3].last_message_timestamp * 1e3)) + "") && me(i, t);
      },
      i: T,
      o: T,
      d: function d(r) {
        r && m(e);
      }
    };
  }
  function _c(n) {
    var e, t, _i14, r, l, a, s, _o11, _c11, f, g, y, S;
    _i14 = new fr({});
    var k = [pc, hc],
      L = [];
    function j(E, O) {
      return E[7].unread ? 0 : 1;
    }
    return s = j(n), _o11 = L[s] = k[s](n), {
      c: function c() {
        e = b("div"), t = b("button"), He(_i14.$$.fragment), r = G(), l = b("div"), a = b("button"), _o11.c(), d(t, "title", "Delete thread"), d(t, "aria-label", "Delete thread"), d(e, "class", "delete"), d(a, "title", _c11 = "Mark thread as ".concat(n[7].unread ? "" : "un", "read")), d(a, "aria-label", f = "Mark thread as ".concat(n[7].unread ? "" : "un", "read")), d(l, "class", "read-status");
      },
      m: function m(E, O) {
        p(E, e, O), w(e, t), Fe(_i14, t, null), p(E, r, O), p(E, l, O), w(l, a), L[s].m(a, null), g = !0, y || (S = [ge(t, "click", Xe(n[21])), ge(a, "click", Xe(n[20]))], y = !0);
      },
      p: function p(E, O) {
        var B = s;
        s = j(E), s !== B && (Ee(), F(L[B], 1, 1, function () {
          L[B] = null;
        }), Te(), _o11 = L[s], _o11 || (_o11 = L[s] = k[s](E), _o11.c()), C(_o11, 1), _o11.m(a, null)), (!g || O[0] & 128 && _c11 !== (_c11 = "Mark thread as ".concat(E[7].unread ? "" : "un", "read"))) && d(a, "title", _c11), (!g || O[0] & 128 && f !== (f = "Mark thread as ".concat(E[7].unread ? "" : "un", "read"))) && d(a, "aria-label", f);
      },
      i: function i(E) {
        g || (C(_i14.$$.fragment, E), C(_o11), g = !0);
      },
      o: function o(E) {
        F(_i14.$$.fragment, E), F(_o11), g = !1;
      },
      d: function d(E) {
        E && m(e), Re(_i14), E && m(r), E && m(l), L[s].d(), y = !1, ot(S);
      }
    };
  }
  function hc(n) {
    var e, t;
    return e = new ur({
      props: {
        "aria-hidden": "true"
      }
    }), {
      c: function c() {
        He(e.$$.fragment);
      },
      m: function m(i, r) {
        Fe(e, i, r), t = !0;
      },
      i: function i(_i15) {
        t || (C(e.$$.fragment, _i15), t = !0);
      },
      o: function o(i) {
        F(e.$$.fragment, i), t = !1;
      },
      d: function d(i) {
        Re(e, i);
      }
    };
  }
  function pc(n) {
    var e, t;
    return e = new dr({
      props: {
        "aria-hidden": "true"
      }
    }), {
      c: function c() {
        He(e.$$.fragment);
      },
      m: function m(i, r) {
        Fe(e, i, r), t = !0;
      },
      i: function i(_i16) {
        t || (C(e.$$.fragment, _i16), t = !0);
      },
      o: function o(i) {
        F(e.$$.fragment, i), t = !1;
      },
      d: function d(i) {
        Re(e, i);
      }
    };
  }
  function gc(n) {
    return {
      c: T,
      m: T,
      p: T,
      i: T,
      o: T,
      d: T
    };
  }
  function ua(n) {
    var e, t, _i17, r, l;
    return t = new Vo({}), {
      c: function c() {
        e = b("button"), He(t.$$.fragment), d(e, "title", "Return to Mailbox"), d(e, "aria-label", "Return to Mailbox");
      },
      m: function m(a, s) {
        p(a, e, s), Fe(t, e, null), _i17 = !0, r || (l = ge(e, "click", Xe(n[23])), r = !0);
      },
      p: T,
      i: function i(a) {
        _i17 || (C(t.$$.fragment, a), _i17 = !0);
      },
      o: function o(a) {
        F(t.$$.fragment, a), _i17 = !1;
      },
      d: function d(a) {
        a && m(e), Re(t), r = !1, l();
      }
    };
  }
  function ma(n) {
    var e, t, i, r, l, a, s, o;
    return {
      c: function c() {
        e = b("div"), t = b("button"), d(t, "class", i = n[3].starred ? "starred" : ""), d(t, "title", r = n[3].starred ? "Unstar thread" : "Star thread"), d(t, "aria-label", l = n[3].starred ? "Unstar thread" : "Star thread"), d(t, "role", "switch"), d(t, "aria-checked", a = n[3].starred), d(e, "class", "starred");
      },
      m: function m(c, f) {
        p(c, e, f), w(e, t), s || (o = ge(t, "click", Xe(n[25])), s = !0);
      },
      p: function p(c, f) {
        f[0] & 128 && i !== (i = c[3].starred ? "starred" : "") && d(t, "class", i), f[0] & 128 && r !== (r = c[3].starred ? "Unstar thread" : "Star thread") && d(t, "title", r), f[0] & 128 && l !== (l = c[3].starred ? "Unstar thread" : "Star thread") && d(t, "aria-label", l), f[0] & 128 && a !== (a = c[3].starred) && d(t, "aria-checked", a);
      },
      d: function d(c) {
        c && m(e), s = !1, o();
      }
    };
  }
  function _a(n) {
    var e, t, _i18, r, l, a, s, _o12, _c12, f, g, y, S;
    _i18 = new fr({});
    var k = [bc, vc],
      L = [];
    function j(E, O) {
      return E[7].unread ? 0 : 1;
    }
    return s = j(n), _o12 = L[s] = k[s](n), {
      c: function c() {
        e = b("div"), t = b("button"), He(_i18.$$.fragment), r = G(), l = b("div"), a = b("button"), _o12.c(), d(t, "title", "Delete thread / Move to trash"), d(t, "aria-label", "Delete thread (Move to trash)"), d(e, "class", "delete"), d(a, "title", _c12 = "Mark thread as ".concat(n[7].unread ? "" : "un", "read")), d(a, "aria-label", f = "Mark thread as ".concat(n[7].unread ? "" : "un", "read")), d(l, "class", "read-status");
      },
      m: function m(E, O) {
        p(E, e, O), w(e, t), Fe(_i18, t, null), p(E, r, O), p(E, l, O), w(l, a), L[s].m(a, null), g = !0, y || (S = [ge(t, "click", Xe(n[80])), ge(a, "click", Xe(n[20]))], y = !0);
      },
      p: function p(E, O) {
        var B = s;
        s = j(E), s !== B && (Ee(), F(L[B], 1, 1, function () {
          L[B] = null;
        }), Te(), _o12 = L[s], _o12 || (_o12 = L[s] = k[s](E), _o12.c()), C(_o12, 1), _o12.m(a, null)), (!g || O[0] & 128 && _c12 !== (_c12 = "Mark thread as ".concat(E[7].unread ? "" : "un", "read"))) && d(a, "title", _c12), (!g || O[0] & 128 && f !== (f = "Mark thread as ".concat(E[7].unread ? "" : "un", "read"))) && d(a, "aria-label", f);
      },
      i: function i(E) {
        g || (C(_i18.$$.fragment, E), C(_o12), g = !0);
      },
      o: function o(E) {
        F(_i18.$$.fragment, E), F(_o12), g = !1;
      },
      d: function d(E) {
        E && m(e), Re(_i18), E && m(r), E && m(l), L[s].d(), y = !1, ot(S);
      }
    };
  }
  function vc(n) {
    var e, t;
    return e = new ur({
      props: {
        "aria-hidden": "true"
      }
    }), {
      c: function c() {
        He(e.$$.fragment);
      },
      m: function m(i, r) {
        Fe(e, i, r), t = !0;
      },
      i: function i(_i19) {
        t || (C(e.$$.fragment, _i19), t = !0);
      },
      o: function o(i) {
        F(e.$$.fragment, i), t = !1;
      },
      d: function d(i) {
        Re(e, i);
      }
    };
  }
  function bc(n) {
    var e, t;
    return e = new dr({
      props: {
        "aria-hidden": "true"
      }
    }), {
      c: function c() {
        He(e.$$.fragment);
      },
      m: function m(i, r) {
        Fe(e, i, r), t = !0;
      },
      i: function i(_i20) {
        t || (C(e.$$.fragment, _i20), t = !0);
      },
      o: function o(i) {
        F(e.$$.fragment, i), t = !1;
      },
      d: function d(i) {
        Re(e, i);
      }
    };
  }
  function wc(n) {
    var e,
      t = n[3].snippet + "",
      i;
    return {
      c: function c() {
        e = b("span"), i = x(t), d(e, "class", "snippet");
      },
      m: function m(r, l) {
        p(r, e, l), w(e, i);
      },
      p: function p(r, l) {
        l[0] & 128 && t !== (t = r[3].snippet + "") && me(i, t);
      },
      i: T,
      o: T,
      d: function d(r) {
        r && m(e);
      }
    };
  }
  function yc(n) {
    var e,
      t,
      _i21 = n[7].messages,
      r = [];
    for (var a = 0; a < _i21.length; a += 1) r[a] = Sa(Hr(n, _i21, a));
    var l = function l(a) {
      return F(r[a], 1, 1, function () {
        r[a] = null;
      });
    };
    return {
      c: function c() {
        for (var _a6 = 0; _a6 < r.length; _a6 += 1) r[_a6].c();
        e = Le();
      },
      m: function m(a, s) {
        for (var o = 0; o < r.length; o += 1) r[o].m(a, s);
        p(a, e, s), t = !0;
      },
      p: function p(a, s) {
        if (s[0] & 2080944626 | s[1] & 200) {
          _i21 = a[7].messages;
          var o;
          for (o = 0; o < _i21.length; o += 1) {
            var c = Hr(a, _i21, o);
            r[o] ? (r[o].p(c, s), C(r[o], 1)) : (r[o] = Sa(c), r[o].c(), C(r[o], 1), r[o].m(e.parentNode, e));
          }
          for (Ee(), o = _i21.length; o < r.length; o += 1) l(o);
          Te();
        }
      },
      i: function i(a) {
        if (!t) {
          for (var s = 0; s < _i21.length; s += 1) C(r[s]);
          t = !0;
        }
      },
      o: function o(a) {
        r = r.filter(Boolean);
        for (var s = 0; s < r.length; s += 1) F(r[s]);
        t = !1;
      },
      d: function d(a) {
        kt(r, a), a && m(e);
      }
    };
  }
  function kc(n) {
    var Q, z, Y;
    var e,
      t,
      i,
      r,
      l,
      a = (n[8] && ((Q = n[2]) == null ? void 0 : Q.from[0].email) === n[8] ? "me" : ((z = n[2]) == null ? void 0 : z.from[0].name) || ((Y = n[2]) == null ? void 0 : Y.from[0].email)) + "",
      s,
      o,
      _c13,
      f,
      g,
      y,
      S,
      k,
      L,
      j = n[2].snippet + "",
      E,
      O,
      B,
      ae = n[4].show_contact_avatar && ha(n),
      V = n[4].show_received_timestamp && pa(n);
    return {
      c: function c() {
        var A, W;
        e = b("div"), t = b("div"), ae && ae.c(), i = G(), r = b("div"), l = b("span"), s = x(a), o = G(), _c13 = b("nylas-tooltip"), y = G(), S = b("section"), V && V.c(), k = G(), L = b("div"), E = x(j), d(l, "class", "name"), U(_c13, "id", f = (A = n[2]) == null ? void 0 : A.id.slice(0, 3)), U(_c13, "current_tooltip_id", n[13]), U(_c13, "icon", ln), U(_c13, "content", g = (W = n[2]) == null ? void 0 : W.from[0].email), d(r, "class", "message-from"), d(t, "class", "avatar-info"), d(e, "class", "message-head"), d(L, "class", "snippet");
      },
      m: function m(A, W) {
        p(A, e, W), w(e, t), ae && ae.m(t, null), w(t, i), w(t, r), w(r, l), w(l, s), w(r, o), w(r, _c13), w(e, y), w(e, S), V && V.m(S, null), p(A, k, W), p(A, L, W), w(L, E), O || (B = ge(_c13, "toggleTooltip", n[34]), O = !0);
      },
      p: function p(A, W) {
        var Oe, _e, se, re, J;
        A[4].show_contact_avatar ? ae ? ae.p(A, W) : (ae = ha(A), ae.c(), ae.m(t, i)) : ae && (ae.d(1), ae = null), W[0] & 384 && a !== (a = (A[8] && ((Oe = A[2]) == null ? void 0 : Oe.from[0].email) === A[8] ? "me" : ((_e = A[2]) == null ? void 0 : _e.from[0].name) || ((se = A[2]) == null ? void 0 : se.from[0].email)) + "") && me(s, a), W[0] & 128 && f !== (f = (re = A[2]) == null ? void 0 : re.id.slice(0, 3)) && U(_c13, "id", f), W[0] & 8192 && U(_c13, "current_tooltip_id", A[13]), W[0] & 128 && g !== (g = (J = A[2]) == null ? void 0 : J.from[0].email) && U(_c13, "content", g), A[4].show_received_timestamp ? V ? V.p(A, W) : (V = pa(A), V.c(), V.m(S, null)) : V && (V.d(1), V = null), W[0] & 128 && j !== (j = A[2].snippet + "") && me(E, j);
      },
      i: T,
      o: T,
      d: function d(A) {
        A && m(e), ae && ae.d(), V && V.d(), A && m(k), A && m(L), O = !1, B();
      }
    };
  }
  function Ec(n) {
    var ke, D, ce, xe;
    var e,
      t,
      i,
      r,
      l,
      a,
      s = (n[8] && ((ke = n[2]) == null ? void 0 : ke.from[0].email) === n[8] ? "me" : ((D = n[2]) == null ? void 0 : D.from[0].name) || ((ce = n[2]) == null ? void 0 : ce.from[0].email)) + "",
      o,
      _c14,
      f,
      g,
      y,
      S,
      k,
      L,
      j,
      E,
      O,
      B,
      ae = n[4].show_reply_all && n[28](n[2]),
      V,
      Q,
      z,
      Y,
      A,
      W,
      Oe,
      _e,
      se = n[4].show_contact_avatar && ga(n),
      re = ((xe = n[2]) == null ? void 0 : xe.to) && va(n),
      J = n[4].show_received_timestamp && ya(n),
      q = n[4].show_reply && ka(n),
      de = ae && Ea(n),
      ee = n[4].show_forward && Ta(n);
    var Z = [Ic, Rc, Pc, Dc],
      he = [];
    function le(P, oe) {
      return P[4].clean_conversation && P[2].conversation ? 0 : P[2] && P[2].body != null ? 1 : !!P[4].thread && !P[4].thread_id && P[1] != "mailbox" ? 2 : 3;
    }
    return Y = le(n), A = he[Y] = Z[Y](n), {
      c: function c() {
        var P, oe;
        e = b("div"), t = b("div"), i = b("div"), se && se.c(), r = G(), l = b("div"), a = b("span"), o = x(s), _c14 = G(), f = b("nylas-tooltip"), S = G(), k = b("div"), re && re.c(), L = G(), j = b("div"), J && J.c(), E = G(), O = b("div"), q && q.c(), B = G(), de && de.c(), V = G(), ee && ee.c(), Q = G(), z = b("div"), A.c(), d(a, "class", "name"), U(f, "id", g = (P = n[2]) == null ? void 0 : P.id.slice(0, 3)), U(f, "current_tooltip_id", n[13]), U(f, "icon", ln), U(f, "content", y = (oe = n[2]) == null ? void 0 : oe.from[0].email), d(l, "class", "message-from"), d(i, "class", "avatar-info"), d(k, "class", "message-to"), d(t, "class", "message-from-to"), d(O, "aria-label", "Email Actions"), d(O, "role", "toolbar"), d(j, "class", ""), d(e, "class", "message-head"), d(z, "class", "message-body");
      },
      m: function m(P, oe) {
        p(P, e, oe), w(e, t), w(t, i), se && se.m(i, null), w(i, r), w(i, l), w(l, a), w(a, o), w(l, _c14), w(l, f), w(t, S), w(t, k), re && re.m(k, null), w(e, L), w(e, j), J && J.m(j, null), w(j, E), w(j, O), q && q.m(O, null), w(O, B), de && de.m(O, null), w(O, V), ee && ee.m(O, null), p(P, Q, oe), p(P, z, oe), he[Y].m(z, null), W = !0, Oe || (_e = ge(f, "toggleTooltip", n[34]), Oe = !0);
      },
      p: function p(P, oe) {
        var pt, ct, it, $e, Ce, be;
        P[4].show_contact_avatar ? se ? se.p(P, oe) : (se = ga(P), se.c(), se.m(i, r)) : se && (se.d(1), se = null), (!W || oe[0] & 384) && s !== (s = (P[8] && ((pt = P[2]) == null ? void 0 : pt.from[0].email) === P[8] ? "me" : ((ct = P[2]) == null ? void 0 : ct.from[0].name) || ((it = P[2]) == null ? void 0 : it.from[0].email)) + "") && me(o, s), (!W || oe[0] & 128 && g !== (g = ($e = P[2]) == null ? void 0 : $e.id.slice(0, 3))) && U(f, "id", g), (!W || oe[0] & 8192) && U(f, "current_tooltip_id", P[13]), (!W || oe[0] & 128 && y !== (y = (Ce = P[2]) == null ? void 0 : Ce.from[0].email)) && U(f, "content", y), ((be = P[2]) == null ? void 0 : be.to) ? re ? re.p(P, oe) : (re = va(P), re.c(), re.m(k, null)) : re && (re.d(1), re = null), P[4].show_received_timestamp ? J ? J.p(P, oe) : (J = ya(P), J.c(), J.m(j, E)) : J && (J.d(1), J = null), P[4].show_reply ? q ? (q.p(P, oe), oe[0] & 16 && C(q, 1)) : (q = ka(P), q.c(), C(q, 1), q.m(O, B)) : q && (Ee(), F(q, 1, 1, function () {
          q = null;
        }), Te()), oe[0] & 144 && (ae = P[4].show_reply_all && P[28](P[2])), ae ? de ? (de.p(P, oe), oe[0] & 144 && C(de, 1)) : (de = Ea(P), de.c(), C(de, 1), de.m(O, V)) : de && (Ee(), F(de, 1, 1, function () {
          de = null;
        }), Te()), P[4].show_forward ? ee ? (ee.p(P, oe), oe[0] & 16 && C(ee, 1)) : (ee = Ta(P), ee.c(), C(ee, 1), ee.m(O, null)) : ee && (Ee(), F(ee, 1, 1, function () {
          ee = null;
        }), Te());
        var N = Y;
        Y = le(P), Y === N ? he[Y].p(P, oe) : (Ee(), F(he[N], 1, 1, function () {
          he[N] = null;
        }), Te(), A = he[Y], A ? A.p(P, oe) : (A = he[Y] = Z[Y](P), A.c()), C(A, 1), A.m(z, null));
      },
      i: function i(P) {
        W || (C(q), C(de), C(ee), C(A), W = !0);
      },
      o: function o(P) {
        F(q), F(de), F(ee), F(A), W = !1;
      },
      d: function d(P) {
        P && m(e), se && se.d(), re && re.d(), J && J.d(), q && q.d(), de && de.d(), ee && ee.d(), P && m(Q), P && m(z), he[Y].d(), Oe = !1, _e();
      }
    };
  }
  function ha(n) {
    var e, t, i;
    return {
      c: function c() {
        var r;
        e = b("div"), t = b("nylas-contact-image"), U(t, "contact_query", n[12]), U(t, "contact", i = n[5][(r = n[2]) == null ? void 0 : r.from[0].email]), d(e, "class", "default-avatar");
      },
      m: function m(r, l) {
        p(r, e, l), w(e, t);
      },
      p: function p(r, l) {
        var a;
        l[0] & 4096 && U(t, "contact_query", r[12]), l[0] & 160 && i !== (i = r[5][(a = r[2]) == null ? void 0 : a.from[0].email]) && U(t, "contact", i);
      },
      d: function d(r) {
        r && m(e);
      }
    };
  }
  function pa(n) {
    var e,
      t,
      i = Ft(new Date(n[2].date * 1e3)) + "",
      r;
    return {
      c: function c() {
        e = b("div"), t = b("span"), r = x(i), d(e, "class", "message-date");
      },
      m: function m(l, a) {
        p(l, e, a), w(e, t), w(t, r);
      },
      p: function p(l, a) {
        a[0] & 128 && i !== (i = Ft(new Date(l[2].date * 1e3)) + "") && me(r, i);
      },
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function ga(n) {
    var e, t, i;
    return {
      c: function c() {
        var r;
        e = b("div"), t = b("nylas-contact-image"), U(t, "contact_query", n[12]), U(t, "contact", i = n[5][(r = n[2]) == null ? void 0 : r.from[0].email]), d(e, "class", "default-avatar");
      },
      m: function m(r, l) {
        p(r, e, l), w(e, t);
      },
      p: function p(r, l) {
        var a;
        l[0] & 4096 && U(t, "contact_query", r[12]), l[0] & 160 && i !== (i = r[5][(a = r[2]) == null ? void 0 : a.from[0].email]) && U(t, "contact", i);
      },
      d: function d(r) {
        r && m(e);
      }
    };
  }
  function va(n) {
    var e,
      t,
      i = {
        ctx: n,
        current: null,
        token: null,
        hasCatch: !1,
        pending: Mc,
        then: Ac,
        catch: Tc,
        value: 123
      };
    return mt(t = n[38]({
      to: n[2].to,
      cc: n[2].cc,
      bcc: n[2].bcc
    }), i), {
      c: function c() {
        e = Le(), i.block.c();
      },
      m: function m(r, l) {
        p(r, e, l), i.block.m(r, i.anchor = l), i.mount = function () {
          return e.parentNode;
        }, i.anchor = e;
      },
      p: function p(r, l) {
        n = r, i.ctx = n, l[0] & 128 && t !== (t = n[38]({
          to: n[2].to,
          cc: n[2].cc,
          bcc: n[2].bcc
        })) && mt(t, i) || nn(i, n, l);
      },
      d: function d(r) {
        r && m(e), i.block.d(r), i.token = null, i = null;
      }
    };
  }
  function Tc(n) {
    return {
      c: T,
      m: T,
      p: T,
      d: T
    };
  }
  function Ac(n) {
    var e,
      t,
      i = n[123].slice(0, Je),
      r = [];
    for (var a = 0; a < i.length; a += 1) r[a] = ba(Br(n, i, a));
    var l = n[123].length > Je && wa(n);
    return {
      c: function c() {
        for (var _a7 = 0; _a7 < r.length; _a7 += 1) r[_a7].c();
        e = G(), l && l.c(), t = Le();
      },
      m: function m(a, s) {
        for (var o = 0; o < r.length; o += 1) r[o].m(a, s);
        p(a, e, s), l && l.m(a, s), p(a, t, s);
      },
      p: function p(a, s) {
        if (s[0] & 144 | s[1] & 128) {
          i = a[123].slice(0, Je);
          var o;
          for (o = 0; o < i.length; o += 1) {
            var c = Br(a, i, o);
            r[o] ? r[o].p(c, s) : (r[o] = ba(c), r[o].c(), r[o].m(e.parentNode, e));
          }
          for (; o < r.length; o += 1) r[o].d(1);
          r.length = i.length;
        }
        a[123].length > Je ? l ? l.p(a, s) : (l = wa(a), l.c(), l.m(t.parentNode, t)) : l && (l.d(1), l = null);
      },
      d: function d(a) {
        kt(r, a), a && m(e), l && l.d(a), a && m(t);
      }
    };
  }
  function Oc(n) {
    var e;
    return {
      c: function c() {
        e = x("bcc:");
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function Sc(n) {
    var e;
    return {
      c: function c() {
        e = x("cc:");
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function Cc(n) {
    var e = "to ".concat(n[4].you && n[124].email === n[4].you.email_address ? "Me" : ""),
      t;
    return {
      c: function c() {
        t = x(e);
      },
      m: function m(i, r) {
        p(i, t, r);
      },
      p: function p(i, r) {
        r[0] & 144 && e !== (e = "to ".concat(i[4].you && i[124].email === i[4].you.email_address ? "Me" : "")) && me(t, e);
      },
      d: function d(i) {
        i && m(t);
      }
    };
  }
  function Nc(n) {
    var e = n[124].email + "",
      t;
    return {
      c: function c() {
        t = x(e);
      },
      m: function m(i, r) {
        p(i, t, r);
      },
      p: function p(i, r) {
        r[0] & 128 && e !== (e = i[124].email + "") && me(t, e);
      },
      d: function d(i) {
        i && m(t);
      }
    };
  }
  function Lc(n) {
    var s;
    var e = ((s = n[124].name) != null ? s : n[4].you.name) + "",
      t,
      i,
      r = n[124].email + "",
      l,
      a;
    return {
      c: function c() {
        t = x(e), i = x(" <"), l = x(r), a = x(">");
      },
      m: function m(o, c) {
        p(o, t, c), p(o, i, c), p(o, l, c), p(o, a, c);
      },
      p: function p(o, c) {
        var f;
        c[0] & 144 && e !== (e = ((f = o[124].name) != null ? f : o[4].you.name) + "") && me(t, e), c[0] & 128 && r !== (r = o[124].email + "") && me(l, r);
      },
      d: function d(o) {
        o && m(t), o && m(i), o && m(l), o && m(a);
      }
    };
  }
  function ba(n) {
    var e, t;
    function i(c, f) {
      if (c[126] === 0) return Cc;
      if (c[124]._type === "cc" && c[126] === c[2].to.length) return Sc;
      if (c[124]._type === "bcc" && c[126] === c[2].to.length + c[2].cc.length) return Oc;
    }
    var r = i(n),
      l = r && r(n);
    function a(c, f) {
      if (c[124].email && c[124].name) return Lc;
      if (c[124].email && !c[124].name) return Nc;
    }
    var s = a(n),
      o = s && s(n);
    return {
      c: function c() {
        e = b("p"), l && l.c(), t = G(), o && o.c();
      },
      m: function m(c, f) {
        p(c, e, f), l && l.m(e, null), w(e, t), o && o.m(e, null);
      },
      p: function p(c, f) {
        r === (r = i(c)) && l ? l.p(c, f) : (l && l.d(1), l = r && r(c), l && (l.c(), l.m(e, t))), s === (s = a(c)) && o ? o.p(c, f) : (o && o.d(1), o = s && s(c), o && (o.c(), o.m(e, null)));
      },
      d: function d(c) {
        c && m(e), l && l.d(), o && o.d();
      }
    };
  }
  function wa(n) {
    var e, t, i, r, l, a, s;
    return {
      c: function c() {
        e = b("div"), t = b("nylas-tooltip"), U(t, "id", i = "show-more-participants-".concat(n[2].id)), U(t, "current_tooltip_id", n[13]), U(t, "icon", ln), U(t, "text", r = "And ".concat(n[123].length - Je, " more")), U(t, "content", l = "".concat(sn(n[123])));
      },
      m: function m(o, c) {
        p(o, e, c), w(e, t), a || (s = ge(t, "toggleTooltip", n[34]), a = !0);
      },
      p: function p(o, c) {
        c[0] & 128 && i !== (i = "show-more-participants-".concat(o[2].id)) && U(t, "id", i), c[0] & 8192 && U(t, "current_tooltip_id", o[13]), c[0] & 128 && r !== (r = "And ".concat(o[123].length - Je, " more")) && U(t, "text", r), c[0] & 128 && l !== (l = "".concat(sn(o[123]))) && U(t, "content", l);
      },
      d: function d(o) {
        o && m(e), a = !1, s();
      }
    };
  }
  function Mc(n) {
    return {
      c: T,
      m: T,
      p: T,
      d: T
    };
  }
  function ya(n) {
    var e,
      t,
      i = Ft(new Date(n[2].date * 1e3)) + "",
      r;
    return {
      c: function c() {
        e = b("div"), t = b("span"), r = x(i), d(e, "class", "message-date");
      },
      m: function m(l, a) {
        p(l, e, a), w(e, t), w(t, r);
      },
      p: function p(l, a) {
        a[0] & 128 && i !== (i = Ft(new Date(l[2].date * 1e3)) + "") && me(r, i);
      },
      d: function d(l) {
        l && m(e);
      }
    };
  }
  function ka(n) {
    var e, t, _i22, r, l, a;
    _i22 = new Lr({
      props: {
        "aria-hidden": "true"
      }
    });
    function s() {
      var _n4;
      for (var _len5 = arguments.length, o = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        o[_key5] = arguments[_key5];
      }
      return (_n4 = n)[81].apply(_n4, [n[2]].concat(o));
    }
    return {
      c: function c() {
        e = b("div"), t = b("button"), He(_i22.$$.fragment), d(t, "title", "Reply"), d(t, "aria-label", "Reply"), d(e, "class", "reply");
      },
      m: function m(o, c) {
        p(o, e, c), w(e, t), Fe(_i22, t, null), r = !0, l || (a = ge(t, "click", Xe(s)), l = !0);
      },
      p: function p(o, c) {
        n = o;
      },
      i: function i(o) {
        r || (C(_i22.$$.fragment, o), r = !0);
      },
      o: function o(_o13) {
        F(_i22.$$.fragment, _o13), r = !1;
      },
      d: function d(o) {
        o && m(e), Re(_i22), l = !1, a();
      }
    };
  }
  function Ea(n) {
    var e, t, _i23, r, l, a;
    _i23 = new Mr({
      props: {
        "aria-hidden": "true"
      }
    });
    function s() {
      var _n5;
      for (var _len6 = arguments.length, o = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        o[_key6] = arguments[_key6];
      }
      return (_n5 = n)[82].apply(_n5, [n[2]].concat(o));
    }
    return {
      c: function c() {
        e = b("div"), t = b("button"), He(_i23.$$.fragment), d(t, "title", "Reply all"), d(t, "aria-label", "Reply all"), d(e, "class", "reply-all");
      },
      m: function m(o, c) {
        p(o, e, c), w(e, t), Fe(_i23, t, null), r = !0, l || (a = ge(t, "click", Xe(s)), l = !0);
      },
      p: function p(o, c) {
        n = o;
      },
      i: function i(o) {
        r || (C(_i23.$$.fragment, o), r = !0);
      },
      o: function o(_o14) {
        F(_i23.$$.fragment, _o14), r = !1;
      },
      d: function d(o) {
        o && m(e), Re(_i23), l = !1, a();
      }
    };
  }
  function Ta(n) {
    var e, t, _i24, r, l, a;
    _i24 = new Dr({
      props: {
        "aria-hidden": "true"
      }
    });
    function s() {
      var _n6;
      for (var _len7 = arguments.length, o = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        o[_key7] = arguments[_key7];
      }
      return (_n6 = n)[83].apply(_n6, [n[2]].concat(o));
    }
    return {
      c: function c() {
        e = b("div"), t = b("button"), He(_i24.$$.fragment), d(t, "title", "Forward"), d(t, "aria-label", "Forward"), d(e, "class", "forward");
      },
      m: function m(o, c) {
        p(o, e, c), w(e, t), Fe(_i24, t, null), r = !0, l || (a = ge(t, "click", Xe(s)), l = !0);
      },
      p: function p(o, c) {
        n = o;
      },
      i: function i(o) {
        r || (C(_i24.$$.fragment, o), r = !0);
      },
      o: function o(_o15) {
        F(_i24.$$.fragment, _o15), r = !1;
      },
      d: function d(o) {
        o && m(e), Re(_i24), l = !1, a();
      }
    };
  }
  function Dc(n) {
    var e, t, i, r;
    return t = new As({
      props: {
        class: "spinner"
      }
    }), {
      c: function c() {
        e = b("div"), He(t.$$.fragment), i = x("\n                          Loading..."), d(e, "class", "email-loader");
      },
      m: function m(l, a) {
        p(l, e, a), Fe(t, e, null), w(e, i), r = !0;
      },
      p: T,
      i: function i(l) {
        r || (C(t.$$.fragment, l), r = !0);
      },
      o: function o(l) {
        F(t.$$.fragment, l), r = !1;
      },
      d: function d(l) {
        l && m(e), Re(t);
      }
    };
  }
  function Pc(n) {
    var s;
    var e = ((s = n[2].body) != null ? s : n[2].snippet) + "",
      t,
      i,
      r = n[15][n[2].id] && Array.isArray(n[15][n[2].id]) && n[15][n[2].id].length > 0,
      l,
      a = r && Aa(n);
    return {
      c: function c() {
        t = x(e), i = G(), a && a.c(), l = Le();
      },
      m: function m(o, c) {
        p(o, t, c), p(o, i, c), a && a.m(o, c), p(o, l, c);
      },
      p: function p(o, c) {
        var f;
        c[0] & 128 && e !== (e = ((f = o[2].body) != null ? f : o[2].snippet) + "") && me(t, e), c[0] & 32896 && (r = o[15][o[2].id] && Array.isArray(o[15][o[2].id]) && o[15][o[2].id].length > 0), r ? a ? a.p(o, c) : (a = Aa(o), a.c(), a.m(l.parentNode, l)) : a && (a.d(1), a = null);
      },
      i: T,
      o: T,
      d: function d(o) {
        o && m(t), o && m(i), a && a.d(o), o && m(l);
      }
    };
  }
  function Rc(n) {
    var e, t, i, r, l;
    return {
      c: function c() {
        e = b("nylas-message-body"), U(e, "message", t = n[2]), U(e, "body", i = n[2].body);
      },
      m: function m(a, s) {
        p(a, e, s), r || (l = ge(e, "downloadClicked", n[37]), r = !0);
      },
      p: function p(a, s) {
        s[0] & 128 && t !== (t = a[2]) && U(e, "message", t), s[0] & 128 && i !== (i = a[2].body) && U(e, "body", i);
      },
      i: T,
      o: T,
      d: function d(a) {
        a && m(e), r = !1, l();
      }
    };
  }
  function Ic(n) {
    var e,
      t = on.sanitize(n[2].conversation) + "",
      i;
    return {
      c: function c() {
        e = new pn(!1), i = Le(), e.a = i;
      },
      m: function m(r, l) {
        e.m(t, r, l), p(r, i, l);
      },
      p: function p(r, l) {
        l[0] & 128 && t !== (t = on.sanitize(r[2].conversation) + "") && e.p(t);
      },
      i: T,
      o: T,
      d: function d(r) {
        r && m(i), r && e.d();
      }
    };
  }
  function Aa(n) {
    var e,
      t = n[15][n[2].id],
      i = [];
    for (var r = 0; r < t.length; r += 1) i[r] = Oa(zr(n, t, r));
    return {
      c: function c() {
        e = b("div");
        for (var _r6 = 0; _r6 < i.length; _r6 += 1) i[_r6].c();
        d(e, "class", "attachment");
      },
      m: function m(r, l) {
        p(r, e, l);
        for (var a = 0; a < i.length; a += 1) i[a].m(e, null);
      },
      p: function p(r, l) {
        if (l[0] & 557184) {
          t = r[15][r[2].id];
          var a;
          for (a = 0; a < t.length; a += 1) {
            var s = zr(r, t, a);
            i[a] ? i[a].p(s, l) : (i[a] = Oa(s), i[a].c(), i[a].m(e, null));
          }
          for (; a < i.length; a += 1) i[a].d(1);
          i.length = t.length;
        }
      },
      d: function d(r) {
        r && m(e), kt(i, r);
      }
    };
  }
  function Oa(n) {
    var e,
      t = (n[129].filename || n[129].id) + "",
      i,
      r,
      l,
      a;
    function s() {
      var _n7;
      for (var _len8 = arguments.length, o = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        o[_key8] = arguments[_key8];
      }
      return (_n7 = n)[84].apply(_n7, [n[129]].concat(o));
    }
    return {
      c: function c() {
        e = b("button"), i = x(t), r = G();
      },
      m: function m(o, c) {
        p(o, e, c), w(e, i), w(e, r), l || (a = ge(e, "click", Xe(s)), l = !0);
      },
      p: function p(o, c) {
        n = o, c[0] & 32896 && t !== (t = (n[129].filename || n[129].id) + "") && me(i, t);
      },
      d: function d(o) {
        o && m(e), l = !1, a();
      }
    };
  }
  function Sa(n) {
    var e,
      t,
      _i25,
      r,
      l,
      a = n[128],
      s,
      o,
      c;
    var f = [Ec, kc],
      g = [];
    function y(E, O) {
      return E[2].expanded || E[128] === E[7].messages.length - 1 ? 0 : 1;
    }
    t = y(n), _i25 = g[t] = f[t](n);
    var S = function S() {
        return n[85](e, a);
      },
      k = function k() {
        return n[85](null, a);
      };
    function L() {
      var _n8;
      for (var _len9 = arguments.length, E = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        E[_key9] = arguments[_key9];
      }
      return (_n8 = n)[86].apply(_n8, [n[128]].concat(E));
    }
    function j() {
      var _n9;
      for (var _len10 = arguments.length, E = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        E[_key10] = arguments[_key10];
      }
      return (_n9 = n)[87].apply(_n9, [n[128]].concat(E));
    }
    return {
      c: function c() {
        e = b("div"), _i25.c(), r = G(), d(e, "class", l = "individual-message ".concat(n[128] === n[7].messages.length - 1 || n[2].expanded ? "expanded" : "condensed")), Ae(e, "last-message", n[128] === n[7].messages.length - 1);
      },
      m: function m(E, O) {
        p(E, e, O), g[t].m(e, null), w(e, r), S(), s = !0, o || (c = [ge(e, "click", Xe(L)), ge(e, "keypress", j)], o = !0);
      },
      p: function p(E, O) {
        n = E;
        var B = t;
        t = y(n), t === B ? g[t].p(n, O) : (Ee(), F(g[B], 1, 1, function () {
          g[B] = null;
        }), Te(), _i25 = g[t], _i25 ? _i25.p(n, O) : (_i25 = g[t] = f[t](n), _i25.c()), C(_i25, 1), _i25.m(e, r)), (!s || O[0] & 128 && l !== (l = "individual-message ".concat(n[128] === n[7].messages.length - 1 || n[2].expanded ? "expanded" : "condensed"))) && d(e, "class", l), a !== n[128] && (k(), a = n[128], S()), O[0] & 128 && Ae(e, "last-message", n[128] === n[7].messages.length - 1);
      },
      i: function i(E) {
        s || (C(_i25), s = !0);
      },
      o: function o(E) {
        F(_i25), s = !1;
      },
      d: function d(E) {
        E && m(e), g[t].d(), k(), o = !1, ot(c);
      }
    };
  }
  function Ca(n) {
    var e,
      t,
      _i26 = n[7].drafts,
      r = [];
    for (var a = 0; a < _i26.length; a += 1) r[a] = Ra(Fr(n, _i26, a));
    var l = function l(a) {
      return F(r[a], 1, 1, function () {
        r[a] = null;
      });
    };
    return {
      c: function c() {
        for (var _a8 = 0; _a8 < r.length; _a8 += 1) r[_a8].c();
        e = Le();
      },
      m: function m(a, s) {
        for (var o = 0; o < r.length; o += 1) r[o].m(a, s);
        p(a, e, s), t = !0;
      },
      p: function p(a, s) {
        if (s[0] & 8400 | s[1] & 139) {
          _i26 = a[7].drafts;
          var o;
          for (o = 0; o < _i26.length; o += 1) {
            var c = Fr(a, _i26, o);
            r[o] ? (r[o].p(c, s), C(r[o], 1)) : (r[o] = Ra(c), r[o].c(), C(r[o], 1), r[o].m(e.parentNode, e));
          }
          for (Ee(), o = _i26.length; o < r.length; o += 1) l(o);
          Te();
        }
      },
      i: function i(a) {
        if (!t) {
          for (var s = 0; s < _i26.length; s += 1) C(r[s]);
          t = !0;
        }
      },
      o: function o(a) {
        r = r.filter(Boolean);
        for (var s = 0; s < r.length; s += 1) F(r[s]);
        t = !1;
      },
      d: function d(a) {
        kt(r, a), a && m(e);
      }
    };
  }
  function Na(n) {
    var e, t, _i27;
    return t = new mr({}), {
      c: function c() {
        e = b("div"), He(t.$$.fragment), d(e, "class", "default-avatar draft");
      },
      m: function m(r, l) {
        p(r, e, l), Fe(t, e, null), _i27 = !0;
      },
      i: function i(r) {
        _i27 || (C(t.$$.fragment, r), _i27 = !0);
      },
      o: function o(r) {
        F(t.$$.fragment, r), _i27 = !1;
      },
      d: function d(r) {
        r && m(e), Re(t);
      }
    };
  }
  function La(n) {
    var e,
      t,
      i = {
        ctx: n,
        current: null,
        token: null,
        hasCatch: !1,
        pending: Vc,
        then: Fc,
        catch: jc,
        value: 123
      };
    return mt(t = n[38]({
      to: n[120].to,
      cc: n[120].cc,
      bcc: n[120].bcc
    }), i), {
      c: function c() {
        e = Le(), i.block.c();
      },
      m: function m(r, l) {
        p(r, e, l), i.block.m(r, i.anchor = l), i.mount = function () {
          return e.parentNode;
        }, i.anchor = e;
      },
      p: function p(r, l) {
        n = r, i.ctx = n, l[0] & 128 && t !== (t = n[38]({
          to: n[120].to,
          cc: n[120].cc,
          bcc: n[120].bcc
        })) && mt(t, i) || nn(i, n, l);
      },
      d: function d(r) {
        r && m(e), i.block.d(r), i.token = null, i = null;
      }
    };
  }
  function jc(n) {
    return {
      c: T,
      m: T,
      p: T,
      d: T
    };
  }
  function Fc(n) {
    var e,
      t,
      i = n[123].slice(0, Je),
      r = [];
    for (var a = 0; a < i.length; a += 1) r[a] = Ma(Ur(n, i, a));
    var l = n[123].length > Je && Da(n);
    return {
      c: function c() {
        for (var _a9 = 0; _a9 < r.length; _a9 += 1) r[_a9].c();
        e = G(), l && l.c(), t = Le();
      },
      m: function m(a, s) {
        for (var o = 0; o < r.length; o += 1) r[o].m(a, s);
        p(a, e, s), l && l.m(a, s), p(a, t, s);
      },
      p: function p(a, s) {
        if (s[0] & 144 | s[1] & 128) {
          i = a[123].slice(0, Je);
          var o;
          for (o = 0; o < i.length; o += 1) {
            var c = Ur(a, i, o);
            r[o] ? r[o].p(c, s) : (r[o] = Ma(c), r[o].c(), r[o].m(e.parentNode, e));
          }
          for (; o < r.length; o += 1) r[o].d(1);
          r.length = i.length;
        }
        a[123].length > Je ? l ? l.p(a, s) : (l = Da(a), l.c(), l.m(t.parentNode, t)) : l && (l.d(1), l = null);
      },
      d: function d(a) {
        kt(r, a), a && m(e), l && l.d(a), a && m(t);
      }
    };
  }
  function Uc(n) {
    var e;
    return {
      c: function c() {
        e = x("bcc:");
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function Hc(n) {
    var e;
    return {
      c: function c() {
        e = x("cc:");
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function zc(n) {
    var e = "to ".concat(n[4].you && n[124].email === n[4].you.email_address ? "Me" : ""),
      t;
    return {
      c: function c() {
        t = x(e);
      },
      m: function m(i, r) {
        p(i, t, r);
      },
      p: function p(i, r) {
        r[0] & 144 && e !== (e = "to ".concat(i[4].you && i[124].email === i[4].you.email_address ? "Me" : "")) && me(t, e);
      },
      d: function d(i) {
        i && m(t);
      }
    };
  }
  function Bc(n) {
    var e = n[124].email + "",
      t;
    return {
      c: function c() {
        t = x(e);
      },
      m: function m(i, r) {
        p(i, t, r);
      },
      p: function p(i, r) {
        r[0] & 128 && e !== (e = i[124].email + "") && me(t, e);
      },
      d: function d(i) {
        i && m(t);
      }
    };
  }
  function Gc(n) {
    var s;
    var e = ((s = n[124].name) != null ? s : n[4].you.name) + "",
      t,
      i,
      r = n[124].email + "",
      l,
      a;
    return {
      c: function c() {
        t = x(e), i = x(" <"), l = x(r), a = x(">");
      },
      m: function m(o, c) {
        p(o, t, c), p(o, i, c), p(o, l, c), p(o, a, c);
      },
      p: function p(o, c) {
        var f;
        c[0] & 144 && e !== (e = ((f = o[124].name) != null ? f : o[4].you.name) + "") && me(t, e), c[0] & 128 && r !== (r = o[124].email + "") && me(l, r);
      },
      d: function d(o) {
        o && m(t), o && m(i), o && m(l), o && m(a);
      }
    };
  }
  function Ma(n) {
    var e, t, i;
    function r(f, g) {
      if (f[126] === 0) return zc;
      if (f[124]._type === "cc" && f[126] === f[120].to.length) return Hc;
      if (f[124]._type === "bcc" && f[126] === f[120].to.length + f[120].cc.length) return Uc;
    }
    var l = r(n),
      a = l && l(n);
    function s(f, g) {
      if (f[124].email && f[124].name) return Gc;
      if (f[124].email && !f[124].name) return Bc;
    }
    var o = s(n),
      _c15 = o && o(n);
    return {
      c: function c() {
        e = b("p"), t = x("Draft\n                                "), a && a.c(), i = G(), _c15 && _c15.c();
      },
      m: function m(f, g) {
        p(f, e, g), w(e, t), a && a.m(e, null), w(e, i), _c15 && _c15.m(e, null);
      },
      p: function p(f, g) {
        l === (l = r(f)) && a ? a.p(f, g) : (a && a.d(1), a = l && l(f), a && (a.c(), a.m(e, i))), o === (o = s(f)) && _c15 ? _c15.p(f, g) : (_c15 && _c15.d(1), _c15 = o && o(f), _c15 && (_c15.c(), _c15.m(e, null)));
      },
      d: function d(f) {
        f && m(e), a && a.d(), _c15 && _c15.d();
      }
    };
  }
  function Da(n) {
    var e, t, i, r, l, a, s;
    return {
      c: function c() {
        e = b("div"), t = b("nylas-tooltip"), U(t, "id", i = "show-more-participants-".concat(n[120].id)), U(t, "current_tooltip_id", n[13]), U(t, "icon", ln), U(t, "text", r = "And ".concat(n[123].length - Je, " more")), U(t, "content", l = "".concat(sn(n[123])));
      },
      m: function m(o, c) {
        p(o, e, c), w(e, t), a || (s = ge(t, "toggleTooltip", n[34]), a = !0);
      },
      p: function p(o, c) {
        c[0] & 128 && i !== (i = "show-more-participants-".concat(o[120].id)) && U(t, "id", i), c[0] & 8192 && U(t, "current_tooltip_id", o[13]), c[0] & 128 && r !== (r = "And ".concat(o[123].length - Je, " more")) && U(t, "text", r), c[0] & 128 && l !== (l = "".concat(sn(o[123]))) && U(t, "content", l);
      },
      d: function d(o) {
        o && m(e), a = !1, s();
      }
    };
  }
  function Vc(n) {
    return {
      c: T,
      m: T,
      p: T,
      d: T
    };
  }
  function Pa(n) {
    var e,
      t,
      i,
      r = Ft(new Date(n[120].date * 1e3)) + "",
      l;
    return {
      c: function c() {
        e = b("div"), t = b("span"), i = x("Saved at: "), l = x(r), d(e, "class", "message-date");
      },
      m: function m(a, s) {
        p(a, e, s), w(e, t), w(t, i), w(t, l);
      },
      p: function p(a, s) {
        s[0] & 128 && r !== (r = Ft(new Date(a[120].date * 1e3)) + "") && me(l, r);
      },
      d: function d(a) {
        a && m(e);
      }
    };
  }
  function Ra(n) {
    var Y;
    var e,
      t,
      i,
      r,
      l,
      a,
      s,
      o,
      _c16,
      f = n[120].snippet + "",
      g,
      y,
      S = n[122],
      k,
      L,
      j,
      E = n[4].show_contact_avatar && Na(),
      O = ((Y = n[120]) == null ? void 0 : Y.to) && La(n),
      B = n[4].show_received_timestamp && Pa(n);
    var ae = function ae() {
        return n[88](e, S);
      },
      V = function V() {
        return n[88](null, S);
      };
    function Q() {
      var _n10;
      for (var _len11 = arguments.length, A = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        A[_key11] = arguments[_key11];
      }
      return (_n10 = n)[89].apply(_n10, [n[120]].concat(A));
    }
    function z() {
      var _n11;
      for (var _len12 = arguments.length, A = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        A[_key12] = arguments[_key12];
      }
      return (_n11 = n)[90].apply(_n11, [n[120]].concat(A));
    }
    return {
      c: function c() {
        e = b("div"), t = b("div"), i = b("div"), E && E.c(), r = G(), l = b("div"), O && O.c(), a = G(), s = b("section"), B && B.c(), o = G(), _c16 = b("div"), g = x(f), y = G(), d(l, "class", "draft-to"), d(i, "class", "avatar-info"), d(t, "class", "message-head draft"), d(_c16, "class", "snippet"), d(e, "tabindex", "0"), d(e, "class", "individual-message condensed draft-message"), Ae(e, "active-draft", n[120].active);
      },
      m: function m(A, W) {
        p(A, e, W), w(e, t), w(t, i), E && E.m(i, null), w(i, r), w(i, l), O && O.m(l, null), w(t, a), w(t, s), B && B.m(s, null), w(e, o), w(e, _c16), w(_c16, g), w(e, y), ae(), k = !0, L || (j = [ge(e, "click", Xe(Q)), ge(e, "keypress", z)], L = !0);
      },
      p: function p(A, W) {
        var Oe;
        n = A, n[4].show_contact_avatar ? E ? W[0] & 16 && C(E, 1) : (E = Na(), E.c(), C(E, 1), E.m(i, r)) : E && (Ee(), F(E, 1, 1, function () {
          E = null;
        }), Te()), ((Oe = n[120]) == null ? void 0 : Oe.to) ? O ? O.p(n, W) : (O = La(n), O.c(), O.m(l, null)) : O && (O.d(1), O = null), n[4].show_received_timestamp ? B ? B.p(n, W) : (B = Pa(n), B.c(), B.m(s, null)) : B && (B.d(1), B = null), (!k || W[0] & 128) && f !== (f = n[120].snippet + "") && me(g, f), S !== n[122] && (V(), S = n[122], ae()), W[0] & 128 && Ae(e, "active-draft", n[120].active);
      },
      i: function i(A) {
        k || (C(E), k = !0);
      },
      o: function o(A) {
        F(E), k = !1;
      },
      d: function d(A) {
        A && m(e), E && E.d(), O && O.d(), B && B.d(), V(), L = !1, ot(j);
      }
    };
  }
  function Wc(n) {
    var e;
    return {
      c: function c() {
        e = x("Loading...");
      },
      m: function m(t, i) {
        p(t, e, i);
      },
      p: T,
      i: T,
      o: T,
      d: function d(t) {
        t && m(e);
      }
    };
  }
  function Jc(n) {
    var e,
      t,
      i,
      r,
      l,
      a,
      s,
      o,
      c,
      f = n[16] && Gr(n);
    var g = [Gs, Bs],
      y = [];
    function S(k, L) {
      return k[4].thread || k[4].thread_id ? 0 : k[4].message ? 1 : -1;
    }
    return ~(l = S(n)) && (a = y[l] = g[l](n)), {
      c: function c() {
        e = b("nylas-error"), t = G(), f && f.c(), i = G(), r = b("main"), a && a.c(), this.c = T, U(e, "id", n[0]), d(r, "class", "nylas-email"), d(r, "data-cy", "nylas-email"), d(r, "tabindex", "0");
      },
      m: function m(k, L) {
        p(k, e, L), p(k, t, L), f && f.m(k, L), p(k, i, L), p(k, r, L), ~l && y[l].m(r, null), n[95](r), s = !0, o || (c = [ge(r, "click", n[22]), ge(r, "keypress", n[24])], o = !0);
      },
      p: function p(k, L) {
        (!s || L[0] & 1) && U(e, "id", k[0]), k[16] ? f ? f.p(k, L) : (f = Gr(k), f.c(), f.m(i.parentNode, i)) : f && (f.d(1), f = null);
        var j = l;
        l = S(k), l === j ? ~l && y[l].p(k, L) : (a && (Ee(), F(y[j], 1, 1, function () {
          y[j] = null;
        }), Te()), ~l ? (a = y[l], a ? a.p(k, L) : (a = y[l] = g[l](k), a.c()), C(a, 1), a.m(r, null)) : a = null);
      },
      i: function i(k) {
        s || (C(a), s = !0);
      },
      o: function o(k) {
        F(a), s = !1;
      },
      d: function d(k) {
        k && m(e), k && m(t), f && f.d(k), k && m(i), k && m(r), ~l && y[l].d(), n[95](null), o = !1, ot(c);
      }
    };
  }
  var Je = 3,
    Ia = 2,
    ja = 1,
    xc = 20;
  function Fa(n) {
    n.stopImmediatePropagation();
  }
  function Ft(n) {
    return n.toLocaleDateString("en-US", {
      weekday: "short",
      month: "long",
      day: "numeric"
    }) + ", " + n.toLocaleTimeString("en-US", {
      hour12: !0,
      hour: "numeric",
      minute: "2-digit"
    });
  }
  function Bn(n, e) {
    var t, i;
    return n && e && n.length > 1 && e.length >= 2 && ((t = n[0]) === null || t === void 0 ? void 0 : t.from.length) && e[0].email !== ((i = n[n.length - 1]) === null || i === void 0 ? void 0 : i.from[0].email);
  }
  function Ua(n) {
    var e;
    return n && ((e = n.drafts) === null || e === void 0 ? void 0 : e.length) > 0;
  }
  function sn(n) {
    return n.reduce(function (e, t, i) {
      var r = t.name && t.name !== t.email ? "".concat(t.name, " <").concat(t.email, ">") : t.email;
      return i === 0 ? e += "to: ".concat(r, ",\n") : t._type === "cc" && !e.includes("cc:") ? e += "cc: ".concat(r, ",\n") : t._type === "bcc" && !e.includes("bcc:") ? e += "bcc: ".concat(r, ",\n") : e += "".concat(r, ",\n"), e;
    }, "");
  }
  function Zc(n, e, t) {
    var i, r, l, a, s, o, c;
    hn(n, si, function (u) {
      return t(101, a = u);
    }), hn(n, so, function (u) {
      return t(76, s = u);
    }), hn(n, fo, function (u) {
      return t(102, o = u);
    }), hn(n, oi, function (u) {
      return t(77, c = u);
    });
    var f = this && this.__awaiter || function (u, v, I, X) {
        function De(we) {
          return we instanceof I ? we : new I(function (je) {
            je(we);
          });
        }
        return new (I || (I = Promise))(function (we, je) {
          function vt(Ze) {
            try {
              Dt(X.next(Ze));
            } catch (Ot) {
              je(Ot);
            }
          }
          function Wt(Ze) {
            try {
              Dt(X.throw(Ze));
            } catch (Ot) {
              je(Ot);
            }
          }
          function Dt(Ze) {
            Ze.done ? we(Ze.value) : De(Ze.value).then(vt, Wt);
          }
          Dt((X = X.apply(u, v || [])).next());
        });
      },
      g,
      y,
      S,
      k,
      L,
      j,
      E,
      O,
      B,
      ae,
      V;
    var Q = di(tn());
    var _e3 = e,
      _e3$id = _e3.id,
      z = _e3$id === void 0 ? "" : _e3$id,
      _e4 = e,
      _e4$access_token = _e4.access_token,
      Y = _e4$access_token === void 0 ? "" : _e4$access_token,
      _e5 = e,
      A = _e5.clean_conversation,
      _e6 = e,
      _e6$click_action = _e6.click_action,
      W = _e6$click_action === void 0 ? "default" : _e6$click_action,
      _e7 = e,
      Oe = _e7.message_id,
      _e8 = e,
      _e = _e8.message,
      _e9 = e,
      se = _e9.show_contact_avatar,
      _e10 = e,
      re = _e10.show_expanded_email_view_onload,
      _e11 = e,
      J = _e11.show_number_of_messages,
      _e12 = e,
      q = _e12.show_received_timestamp,
      _e13 = e,
      de = _e13.show_star,
      _e14 = e,
      ee = _e14.show_thread_actions,
      _e15 = e,
      Z = _e15.theme,
      _e16 = e,
      he = _e16.thread_id,
      _e17 = e,
      le = _e17.thread,
      _e18 = e,
      ke = _e18.you,
      _e19 = e,
      D = _e19.show_reply,
      _e20 = e,
      ce = _e20.show_reply_all,
      _e21 = e,
      xe = _e21.show_forward;
    var P = {
      clean_conversation: !1,
      click_action: "default",
      message_id: "",
      show_contact_avatar: !0,
      show_expanded_email_view_onload: !1,
      show_number_of_messages: !0,
      show_received_timestamp: !0,
      show_star: !1,
      show_thread_actions: !1,
      theme: "auto",
      thread_id: "",
      you: {},
      show_reply: !1,
      show_reply_all: !1,
      show_forward: !1
    };
    var oe = {},
      N = ui({}, {}, P),
      pt,
      ct = !1,
      it = !1,
      $e = !1;
    Ci(function () {
      return f(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var u, v, I, X;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return ol();
            case 2:
              t(66, it = !0);
              _context30.t0 = t;
              _context30.next = 6;
              return o[JSON.stringify({
                component_id: z,
                access_token: Y
              })];
            case 6:
              _context30.t1 = _context30.sent;
              if (_context30.t1) {
                _context30.next = 9;
                break;
              }
              _context30.t1 = {};
            case 9:
              _context30.t2 = oe = _context30.t1;
              (0, _context30.t0)(65, _context30.t2);
              t(67, $e = !0);
              t(4, N = ui(e, oe, P));
              be();
              if (!(z && !((u = N.you) === null || u === void 0 ? void 0 : u.id) && !Ne)) {
                _context30.next = 37;
                break;
              }
              _context30.t3 = t;
              _context30.next = 18;
              return Fl({
                component_id: ft.component_id,
                access_token: Y
              });
            case 18:
              _context30.t4 = N.you = _context30.sent;
              _context30.t5 = N;
              (0, _context30.t3)(4, _context30.t4, _context30.t5);
              X = {
                component_id: z,
                access_token: Y
              };
              if (!(((v = N.you) === null || v === void 0 ? void 0 : v.organization_unit) === zn.Label)) {
                _context30.next = 30;
                break;
              }
              _context30.t6 = t;
              _context30.next = 26;
              return hs.getLabels(X);
            case 26:
              _context30.t7 = Et = _context30.sent;
              (0, _context30.t6)(70, _context30.t7);
              _context30.next = 37;
              break;
            case 30:
              _context30.t8 = ((I = N.you) === null || I === void 0 ? void 0 : I.organization_unit) === zn.Folder;
              if (!_context30.t8) {
                _context30.next = 37;
                break;
              }
              _context30.t9 = t;
              _context30.next = 35;
              return ks.getFolders(X);
            case 35:
              _context30.t10 = Tt = _context30.sent;
              (0, _context30.t9)(71, _context30.t10);
            case 37:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }));
    });
    var Ce = e;
    function be() {
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var u;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              u = Ce.thread_id;
              t(68, Ce = e);
              t(4, N.thread_id = !le && !Oe && !_e ? N.thread_id || oe.thread_id : "", N);
              z && !N.thread_id && !N.thread && N.message_id && Tn();
              _context31.t0 = !h || u !== N.thread_id;
              if (!_context31.t0) {
                _context31.next = 8;
                break;
              }
              _context31.next = 8;
              return pe();
            case 8:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      }));
    }
    var qe = {},
      Zt = {},
      Ct = !1;
    function Yt(u) {
      var v;
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var I, X, _iterator16, _step16, De, we;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              I = ((v = u.messages) === null || v === void 0 ? void 0 : v.reduce(function (De, we) {
                var je = we.from[0];
                return De[je.email] = je, De;
              }, {})) || {}, X = Array.from(Object.values(I)) || [];
              _iterator16 = _createForOfIteratorHelper(X);
              _context32.prev = 2;
              _iterator16.s();
            case 4:
              if ((_step16 = _iterator16.n()).done) {
                _context32.next = 17;
                break;
              }
              De = _step16.value;
              we = De.email;
              _context32.t0 = !qe[we] && we;
              if (!_context32.t0) {
                _context32.next = 15;
                break;
              }
              _context32.t1 = t;
              _context32.next = 12;
              return dt(De);
            case 12:
              _context32.t2 = qe[we] = _context32.sent;
              _context32.t3 = qe;
              (0, _context32.t1)(5, _context32.t2, _context32.t3);
            case 15:
              _context32.next = 4;
              break;
            case 17:
              _context32.next = 22;
              break;
            case 19:
              _context32.prev = 19;
              _context32.t4 = _context32["catch"](2);
              _iterator16.e(_context32.t4);
            case 22:
              _context32.prev = 22;
              _iterator16.f();
              return _context32.finish(22);
            case 25:
            case "end":
              return _context32.stop();
          }
        }, _callee32, null, [[2, 19, 22, 25]]);
      }));
    }
    var Ut,
      wt = [],
      Et = [],
      Tt = [],
      yn = [],
      ft,
      R,
      h,
      $;
    function pe() {
      var u, v;
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var I, X;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (!(z && N.thread_id)) {
                _context33.next = 11;
                break;
              }
              $ = Dl({
                component_id: z,
                thread_id: N.thread_id,
                access_token: Y
              }).catch(It);
              _context33.next = 4;
              return $;
            case 4:
              I = _context33.sent;
              if (!($ = null, ((u = I == null ? void 0 : I.messages) === null || u === void 0 ? void 0 : u.length) > 0)) {
                _context33.next = 10;
                break;
              }
              X = I.messages.length - 1;
              _context33.next = 9;
              return yt(I.messages[X].id);
            case 9:
              I.messages[X] = _context33.sent;
            case 10:
              I && (I.expanded = (v = h == null ? void 0 : h.expanded) !== null && v !== void 0 ? v : N.show_expanded_email_view_onload, t(7, h = I), Q("threadLoaded", I));
            case 11:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }));
    }
    var Ne;
    function gt() {
      h ? Bi({
        access_token: Y,
        component_id: z,
        message_id: h.messages.slice(-xc).map(function (u) {
          return u.id;
        })
      }).then(function (u) {
        u.forEach(function (v) {
          var I = h.messages.find(function (X) {
            return X.id === v.id;
          });
          I && (I.conversation = v.conversation);
        }), t(7, h), t(4, N), t(76, s), t(73, R), t(59, j), t(3, le), t(60, E), t(61, O), t(66, it), t(67, $e), t(103, f), t(68, Ce), t(119, e), t(65, oe), t(72, ft), t(39, Y), t(0, z);
      }) : N.message && Bi({
        component_id: z,
        message_id: [N.message.id]
      }).then(function (u) {
        u.forEach(function (v) {
          N.message && t(4, N.message.conversation = v.conversation, N);
        }), t(7, h), t(4, N), t(76, s), t(73, R), t(59, j), t(3, le), t(60, E), t(61, O), t(66, it), t(67, $e), t(103, f), t(68, Ce), t(119, e), t(65, oe), t(72, ft), t(39, Y), t(0, z);
      });
    }
    var et;
    function dt(u) {
      var v;
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var I;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              if (!(t(12, et.query = "?email=".concat(u.email), et), z)) {
                _context34.next = 10;
                break;
              }
              I = a[JSON.stringify(et)];
              _context34.t0 = I;
              if (_context34.t0) {
                _context34.next = 7;
                break;
              }
              _context34.next = 6;
              return si.addContact(et);
            case 6:
              I = _context34.sent;
            case 7:
              return _context34.abrupt("return", (v = I[0]) !== null && v !== void 0 ? v : u);
            case 10:
              return _context34.abrupt("return", u);
            case 11:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }));
    }
    function At() {
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.t0 = h && ft.component_id && N.thread_id;
              if (!_context35.t0) {
                _context35.next = 4;
                break;
              }
              _context35.next = 4;
              return zi(ft, h).catch(It);
            case 4:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }));
    }
    var Nt = !1;
    function Gn(u) {
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var v, _h, I, X;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              if (!Nt) {
                _context36.next = 2;
                break;
              }
              return _context36.abrupt("return");
            case 2:
              v = Cn(h);
              if (h[v].length <= 0) {
                _context36.next = 25;
                break;
              }
              if (!(Nt = !0, N.click_action === "default" || N.click_action === "mailbox")) {
                _context36.next = 23;
                break;
              }
              _context36.t0 = h && N.click_action === "default";
              if (!_context36.t0) {
                _context36.next = 13;
                break;
              }
              _context36.t1 = h.unread;
              if (!_context36.t1) {
                _context36.next = 12;
                break;
              }
              t(7, h.unread = !h.unread, h);
              _context36.next = 12;
              return At();
            case 12:
              t(7, h.expanded = !h.expanded, h);
            case 13:
              if (!(!Ne && v !== jt.DRAFTS)) {
                _context36.next = 21;
                break;
              }
              _h = h, I = _h.messages, X = I.length - 1;
              I[X].expanded = !I[X].expanded;
              _context36.t2 = I[X].body;
              if (_context36.t2) {
                _context36.next = 21;
                break;
              }
              _context36.next = 20;
              return yt(I[X].id);
            case 20:
              I[X] = _context36.sent;
            case 21:
              _context36.next = 24;
              break;
            case 23:
              v !== jt.DRAFTS && !h.expanded && t(7, h.expanded = !h.expanded, h);
            case 24:
              Nt = !1, Q("threadClicked", {
                event: u,
                thread: h,
                messageType: v
              }), t(13, at = "");
            case 25:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
    }
    function _i(u) {
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              if (!h) {
                _context37.next = 6;
                break;
              }
              t(7, h = Object.assign(Object.assign({}, h), {
                unread: !h.unread
              }));
              _context37.next = 4;
              return At();
            case 4:
              Q("toggleThreadUnreadStatus", {
                event: u,
                thread: h
              });
              return _context37.abrupt("return");
            case 6:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }));
    }
    function Vn(u) {
      var v;
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var _this18 = this;
        var I;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              if (!(N.click_action !== "mailbox")) {
                _context39.next = 9;
                break;
              }
              if (!r) {
                _context39.next = 8;
                break;
              }
              I = ((v = h.labels) === null || v === void 0 ? void 0 : v.map(function (X) {
                return X.id;
              })) || [];
              t(7, h.label_ids = [].concat(_toConsumableArray(I), [r]), h);
              _context39.next = 6;
              return At();
            case 6:
              _context39.next = 9;
              break;
            case 8:
              l && (t(7, h.folder_id = l, h), ft.component_id && N.thread_id && h.messages.forEach(function (I, X) {
                return f(_this18, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
                  return _regeneratorRuntime().wrap(function _callee38$(_context38) {
                    while (1) switch (_context38.prev = _context38.next) {
                      case 0:
                        _context38.next = 2;
                        return Rl(ft.component_id, Object.assign(Object.assign({}, I), {
                          folder_id: l
                        }), Y);
                      case 2:
                      case "end":
                        return _context38.stop();
                    }
                  }, _callee38);
                }));
              }));
            case 9:
              Q("threadDeleted", {
                event: u,
                thread: h
              });
            case 10:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }));
    }
    function cn(u) {
      N.message && (!N.thread_id || !N.thread) || N.click_action === "mailbox" && h.expanded || (u.preventDefault(), Gn(u));
    }
    function fn(u) {
      Q("returnToMailbox", {
        event: u,
        thread: h
      });
    }
    function hi(u) {
      N.message && (!N.thread_id || !N.thread) || N.click_action === "mailbox" && h.expanded || (u.preventDefault(), u.code === "Enter" && Gn(u));
    }
    function pi(u) {
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              u.stopImmediatePropagation();
              _context40.t0 = h;
              if (!_context40.t0) {
                _context40.next = 6;
                break;
              }
              t(7, h = Object.assign(Object.assign({}, h), {
                starred: !h.starred
              }));
              _context40.next = 6;
              return At();
            case 6:
              Q("threadStarred", {
                event: u,
                thread: h
              });
            case 7:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      }));
    }
    function Xt(u, v, I) {
      var X, De;
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var we, je, _Oo, vt, Wt, Dt, Ze, Ot, qt, Pe;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              u.stopImmediatePropagation();
              we = {
                name: N.you.name,
                email: N.you.email_address
              }, je = [we], _Oo = Oo({
                myEmail: we.email,
                message: v,
                type: I
              }), vt = _Oo.to, Wt = _Oo.cc, Dt = ((X = v.subject) === null || X === void 0 ? void 0 : X.toLowerCase().startsWith("re:")) ? v.subject : "Re: ".concat(v.subject), Ze = {
                reply_to_message_id: v.id,
                from: je,
                to: vt,
                reply_to: je,
                cc: Wt,
                bcc: v.bcc,
                body: v.body,
                subject: Dt
              };
              _context41.t0 = I;
              _context41.next = _context41.t0 === "reply" ? 5 : _context41.t0 === "reply_all" ? 7 : 9;
              break;
            case 5:
              Ot = "replyClicked";
              return _context41.abrupt("break", 9);
            case 7:
              Ot = "replyAllClicked";
              return _context41.abrupt("break", 9);
            case 9:
              qt = (De = h == null ? void 0 : h.drafts) === null || De === void 0 ? void 0 : De.find(function (Pe) {
                return Pe.reply_to_message_id === v.id;
              });
              if (!qt) {
                _context41.next = 19;
                break;
              }
              if (!(!N.thread && qt.id)) {
                _context41.next = 16;
                break;
              }
              _context41.next = 14;
              return yt(qt.id);
            case 14:
              Pe = _context41.sent;
              qt.body = Pe.body, Ze.body = Pe.body;
            case 16:
              Q(Ot, {
                event: u,
                message: Object.assign({}, qt),
                thread: h,
                value: Ze
              });
              _context41.next = 20;
              break;
            case 19:
              Q(Ot, {
                event: u,
                message: Object.assign({}, v),
                thread: h,
                value: Ze
              });
            case 20:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }));
    }
    function Kt(u, v) {
      var I;
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var X, De, we, je;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              X = (I = h == null ? void 0 : h.drafts) === null || I === void 0 ? void 0 : I.find(function (je) {
                return je.reply_to_message_id === v.id;
              }), De = "Fwd: ".concat(v.subject), we = {
                reply_to_message_id: v.id,
                subject: De,
                body: v.body
              };
              if (!X) {
                _context42.next = 10;
                break;
              }
              if (!(!N.thread && X.id)) {
                _context42.next = 7;
                break;
              }
              _context42.next = 5;
              return yt(X.id);
            case 5:
              je = _context42.sent;
              X.body = je.body, we.body = je.body;
            case 7:
              Q("forwardClicked", {
                event: u,
                message: Object.assign({}, X),
                thread: h,
                value: we
              });
              _context42.next = 11;
              break;
            case 10:
              Q("forwardClicked", {
                event: u,
                message: Object.assign({}, v),
                thread: h,
                value: we
              });
            case 11:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      }));
    }
    function kn(u) {
      var v, I;
      return ((v = u == null ? void 0 : u.to) === null || v === void 0 ? void 0 : v.length) + ((I = u == null ? void 0 : u.cc) === null || I === void 0 ? void 0 : I.length) > 1 && !lr(N.you.email_address, u, "from");
    }
    function rt(u, v) {
      u.stopImmediatePropagation(), v === h.messages.length - 1 ? Fa(u) : (t(7, h.messages[v].expanded = !h.messages[v].expanded, h), Q("messageClicked", {
        event: u,
        message: h.messages[v],
        thread: h
      }), N.thread || yt(h.messages[v].id).then(function (I) {
        t(7, h.messages[v].body = I.body, h);
      }));
    }
    function En(u, v) {
      u.stopImmediatePropagation(), u.code === "Enter" && (v === h.messages.length - 1 ? Fa(u) : t(7, h.messages[v].expanded = !h.messages[v].expanded, h));
    }
    function yt(u) {
      var _this19 = this;
      return z ? Il(ft, u).then(function (v) {
        return f(_this19, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
          var I;
          return _regeneratorRuntime().wrap(function _callee43$(_context43) {
            while (1) switch (_context43.prev = _context43.next) {
              case 0:
                if (!fi.hasInlineFiles(v)) {
                  _context43.next = 5;
                  break;
                }
                _context43.next = 3;
                return Sn(v);
              case 3:
                I = _context43.sent;
                return _context43.abrupt("return", (Q("messageLoaded", I), I));
              case 5:
                return _context43.abrupt("return", (Q("messageLoaded", v), v));
              case 6:
              case "end":
                return _context43.stop();
            }
          }, _callee43);
        }));
      }) : new Promise(function () {
        return null;
      });
    }
    function Tn() {
      var _this20 = this;
      jl({
        access_token: Y,
        component_id: z,
        message_id: N.message_id
      }).then(function (u) {
        return f(_this20, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
          var v;
          return _regeneratorRuntime().wrap(function _callee44$(_context44) {
            while (1) switch (_context44.prev = _context44.next) {
              case 0:
                if (!(t(4, N.message = u, N), fi.hasInlineFiles(N.message))) {
                  _context44.next = 5;
                  break;
                }
                _context44.next = 3;
                return Sn(N.message);
              case 3:
                v = _context44.sent;
                t(4, N.message = v, N);
              case 5:
                Q("messageLoaded", N.message);
              case 6:
              case "end":
                return _context44.stop();
            }
          }, _callee44);
        }));
      });
    }
    function Wn(u, v) {
      u.stopImmediatePropagation(), xn(u, v);
    }
    function Jn(u, v) {
      u.stopImmediatePropagation(), u.code === "Enter" && xn(u, v);
    }
    function xn(u, v) {
      var I;
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        var X;
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              if (!v) {
                _context45.next = 7;
                break;
              }
              if (!(v.draft_id = v.id, (I = h == null ? void 0 : h.drafts) === null || I === void 0 || I.forEach(function (X) {
                return X.active = X.id === v.id;
              }), !N.thread && v.id)) {
                _context45.next = 6;
                break;
              }
              _context45.next = 4;
              return yt(v.id);
            case 4:
              X = _context45.sent;
              v.body = X.body;
            case 6:
              Q("draftClicked", {
                event: u,
                message: v,
                thread: h
              });
            case 7:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      }));
    }
    var gi = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    function Zn(u) {
      var v = new Date(new Date().setHours(0, 0, 0, 0)),
        I = new Date(v.getFullYear(), v.getMonth(), v.getDate() - 1, 0, 0, 0, 0),
        X = new Date(v.getFullYear(), v.getMonth(), v.getDate() - 6, 0, 0, 0, 0),
        De = new Date(v.getFullYear(), 0, 1);
      return u >= v ? u.toLocaleTimeString("en-US", {
        hour12: !0,
        hour: "numeric",
        minute: "2-digit"
      }) : u >= I ? "Yesterday" : u >= X ? gi[u.getDay()] : u >= De ? u.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric"
      }) : u.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    }
    var at = "";
    function An(u) {
      t(13, at = u.detail.tooltipID);
    }
    function On(u) {
      var v = [];
      var I = u.messages,
        X = u.drafts;
      for (var De = I.length - 1; De >= 0 && v.length != 2; De--) {
        var we = I[De].from;
        if (we && we.length > 0 && we) {
          var je = we[0].email === pt ? "Me" : we[0].name || we[0].email;
          v.includes(je) || v.push(je);
        }
      }
      return X.length && v.unshift("Draft"), v;
    }
    var Yn = !1,
      Xn = {};
    function vi() {
      var u;
      var v = Cn(h);
      t(15, Xn = (u = h[v]) === null || u === void 0 ? void 0 : u.reduce(function (I, X) {
        var _iterator17 = _createForOfIteratorHelper(X.files.entries()),
          _step17;
        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var _ref56 = _step17.value;
            var _ref57 = _slicedToArray(_ref56, 2);
            var De = _ref57[0];
            var we = _ref57[1];
            _r(we) && (I[X.id] || (I[X.id] = []), I[X.id] = [].concat(_toConsumableArray(I[X.id]), [X.files[De]]));
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
        return I;
      }, {}));
    }
    function Sn(u) {
      var v;
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        var I, _i28, _Object$values, X;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return fi.getFilesForMessage(u, {
                component_id: z,
                access_token: Y
              });
            case 2:
              I = _context46.sent;
              for (_i28 = 0, _Object$values = Object.values(I); _i28 < _Object$values.length; _i28++) {
                X = _Object$values[_i28];
                u.body && (u.body = (v = u.body) === null || v === void 0 ? void 0 : v.replaceAll("src=\"cid:".concat(X.content_id, "\""), "src=\"data:".concat(X.content_type, ";base64,").concat(X.data, "\"")));
              }
              return _context46.abrupt("return", u);
            case 5:
            case "end":
              return _context46.stop();
          }
        }, _callee46);
      }));
    }
    function Qt(u, v) {
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        var I;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              if (!(u.stopImmediatePropagation(), z && (h && N.thread_id || N.message_id))) {
                _context47.next = 5;
                break;
              }
              _context47.next = 3;
              return er({
                file_id: v.id,
                component_id: z,
                access_token: Y
              });
            case 3:
              I = _context47.sent;
              bo(I, v);
            case 5:
              Q("downloadClicked", {
                event: u,
                thread: h,
                file: v
              });
            case 6:
            case "end":
              return _context47.stop();
          }
        }, _callee47);
      }));
    }
    function ze(u) {
      return f(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        var v;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              v = u.detail.file;
              Qt(u, v);
            case 2:
            case "end":
              return _context48.stop();
          }
        }, _callee48);
      }));
    }
    var Ht = null,
      Ue = !1;
    function Cn(u) {
      return u[jt.DRAFTS].length && !u[jt.MESSAGES].length ? jt.DRAFTS : jt.MESSAGES;
    }
    function Ie(_ref58) {
      var u = _ref58.to,
        v = _ref58.cc,
        I = _ref58.bcc;
      return Promise.resolve([].concat(_toConsumableArray(mi(u, {
        _type: "to"
      })), _toConsumableArray(mi(v, {
        _type: "cc"
      })), _toConsumableArray(mi(I, {
        _type: "bcc"
      }))));
    }
    var Lt;
    var Nn = function Nn() {
        return t(9, ct = !0);
      },
      Kn = function Kn() {
        return t(9, ct = !0);
      },
      Ln = function Ln(u) {
        return Vn(u);
      },
      Qn = function Qn(u, v) {
        return Xt(v, u, "reply");
      },
      zt = function zt(u, v) {
        return Xt(v, u, "reply_all");
      },
      Mt = function Mt(u, v) {
        return Kt(v, u);
      },
      Mn = function Mn(u, v) {
        return Q("fileClicked", {
          event: v,
          file: u
        });
      };
    function Dn(u, v) {
      wn[u ? "unshift" : "push"](function () {
        wt[v] = u, t(6, wt);
      });
    }
    var Bt = function Bt(u, v) {
        return rt(v, u);
      },
      dn = function dn(u, v) {
        return En(v, u);
      };
    function un(u, v) {
      wn[u ? "unshift" : "push"](function () {
        wt[v] = u, t(6, wt);
      });
    }
    var $n = function $n(u, v) {
        return Wn(v, u);
      },
      qn = function qn(u, v) {
        return Jn(v, u);
      },
      bi = function bi(u, v) {
        return Qt(v, u);
      },
      Pn = function Pn(u) {
        return Xt(u, N.message, "reply");
      },
      $t = function $t(u) {
        return Xt(u, N.message, "reply_all");
      },
      Gt = function Gt(u) {
        return Kt(u, _e);
      };
    function Vt(u) {
      wn[u ? "unshift" : "push"](function () {
        Ut = u, t(11, Ut);
      });
    }
    return n.$$set = function (u) {
      t(119, e = ue(ue({}, e), Se(u))), "id" in u && t(0, z = u.id), "access_token" in u && t(39, Y = u.access_token), "clean_conversation" in u && t(40, A = u.clean_conversation), "click_action" in u && t(1, W = u.click_action), "message_id" in u && t(41, Oe = u.message_id), "message" in u && t(2, _e = u.message), "show_contact_avatar" in u && t(42, se = u.show_contact_avatar), "show_expanded_email_view_onload" in u && t(43, re = u.show_expanded_email_view_onload), "show_number_of_messages" in u && t(44, J = u.show_number_of_messages), "show_received_timestamp" in u && t(45, q = u.show_received_timestamp), "show_star" in u && t(46, de = u.show_star), "show_thread_actions" in u && t(47, ee = u.show_thread_actions), "theme" in u && t(48, Z = u.theme), "thread_id" in u && t(49, he = u.thread_id), "thread" in u && t(3, le = u.thread), "you" in u && t(50, ke = u.you), "show_reply" in u && t(51, D = u.show_reply), "show_reply_all" in u && t(52, ce = u.show_reply_all), "show_forward" in u && t(53, xe = u.show_forward);
    }, n.$$.update = function () {
      if (n.$$.dirty[2] & 8 && Q("manifestLoaded", oe), n.$$.dirty[2] & 32768 && Object.keys(c).length && Q("onError", c), it && $e && function () {
        return f(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
          return _regeneratorRuntime().wrap(function _callee49$(_context49) {
            while (1) switch (_context49.prev = _context49.next) {
              case 0:
                _context49.t0 = JSON.stringify(Ce) !== JSON.stringify(e);
                if (!_context49.t0) {
                  _context49.next = 5;
                  break;
                }
                t(4, N = ui(e, oe, P));
                _context49.next = 5;
                return be();
              case 5:
              case "end":
                return _context49.stop();
            }
          }, _callee49);
        }));
      }(), n.$$.dirty[0] & 16 | n.$$.dirty[1] & 8388608 && t(8, pt = t(54, g = N.you) === null || g === void 0 ? void 0 : g.email_address), n.$$.dirty[0] & 17 | n.$$.dirty[1] & 256 && t(72, ft = {
        access_token: Y,
        component_id: z,
        thread_id: N.thread_id
      }), n.$$.dirty[2] & 1024 && t(73, R = JSON.stringify(ft)), n.$$.dirty[0] & 24 | n.$$.dirty[1] & 1879048192 | n.$$.dirty[2] & 18432 && N.thread && N.thread.id) {
        var u = t(60, E = t(59, j = s[R]) === null || j === void 0 ? void 0 : j.find(function (v) {
          return v && v.id === (le == null ? void 0 : le.id);
        })) !== null && E !== void 0 ? E : N.thread;
        if (N.show_expanded_email_view_onload) {
          u.expanded = N.show_expanded_email_view_onload;
          var v = u.messages[u.messages.length - 1];
          v.body = t(61, O = v.body) !== null && O !== void 0 ? O : v.snippet;
        }
        t(7, h = u);
      }
      n.$$.dirty[0] & 184 | n.$$.dirty[2] & 128 && function () {
        return f(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
          var _u;
          return _regeneratorRuntime().wrap(function _callee50$(_context50) {
            while (1) switch (_context50.prev = _context50.next) {
              case 0:
                if (!(Ct || !qe)) {
                  _context50.next = 19;
                  break;
                }
                if (!(t(69, Ct = !1), le && le.messages)) {
                  _context50.next = 6;
                  break;
                }
                _context50.next = 4;
                return Yt(le);
              case 4:
                _context50.next = 19;
                break;
              case 6:
                if (!h) {
                  _context50.next = 11;
                  break;
                }
                _context50.next = 9;
                return Yt(h);
              case 9:
                _context50.next = 19;
                break;
              case 11:
                if (!N.message) {
                  _context50.next = 19;
                  break;
                }
                _u = N.message.from[0];
                _context50.t0 = t;
                _context50.next = 16;
                return dt(_u);
              case 16:
                _context50.t1 = qe[_u.email] = _context50.sent;
                _context50.t2 = qe;
                (0, _context50.t0)(5, _context50.t1, _context50.t2);
              case 19:
              case "end":
                return _context50.stop();
            }
          }, _callee50);
        }));
      }(), n.$$.dirty[0] & 160 | n.$$.dirty[1] & 16777216 && t(10, Zt = h && qe ? qe[t(55, y = h.messages[h.messages.length - 1]) === null || y === void 0 ? void 0 : y.from[0].email] : {}), n.$$.dirty[0] & 48 | n.$$.dirty[1] & 33554432 && t(17, i = N.message && qe ? qe[t(56, S = N.message) === null || S === void 0 ? void 0 : S.from[0].email] : {}), n.$$.dirty[0] & 16 && (N.thread_id, t(69, Ct = !0)), n.$$.dirty[1] & 67108864 | n.$$.dirty[2] & 256 && (r = Et && Et.length ? t(57, k = Et.find(function (u) {
        return u.name === "trash";
      })) === null || k === void 0 ? void 0 : k.id : null), n.$$.dirty[1] & 134217728 | n.$$.dirty[2] & 512 && (l = Tt && Tt.length ? t(58, L = Tt.find(function (u) {
        return u.name === "trash";
      })) === null || L === void 0 ? void 0 : L.id : null), n.$$.dirty[0] & 128 && t(18, yn = h ? h.participants : []), n.$$.dirty[0] & 16 && (Ne = !!N.thread), n.$$.dirty[0] & 16 && N.clean_conversation && (N.thread_id || N.message_id) && gt(), n.$$.dirty[0] & 1 | n.$$.dirty[1] & 256 && t(12, et = {
        component_id: z,
        access_token: Y,
        query: ""
      }), n.$$.dirty[0] & 128 | n.$$.dirty[2] & 3 && t(14, Yn = !(t(62, B = h == null ? void 0 : h.messages) === null || B === void 0 ? void 0 : B.length) && !(t(63, ae = h == null ? void 0 : h.drafts) === null || ae === void 0 ? void 0 : ae.length)), n.$$.dirty[0] & 128 && h && vi(), n.$$.dirty[0] & 192 | n.$$.dirty[2] & 4 && t(74, Ht = wt[(t(64, V = h == null ? void 0 : h.messages) === null || V === void 0 ? void 0 : V.length) - 1]), n.$$.dirty[2] & 12288 && Ht && !Ue && Ht.offsetTop > window.innerHeight && (Ht.scrollIntoView({
        behavior: "smooth",
        block: "end"
      }), t(75, Ue = !0)), n.$$.dirty[0] & 16 && N.theme && (N.theme.startsWith(".") || N.theme.startsWith("http") ? t(16, Lt = N.theme) : N.theme && t(16, Lt = "https://unpkg.com/@nylas/components-email@".concat(zs.version, "/themes/").concat(N.theme, ".css")));
    }, e = Se(e), [z, W, _e, le, N, qe, wt, h, pt, ct, Zt, Ut, et, at, Yn, Xn, Lt, i, yn, Q, _i, Vn, cn, fn, hi, pi, Xt, Kt, kn, rt, En, Wn, Jn, Zn, An, On, Qt, ze, Ie, Y, A, Oe, se, re, J, q, de, ee, Z, he, ke, D, ce, xe, g, y, S, k, L, j, E, O, B, ae, V, oe, it, $e, Ce, Ct, Et, Tt, ft, R, Ht, Ue, s, c, Nn, Kn, Ln, Qn, zt, Mt, Mn, Dn, Bt, dn, un, $n, qn, bi, Pn, $t, Gt, Vt];
  }
  var Ha = /*#__PURE__*/function (_rn5) {
    function Ha(e) {
      var _this21;
      _classCallCheck(this, Ha);
      _this21 = _callSuper(this, Ha);
      _this21.shadowRoot.innerHTML = "<style>@charset \"UTF-8\";*{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;list-style:none}.sr-only{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}main{--black:#161717;--grey-dark:#636671;--grey:#bdc0cb;--grey-lighter:#dfe1e8;--grey-dark-warm:#9fa4b5;--grey-lightest:#f7f7f8;--grey-background:#f0f1f5;--white:#ffffff;--blue:#314fa9;--blue-lighter:#f0f3ff;--red:#ee3248;--red-lighter:#ffeef0;--fs-12:0.75rem;--fs-14:0.875rem;--fs-16:1rem;--black-90:#2c2e2e;--grey-light:#f7f7f8;--grey-warm:#cbcbcb}main{height:100%;width:100%;position:relative;display:grid;font-family:var(--nylas-email-font-family, -apple-system, BlinkMacSystemFont, sans-serif)}main .email-row{background:var(--nylas-email-background, var(--grey-lightest));border:1px solid var(--nylas-email-border-style, var(--grey-lighter))}main .email-row nylas-tooltip{position:relative}main .email-row .default-avatar{background:var(--nylas-default-avatar-background, var(--blue));border-radius:50%;color:var(--nylas-default-avatar-color, var(--white));font-family:sans-serif;font-size:1rem;font-weight:bold;height:32px;line-height:35px;text-align:center;text-transform:uppercase;width:32px}main .email-row .default-avatar.deleted{background:var(--red)}main .email-row .default-avatar.draft{background:var(--nylas-email-snippet-color, var(--grey-dark))}main .email-row header{font-size:1.2rem;font-weight:700;padding:0.5rem;padding-bottom:0}main .email-row div.starred{position:relative;display:flex;justify-content:center;align-items:center}main .email-row div.starred button{background-color:transparent;cursor:pointer}main .email-row div.starred button:before{content:\"\u2605\";display:inline-block;font-size:1.1em;color:var(--nylas-email-star-button-inactive-color, #8d94a5);-webkit-user-select:none;-moz-user-select:none;user-select:none}main .email-row div.starred button.starred:before{color:var(--nylas-email-star-button-active-color, #ffc107)}main .email-row div.starred button:hover:before{color:var(--nylas-email-star-button-hover-color, #ffc107)}main .email-row.expanded{background:var(--nylas-email-body-background, var(--white));padding:0;border:1px solid var(--nylas-email-border-style-expanded, var(--grey-lighter));border-radius:4px}main .email-row.expanded .email-loader{height:3rem;display:flex;align-items:center;justify-content:center}main .email-row.expanded .email-loader .spinner{height:18px;animation:rotate 2s linear infinite;margin-right:10px}@keyframes rotate{to{transform:rotate(360deg)}}main .email-row.expanded .subject-header{outline:1px solid var(--grey-lighter);display:flex;align-items:center;padding:24px 16px;gap:8px;border-radius:4px 4px 0 0;font-weight:bold;display:flex;justify-content:space-between;color:var(--nylas-email-subject-color, black);background:var(--nylas-email-header-background, white)}main .email-row.expanded .subject-header.mailbox{cursor:default}main .email-row.expanded .subject-header>div{display:flex;align-items:center;gap:1rem}main .email-row.expanded .subject-header>div button{display:flex;background:none;border:none;outline:0;width:32px;height:32px;border-radius:6px;justify-content:center;align-items:center;cursor:pointer}main .email-row.expanded .subject-header>div button:hover{background:var(--nylas-email-button-hover-background, var(--grey-lighter))}main .email-row.expanded .subject-header>div button *{width:1em;height:1em;fill:var(--nylas-email-subject-color, var(--grey-dark));stroke:var(--nylas-email-subject-color, var(--grey-dark))}main .email-row.expanded .subject-header [role=toolbar]{outline:none}main .email-row.expanded .subject-header [role=toolbar] button *{width:1em;height:1em}main .email-row.expanded [role=toolbar]{outline:1px solid var(--grey-lighter);display:flex;align-items:center;padding:24px 16px;gap:8px;padding:0.7rem 1rem;gap:1rem}main .email-row.expanded [role=toolbar] button{background:none;cursor:pointer;display:flex}main .email-row.expanded [role=toolbar] button *{width:1em;height:1em;stroke:var(--nylas-email-body-color, var(--grey-dark))}main .email-row.expanded .message-head [role=toolbar]{outline:none}main .email-row.expanded .message-head [role=toolbar] button{background:none;outline:none;cursor:pointer}main .email-row.expanded .icon-container,main .email-row.expanded .icon-container>*{pointer-events:none}main .email-row.expanded.expanded-mailbox-thread .message-from .name{font-weight:600}main .email-row.expanded div.individual-message{box-sizing:border-box;padding:0.5rem}main .email-row.expanded div.individual-message div.message-body{overflow:auto;display:inline-flex;flex-direction:column;width:100%;color:var(--nylas-email-body-color, black)}main .email-row.expanded div.individual-message div.message-body div.attachment{overflow-x:auto}main .email-row.expanded div.individual-message div.message-body div.attachment button{margin:0.5rem;height:fit-content;padding:0.3rem 1rem;border:1px solid var(--nylas-email-attachment-border-style, var(--grey));border-radius:30px;color:var(--nylas-email-attachment-button-color, inherit);background:var(--nylas-email-attachment-button-bg, white);cursor:pointer}main .email-row.expanded div.individual-message div.message-body div.attachment button:hover{background:var(--nylas-email-attachment-button-hover-bg, var(--grey-light))}main .email-row.expanded div.individual-message.condensed div.snippet{text-overflow:ellipsis;overflow:hidden;display:block;max-width:inherit;color:var(--nylas-email-snippet-color, var(--grey-dark));margin-top:0.5rem}main .email-row.expanded div.individual-message.condensed div.message-head .avatar-info{display:flex;align-items:center;gap:0.7rem}main .email-row.expanded div.individual-message.condensed div.message-head .avatar-info .draft-to{color:var(--nylas-email-snippet-color, var(--grey-dark))}main .email-row.expanded div.individual-message:not(:last-of-type){border-bottom:1px solid var(--nylas-email-border-style-expanded, var(--grey-lighter))}main .email-row.expanded div.individual-message:not(.last-message).expanded div.message-head:hover{cursor:n-resize}main .email-row.expanded div.individual-message.last-message .message-head:hover,main .email-row.expanded div.individual-message.last-message .message-body:hover{cursor:default}main .email-row.expanded div.individual-message.active-draft{border:1px solid var(--nylas-email-snippet-color, var(--grey-dark))}main .email-row.expanded div.individual-message div.message-head{display:flex;justify-content:space-between;align-items:baseline;gap:0.5rem}main .email-row.expanded div.individual-message div.message-date{display:flex;color:var(--nylas-email-message-date-color, var(--grey));font-size:12px}main .email-row.expanded div.individual-message div.message-from{display:flex;align-items:center;color:var(--nylas-email-message-from-color, black)}main .email-row.expanded div.individual-message div.message-from span.name{font-weight:600;margin-right:0.5rem}main .email-row.expanded.expanded div.message-head.draft{flex-flow:column}main .email-row.expanded.expanded div.message-head div.message-from-to{margin:0.5rem 0}main .email-row.expanded.expanded div.message-head div.message-from-to .avatar-info{display:flex;align-items:center;gap:0.7rem}main .email-row.expanded.expanded div.message-head div.message-from-to div.message-to{color:var(--nylas-email-message-to-color, var(--grey));max-width:150px;margin-left:calc(32px + 0.7rem)}main .email-row.expanded.expanded div.message-head div.message-from-to div.message-to div{display:grid;grid-template-columns:1fr 16px}main .email-row.expanded.expanded div.message-head div.message-from-to div.message-to div span{text-overflow:ellipsis;overflow:hidden}main .email-row.expanded.expanded.condensed{gap:1rem}main .email-row.expanded.expanded.condensed:hover,main .email-row.expanded.expanded.condensed:focus{cursor:s-resize;outline:none}main .email-row.expanded.expanded.condensed span.snippet{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--nylas-email-snippet-color, var(--grey-dark))}main .email-row:hover{cursor:pointer}main .email-row .from-message-count{align-items:center;display:grid;grid-template-columns:repeat(2, auto);grid-gap:1rem;justify-content:flex-start;max-width:350px;color:var(--nylas-email-participant-color, var(--grey-dark))}main .email-row .from-message-count .from-participants{display:grid;grid-template-columns:1fr fit-content(60px)}main .email-row .from-message-count .from-participants .participants-name{overflow:hidden;white-space:nowrap;position:relative;text-overflow:ellipsis;display:flex}main .email-row .from-message-count .from-participants .participants-name .from-sub-section.deleted-email{color:var(--nylas-email-snippet-color, var(--grey-dark))}main .email-row .from-message-count .from-participants .participants-name .from-sub-section.second{display:none}main .email-row .from-message-count .from-participants .participants-name .from-sub-section.participant-label{text-overflow:ellipsis;overflow:hidden}main .email-row .from-message-count .from-participants .participants-name .from-sub-section.draft-label{color:var(--nylas-email-draft-label-color, #dd4b39);overflow:visible}main .email-row .from-message-count .from-participants .participants-count .show-on-mobile{display:inline-block}main .email-row .from-message-count .from-participants .participants-count .show-on-desktop{display:none}main .email-row .subject-snippet-attachment{padding:0.5rem;padding-top:0.4rem;overflow:hidden}main .email-row .subject-snippet-attachment .subject-snippet{display:flex;flex-direction:column;gap:0.5rem;color:var(--nylas-email-snippet-color, var(--grey-dark))}main .email-row .subject-snippet-attachment .subject-snippet .subject{color:var(--nylas-email-subject-color, var(--black));white-space:nowrap;overflow:hidden;text-overflow:ellipsis}main .email-row .subject-snippet-attachment .subject-snippet .snippet{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}main .email-row .subject-snippet-attachment .subject-snippet .snippet.deleted{color:var(--nylas-email-snippet-color, var(--grey-dark))}main .email-row .subject-snippet-attachment .attachment{margin-top:0.5rem;gap:1rem;display:flex;overflow-x:auto}main .email-row .subject-snippet-attachment .attachment button{padding:0.3rem 1rem;border:1px solid var(--nylas-email-attachment-border-style, var(--grey));border-radius:30px;color:var(--nylas-email-attachment-button-color, inherit);background:var(--nylas-email-attachment-button-bg, white);cursor:pointer}main .email-row .subject-snippet-attachment .attachment button:hover{background:var(--nylas-email-attachment-button-hover-bg, var(--grey-light))}main .email-row .subject-snippet-attachment div{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--nylas-email-snippet-color, var(--grey-dark))}main .email-row .subject-snippet-attachment div span.subject{color:var(--nylas-email-subject-color, var(--black))}main .email-row .subject-snippet-attachment div.date{display:flex;justify-content:flex-end;gap:0.5rem;width:100%;font-size:14px;color:var(--nylas-email-message-date-color, var(--grey))}main .email-row .date{display:flex;justify-content:flex-end;align-items:center;width:100%;gap:1rem}main .email-row .date>:last-child{padding-right:1rem}main .email-row .date button,main .email-row .date span{background:none;cursor:pointer;display:flex}main .email-row .date button *,main .email-row .date span *{width:1em;height:1em;fill:var(--nylas-email-action-icons-color, var(--grey-dark))}main .email-row.condensed{height:fit-content;padding:0.5rem;flex-wrap:wrap;overflow:hidden;flex-wrap:wrap;display:grid;gap:0.5rem;align-items:flex-start;grid-template-areas:\"a a a a b c\" \"d d d d d d\"}main .email-row.condensed .from-star{grid-area:a}main .email-row.condensed .thread-message-count{grid-area:b}main .email-row.condensed .subject-snippet-attachment{grid-area:d}main .email-row.condensed .date{grid-area:c}@media(min-width: 640px){main .email-row.condensed{display:grid;column-gap:1rem;grid-template-areas:unset;grid-template-columns:minmax(250px, 18%) 6% auto 130px}main .email-row.condensed .from-star{grid-area:unset}main .email-row.condensed .thread-message-count{grid-area:unset;min-height:2rem;display:flex;align-items:center;justify-content:center}main .email-row.condensed .subject-snippet-attachment{grid-area:unset}main .email-row.condensed .date{grid-area:unset;min-height:2rem;display:flex;align-items:center}}main .email-row.condensed.disable-click{cursor:not-allowed;display:grid;align-items:flex-start;background:var(--grey-lighter)}main .email-row.condensed .from-star{display:grid;grid-template-columns:25px auto;column-gap:0.5rem}main .email-row.condensed .thread-message-count{color:var(--nylas-email-thread-message-count-color, var(--black));font-size:12px;text-align:left}main .email-row.condensed .date{text-align:right}main .email-row.condensed.unread{background:var(--nylas-email-unread-background, white)}main .email-row.condensed.unread .from-message-count,main .email-row.condensed.unread .date,main .email-row.condensed.unread .subject{font-weight:600;color:var(--nylas-email-unread-subject-color, var(--black))}main .email-row.condensed.unread .thread-message-count{color:var(--nylas-email-unread-thread-message-count-color, var(--blue))}main .email-row.expanded.singular:hover{box-shadow:none;cursor:default}main .email-row.expanded.singular div.individual-message:not(.last-message).expanded .message-head:hover,main .email-row.expanded.singular div.individual-message:not(.last-message).expanded .message-body:hover{cursor:default}@media(min-width: 640px){main .email-row .from-message-count{max-width:350px}main .email-row .from-message-count .from-participants .participants-name{overflow:hidden;white-space:nowrap;position:relative}main .email-row .from-message-count .from-participants .participants-name .from-sub-section.second{display:inline-block}main .email-row .from-message-count .from-participants .participants-count .show-on-mobile{display:none}main .email-row .from-message-count .from-participants .participants-count .show-on-desktop{display:inline-block}main .email-row.expanded.singular .individual-message.expanded{padding-top:0.5rem}main .email-row.condensed{padding:0.5rem;justify-content:initial}main .email-row.condensed div.starred button:hover:before{color:var(--nylas-email-star-button-hover-color, #ffc107)}main .email-row.condensed .date{text-align:right;padding-right:0.5rem;display:flex;justify-content:flex-end;gap:0.5rem;font-size:14px;color:var(--nylas-email-message-date-color, var(--grey))}main .email-row.condensed .thread-message-count{text-align:center}main .email-row.expanded{display:flex;flex-direction:column;box-sizing:border-box;width:100%;overflow-x:hidden}main .email-row.expanded header{padding:1rem 2.5rem}main .email-row.expanded div.individual-message{display:flex;flex-direction:column;align-items:center;padding:1rem 0;width:inherit}main .email-row.expanded div.individual-message div.message-head,main .email-row.expanded div.individual-message div.message-body{width:100%;box-sizing:border-box;padding:0 2.5rem}main .email-row.expanded div.individual-message div.message-body{display:flex;flex-direction:column}main .email-row.expanded div.individual-message.condensed div.snippet{width:100%;box-sizing:border-box;padding:0 2.5rem;white-space:pre-wrap;max-width:95vw;align-self:flex-start}main .email-row.expanded div.individual-message.condensed div.message-head.draft{flex-flow:row}main .email-row.expanded div.individual-message div.message-date{font-size:14px;align-self:center}main .email-row.expanded div.individual-message.expanded div.message-head div.message-from-to{margin:0.5rem 0}main .email-row.expanded div.individual-message.expanded div.message-head div.message-from-to div.message-to{max-width:inherit;overflow:inherit}main .email-row.expanded div.individual-message.expanded div.message-head div.message-from-to div.message-to div{display:grid;grid-template-columns:1fr 16px;align-items:center}main .email-row.expanded div.individual-message.expanded div.message-head div.message-from-to div.message-to div span{text-overflow:ellipsis;overflow:hidden}main .email-row .subject-snippet-attachment .subject-snippet{display:grid;grid-template-columns:auto 1fr;gap:1rem}}</style>", Ke(_this21, {
        target: _this21.shadowRoot,
        props: gn(_this21.attributes),
        customElement: !0
      }, Zc, Jc, Ye, {
        id: 0,
        access_token: 39,
        clean_conversation: 40,
        click_action: 1,
        message_id: 41,
        message: 2,
        show_contact_avatar: 42,
        show_expanded_email_view_onload: 43,
        show_number_of_messages: 44,
        show_received_timestamp: 45,
        show_star: 46,
        show_thread_actions: 47,
        theme: 48,
        thread_id: 49,
        thread: 3,
        you: 50,
        show_reply: 51,
        show_reply_all: 52,
        show_forward: 53
      }, null, [-1, -1, -1, -1, -1]), e && (e.target && p(e.target, _this21, e.anchor), e.props && (_this21.$set(e.props), fe()));
      return _this21;
    }
    _inherits(Ha, _rn5);
    return _createClass(Ha, [{
      key: "id",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(e) {
        this.$$set({
          id: e
        }), fe();
      }
    }, {
      key: "access_token",
      get: function get() {
        return this.$$.ctx[39];
      },
      set: function set(e) {
        this.$$set({
          access_token: e
        }), fe();
      }
    }, {
      key: "clean_conversation",
      get: function get() {
        return this.$$.ctx[40];
      },
      set: function set(e) {
        this.$$set({
          clean_conversation: e
        }), fe();
      }
    }, {
      key: "click_action",
      get: function get() {
        return this.$$.ctx[1];
      },
      set: function set(e) {
        this.$$set({
          click_action: e
        }), fe();
      }
    }, {
      key: "message_id",
      get: function get() {
        return this.$$.ctx[41];
      },
      set: function set(e) {
        this.$$set({
          message_id: e
        }), fe();
      }
    }, {
      key: "message",
      get: function get() {
        return this.$$.ctx[2];
      },
      set: function set(e) {
        this.$$set({
          message: e
        }), fe();
      }
    }, {
      key: "show_contact_avatar",
      get: function get() {
        return this.$$.ctx[42];
      },
      set: function set(e) {
        this.$$set({
          show_contact_avatar: e
        }), fe();
      }
    }, {
      key: "show_expanded_email_view_onload",
      get: function get() {
        return this.$$.ctx[43];
      },
      set: function set(e) {
        this.$$set({
          show_expanded_email_view_onload: e
        }), fe();
      }
    }, {
      key: "show_number_of_messages",
      get: function get() {
        return this.$$.ctx[44];
      },
      set: function set(e) {
        this.$$set({
          show_number_of_messages: e
        }), fe();
      }
    }, {
      key: "show_received_timestamp",
      get: function get() {
        return this.$$.ctx[45];
      },
      set: function set(e) {
        this.$$set({
          show_received_timestamp: e
        }), fe();
      }
    }, {
      key: "show_star",
      get: function get() {
        return this.$$.ctx[46];
      },
      set: function set(e) {
        this.$$set({
          show_star: e
        }), fe();
      }
    }, {
      key: "show_thread_actions",
      get: function get() {
        return this.$$.ctx[47];
      },
      set: function set(e) {
        this.$$set({
          show_thread_actions: e
        }), fe();
      }
    }, {
      key: "theme",
      get: function get() {
        return this.$$.ctx[48];
      },
      set: function set(e) {
        this.$$set({
          theme: e
        }), fe();
      }
    }, {
      key: "thread_id",
      get: function get() {
        return this.$$.ctx[49];
      },
      set: function set(e) {
        this.$$set({
          thread_id: e
        }), fe();
      }
    }, {
      key: "thread",
      get: function get() {
        return this.$$.ctx[3];
      },
      set: function set(e) {
        this.$$set({
          thread: e
        }), fe();
      }
    }, {
      key: "you",
      get: function get() {
        return this.$$.ctx[50];
      },
      set: function set(e) {
        this.$$set({
          you: e
        }), fe();
      }
    }, {
      key: "show_reply",
      get: function get() {
        return this.$$.ctx[51];
      },
      set: function set(e) {
        this.$$set({
          show_reply: e
        }), fe();
      }
    }, {
      key: "show_reply_all",
      get: function get() {
        return this.$$.ctx[52];
      },
      set: function set(e) {
        this.$$set({
          show_reply_all: e
        }), fe();
      }
    }, {
      key: "show_forward",
      get: function get() {
        return this.$$.ctx[53];
      },
      set: function set(e) {
        this.$$set({
          show_forward: e
        }), fe();
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["id", "access_token", "clean_conversation", "click_action", "message_id", "message", "show_contact_avatar", "show_expanded_email_view_onload", "show_number_of_messages", "show_received_timestamp", "show_star", "show_thread_actions", "theme", "thread_id", "thread", "you", "show_reply", "show_reply_all", "show_forward"];
      }
    }]);
  }(rn);
  return customElements.define("nylas-email", Ha), Ha;
});